import {
  Accordion,
  Card,
  Col,
  Container,
  Form,
  Row,
  Tabs,
  Tab,
  OverlayTrigger,
  Tooltip
} from "react-bootstrap";
import { InfoCircle } from 'react-bootstrap-icons';
import React, {
  useState,
  useEffect,
  useRef,
} from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import usePostData from "../../hooks/usePostData";
import { ApiResponse } from "./ApiResponse";
import { toast } from "react-toastify";
// @ts-ignore: allow importing CSS side-effect
import "react-toastify/dist/ReactToastify.css";
// @ts-ignore: allow importing CSS side-effect
import "./DashboardCS.css";
import AppDataTable from "../../component/AppDataTable/AppDataTable";
import {
  CaseReportFormRequest,
  ClientSearchResult,
  ClientSearchValidationRef,
  ClientUpdateRequest,
  DiagnosisDetail,
  DiseaseHistoryRow,
  HistoricalTestRow,
  SearchInfoRequest,
  SearchLabRequest,
  SearchTreatmentHistoryRequest,
  SelectOption,
} from "../../types";
import {
  ClientInfoValidationSchema,
  clientSearchCols,
  ClientSearchValidationSchema,
  NewCaseReportValidationSchema,
  UserDetails,
  SourceSelectOption,
  wildCardSearchValidationSchema,
  caseReportSchema,
} from "./Dashboard.types";
import usePost from "../../hooks/usePost";
import useGetData from "../../hooks/useGetData";
import { AppCard } from "../../component/AppCard";
import { AppLabel } from "../../component/AppLabel";
import AppButton from "../../component/AppButton/AppButton";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { RoleData } from "../UserManagement/CreateUser.types";
import formatPhoneNumber from "../../helpers/formatPhoneNumber";
import { adjustDateToMax, adjustDateToMin } from "../../helpers/dateHelper";
import Loader from "../../component/Loader/Loader";
import { useNavigate } from "react-router-dom";
import { NavItem } from './Dashboard.types';
import { DASHBOARD_SECTIONS } from './Dashboard.types';


const wildCardSearchTitle = `Use asterisk * as a wildcard to search for partial matches in First Name.
For example, searching for *Smith will return all profiles with a first name that ends with Smith.
Searching for Smith* will return all profiles with a first name that starts with Smith.
Searching for *Smith* will return all profiles with a first name that contains exactly Smith.
Note: There should be at least three characters required with the wildcard (*) search criteria.`;

const ExpandableRowsComponent: React.FC<{ data: any }> = ({ data }) => (
  <>
    <div className="pt-3 pb-3" style={{ paddingLeft: '5%', fontSize: '14px' }}><b>Address:</b>  {data.street}  {data.city}  {data.stateName}  {data.zipCode}</div>
  </>
);

const minDate: string = new Date('1850-01-01')?.toISOString()?.split('T')[0];

type SyphilisTreatmentHistoryRow = {
  source?: string | null;
  providerName?: string | null;
  resultType?: string | null;
  starsAddedDate?: string | null;
  screeningDate?: string | null;
  examDate?: string | null;
  treatedDate?: string | null;
  treatmentAdministeredName?: string | null;
  treatmentData?: string | null;
  treatmentHistoryRowNum?: number | null;
};

type StdTestInformationRow = {
  specimenDate?: string | null;
  specimenId?: string | null;
  details?: string | null;
  titer?: string | null;
  historyNumber?: number | null;
};

type StdTestInformationGroup = {
  testName: string;
  rows: StdTestInformationRow[];
};

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const userEmail = accounts[0] && accounts[0].username;
  const account = accounts[0];
  //const [authToken, setAuthToken] = useState<any>('');
  const isAuthenticated = useIsAuthenticated();

  const [isLoader, setIsLoader] = useState<boolean>(false);

  const [searchResults, setSearchResults] = useState<any>();
  const [source, setSource] = useState("All");
  const [firstName, setFirstName] = useState("");
  const [wildCardSearch, setWildCardSearch] = useState<boolean>(false);
  const [activeKey, setActiveKey] = useState<boolean>(false);
  const [newCaseKey, setNewCaseKey] = useState<boolean>(false);
  const [lastName, setLastName] = useState("");
  const [dob, setDob] = useState("");
  const [birthGender, setBirthGender] = useState("");
  const [maskedSSN, setMaskedSSN] = useState("");
  const [isEditingContactInfo, setIsEditingContactInfo] = useState(false);
  const [clientInfo, setClientInfo] = useState<ClientSearchResult>();
  const [clientDxInfo, setClientDxInfo] = useState<DiagnosisDetail>();
  const [historicalRPR, setHistoricalRPR] = useState<DiseaseHistoryRow[]>([]);
  const [historicalVDRL, setHistoricalVDRL] = useState<DiseaseHistoryRow[]>([]);
  const [historicalFTAABS, setHistoricalFTAABS] = useState<DiseaseHistoryRow[]>([]);
  const [historicalTPPA, setHistoricalTPPA] = useState<DiseaseHistoryRow[]>([]);
  const [historicalEIAIgG, setHistoricalEIAIgG] = useState<DiseaseHistoryRow[]>([]);
  const [historicalChlamydia, setHistoricalChlamydia] = useState<DiseaseHistoryRow[]>([]);
  const [historicalGonorrhea, setHistoricalGonorrhea] = useState<DiseaseHistoryRow[]>([]);
  const [syphilisTreatmentHistory, setSyphilisTreatmentHistory] = useState<SyphilisTreatmentHistoryRow[]>([]);



  const [selectedClient, setSelectedClient] = useState<ClientSearchResult>(null as any);
  const focusRef = useRef<HTMLDivElement>(null);

  const [showPatientInfo, setShowPatientInfo] = useState<boolean>(false);
  const columns = clientSearchCols(setSelectedClient, true, focusRef, showPatientInfo);

  const [isSearchTableVisible, setIsSearchTableVisible] = useState<boolean>(true);
  const [isTableVisible, setIsTableVisible] = useState<boolean>(true);
  const [isNavCollapsed, setIsNavCollapsed] = useState<boolean>(false);
  const [isNavCaseReportCollapsed, setIsNavCaseReportCollapsed] = useState<boolean>(false);
  const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);
  const navRightOffset = windowWidth <= 768 ? 0 : 20;
  const navWidth = windowWidth <= 768 ? Math.min(190, windowWidth - 42) : 190;
  const navToggleRightOffset = isNavCollapsed ? navRightOffset : navRightOffset + navWidth + 60;
  const navCaseReportToggleRightOffset = isNavCaseReportCollapsed ? navRightOffset : navRightOffset + navWidth + 60;

  const handleSearchToggle = () => {
    setIsSearchTableVisible(prev => !prev);
  };

  const handleToggle = () => {
    setIsTableVisible(prev => !prev);
  };

  const handleNavToggle = () => {
    setIsNavCollapsed(prev => !prev);
  };

  const handleNavCaseReportToggle = () => {
    setIsNavCaseReportCollapsed(prev => !prev);
  };

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const element = focusRef.current;

    if (element) {
      // 1. Instantly focus the container safely
      element.focus({ preventScroll: true });

      // 2. Perform the exact 50px offset calculation
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - 50;

      // 3. Scroll smoothly to the target
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  }, [focusRef.current]);

  //TODO - Need to get this through the API. Get User ID. This should happen when the app initialized and should be called once to be used across the application
  const [userId, setUserId] = useState("2"); // Hard coded for now.

  const [maxDate, setMaxDate] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [clientInfoErrorMessage, setClientInfoErrorMessage] = useState("");

  const { isProgress, postDataById } = usePostData<
    ApiResponse,
    SearchInfoRequest
  >("Search/Clients", "POST");

  const { postByObject } = usePost<ApiResponse, SearchLabRequest>(
    "Search/labs",
    "POST"
  );

  const { postByObject: postTreatmentHistory } = usePost<ApiResponse, SearchTreatmentHistoryRequest>(
    "Search/TreatmentHistory",
    "POST"
  );

  const { postByObject: postClientUpdate } = usePost<
    ApiResponse,
    ClientUpdateRequest
  >("Client/Update", "POST");

  const { getDataById: getRelationshipTypes } = useGetData<any, string>(
    "Client/Relationships",
    "GET"
  );

  const { getDataById: getTests } = useGetData<any, string>(
    "Client/Tests",
    "GET"
  );

  const { getDataById: getResults } = useGetData<any, string>(
    "Client/Results",
    "GET"
  );

  const { getDataById: getStatusTypes } = useGetData<any, string>(
    "Client/StatusTypes",
    "GET"
  );

  const convertToISODate = (dateStr: string | null) => {
    if (!dateStr) return "";
    const parts = dateStr.split("/");
    if (parts.length !== 3) return "";
    const [month, day, year] = parts;
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  };

const formatDisplayDate = (dateStr?: string | null) => {
  if (!dateStr) return "";
  return dateStr.includes("T") ? dateStr.split("T")[0] : convertToISODate(dateStr) || dateStr;
};

const formatStdTableDate = (dateStr?: string | null) => {
  if (!dateStr) return "";

  const datePart = dateStr.includes("T") ? dateStr.split("T")[0] : dateStr;
  const isoMatch = datePart.match(/^(\d{4})-(\d{2})-(\d{2})$/);

  if (isoMatch) {
    const [, year, month, day] = isoMatch;
    return `${month}/${day}/${year}`;
  }

  const slashMatch = datePart.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (slashMatch) {
    const [, month, day, year] = slashMatch;
    return `${month.padStart(2, "0")}/${day.padStart(2, "0")}/${year}`;
  }

  return dateStr;
};


  // Client Info Form Values
  const [clientInfoSourceClientId, setClientInfoSourceClientId] =
    useState<string>("");
  const [clientInfoSource, setClientInfoSource] = useState<string>("");
  const [clientInfoSourceId, setClientInfoSourceId] = useState<string>(""); //SourceID when fetched is EharsId/StarsId

  const [clientInfoFirstName, setClientInfoFirstName] = useState<string>("");
  const [clientData, setClient] = useState<any>();
  const [clientInfoMiddleName, setClientInfoMiddleName] = useState<string>("");
  const [clientInfoLastName, setClientInfoLastName] = useState<string>("");
  const [clientInfoBirthGender, setClientInfoBirthGender] =
    useState<string>("");
  const [clientInfoDob, setClientInfoDob] = useState<string>("");
  const [clientInfoLabDate, setClientInfoLabDate] = useState<string>("");

  const [clientInfoStreet, setClientInfoStreet1] = useState<string>("");
  const [clientInfoStreet2, setClientInfoStreet2] = useState<string>("");
  const [clientInfoCity, setClientInfoCity] = useState<string>("");
  const [clientInfoZip, setClientInfoZip] = useState<string>("");
  const [clientInfoPhone1, setClientInfoPhone1] = useState<string>("");
  const [clientInfoPhone2, setClientInfoPhone2] = useState<string>("");
  const [clientInfoErContactPerson, setClientInfoErContactPerson] =
    useState<string>("");
  const [
    clientInfoErContactPersonRelation,
    setClientInfoErContactPersonRelation,
  ] = useState<string>("");
  const [clientInfoErContactPersonPhone, setClientInfoErContactPersonPhone] =
    useState<string>("");

  const [clientInfoModeOfTransmission, setClientInfoModeOfTransmission] =
    useState<string>("");
  const [clientInfoHivDateOfDiagnosis, setClientInfoHivDateOfDiagnosis] =
    useState<string>("");
  const [clientInfoDateOfLastDocumented, setClientInfoDateOfLastDocumented] =
    useState<string>("");

  //UpDated HIV
  const [updatedLinkageToCareStatusForHivDiagnosis, setUpdatedLinkageToCareStatusForHivDiagnosis] = useState<string>("");
  const [updatedcaseReportCD4, setUpdatedCaseReportCD4] = useState<string>("");

  const [updatedClientInfoHivDateOfDiagnosis, setUpdatedClientInfoHivDateOfDiagnosis] = useState<string>("");
  const [updatedClientInfoViralLoad, setUpdatedClientInfoViralLoad] = useState<string>("");
  const [updatedClientInfoCD4Count, setUpdatedClientInfoCD4Count] = useState<string>("");
  const [updatedL2CName, setUpdatedL2CName] = useState<string>("");
  const [updatedLastUpdatedDate, setUpdatedLastUpdatedDate] = useState({
    lastViralLoad: "",
    lastCd4: "",
    dateOfDiagnosis: ""
  });

  const [clientInfoAidsDate, setClientInfoAidsDate] = useState<string>("");
  const [clientInfoHIVReportedDate, setClientInfoHIVReportedDate] = useState<string>("");
  const [clientInfoHIVModeOfTransmissionId, setClientInfoModeOfTransmissionId] = useState<string>("");

  const [UpdateClientInfoAidsDate, setUpdateClientInfoAidsDate] = useState<string>("");
  const [UpdateClientInfoHIVReportedDate, setUpdateClientInfoHIVReportedDate] = useState<string>("");
  const [UpdateClientInfoHIVModeOfTransmissionId, setUpdateClientInfoHIVModeOfTransmissionId] = useState<string>("");

  const [clientInfoViralLoad, setClientInfoViralLoad] = useState<string>("");
  const [clientInfoCD4Count, setClientInfoCD4Count] = useState<string>("");
  const [clientAdditionalNotes, setClientAdditionalNotes] = useState<string>("");
  const [clientDOHNotes, setClientDOHNotes] = useState<string>("");
  const [l2CName, setl2CName] = useState<string>("");
  const [clientInfoStateData, setClientInfoStateData] = useState<
    SelectOption[]
  >([]);

  const [rprTestInfo, setRprTestInfo] = useState({
    specimenDdate: '',
    details: '',
    titer: ''
  });
  const [vdrlTestInfo, setVdrlTestInfo] = useState({
    specimenDdate: '',
    details: '',
    titer: ''
  });
  const [tppaTestInfo, setTppaTestInfo] = useState({
    specimenDdate: '',
    details: ''
  });
  const [ftaAbsIinfo, setFtaAbsInfo] = useState({
    specimenDdate: '',
    details: ''
  });
  const [eiaIgGInfo, setEiaIgGInfo] = useState({
    specimenDate: '',
    details: ''
  });

  const handleScrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const top = element.getBoundingClientRect().top + window.scrollY - 70;
      window.scrollTo({
        top,
        behavior: 'smooth',
      });
    }
  };

  const handleNavItemClick = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    id: string
  ) => {
    e.preventDefault();

    switch (id) {
      case 'MedicalInformation':
        setIsMedicalInfoCollapsed(false);
        break;
      case 'TestingInformation':
        setIsTestingInfoCollapsed(false);
        break;
      case 'HIVDetails':
        setIsHivDetailsCollapsed(false);
        break;
      case 'HIVDetails':
        setIsHivDetailsCollapsed(false);
        break;
      case 'UpdatedHIVDetails':
        setIsUpdatedHivCollapsed(false);
        break;
      case 'SyphilisTreatmentInformation':
        setIsSyphilisTreatmentCollapsed(false);
        break;
      case 'STDTestInformation':
        setIsStdCollapsed(false);
        break;
      case 'UpdatedSTDTestInformation':
        setIsUpdatedStdCollapsed(false);
        break;
      default:
        break;
    }

    handleScrollToSection(id);
  };

  const navItems: NavItem[] = [
    { id: 'PatientIdentification', label: 'Patient Identification' },
    { id: 'PatientContactIdentification', label: 'Patient Contact Identification' },
    { id: 'EmergencyContactInformation', label: 'Emergency Contact Information' },
    { id: 'MedicalInformation', label: 'Medical Information' },
    { id: 'LinkageToCareStatus', label: 'Linkage to Care Status' },
    { id: 'TestingInformation', label: 'Testing Information' },

    ...(source !== "SYPHILIS"
      ? [{ id: 'HIVDetails', label: 'HIV Diagnosis Details' },
      { id: 'UpdatedHIVDetails', label: 'Updated HIV Diagnosis Details' }] : []),

    ...(source !== "HIV"
      ? [{ id: 'SyphilisTreatmentInformation', label: 'STD Treatment History' },
      { id: 'STDTestInformation', label: 'STD Test Information' },
      { id: 'UpdatedSTDTestInformation', label: 'Updated STD Test Information' }]
      : []),


    ...(clientInfoBirthGender?.toLowerCase() === 'female'
      ? [{ id: 'PregnancyInformation', label: 'Pregnancy Information' }]
      : []),
    { id: 'AdditionalNotes', label: 'Additional Notes' },
  ];

  const [isAdmin, setIsAdmin] = useState(false);
  const [isSTDProvider, setIsSTDProvider] = useState<boolean>(false);
  const [isHivProvider, setIsHivProvider] = useState(false);
  const [showStdTestInfo, setShowStdTestInfo] = useState(false);
  const [clientInfoRelationshipData, setClientInfoRelationshipData] = useState<SelectOption[]>([]);

  const [clientInfoTestData, setClientInfoTestData] = useState<SelectOption[]>([]);
  const [clientInfoResultData, setClientInfoResultData] = useState<SelectOption[]>([]);

  const [clientInfoStatusTypeData, setClientInfoStatusTypeData] = useState<SelectOption[]>([]);
  const [caseReportStatusTypeData, setCaseReportStatusTypeData] = useState<SelectOption[]>([]);

  const { getDataById: getStates } = useGetData<SelectOption[], string>(
    "Client/States",
    "GET"
  );

  const [allRoutinizedHospitalsData, setallRoutinizedHospitalsData] = useState<
    SelectOption[]
  >([]);

  const [filteredRoutinizedFacilities, setFilteredRoutinizedFacilities] =
    useState<any[]>([]);

  const { getDataById: getCaseReportSelectedRoutinizedHospital } = useGetData<
    SelectOption[],
    string
  >("Client/RoutinizedHospital", "GET");

  const [allLinkageCareStatusesData, setallLinkageCareStatusesData] = useState<
    SelectOption[]
  >([]);

  const [allModeoftransmissionData, setallModeoftransmissionData] = useState<
    SelectOption[]
  >([]);

  const { getDataById: getLinkageCareStatuses } = useGetData<
    RoleData[],
    string
  >("Client/LinkageCareStatuses", "GET");

  const { getDataById: getModeofTransmission } = useGetData<
    RoleData[],
    string
  >("Client/ModeOfTransmissions", "GET");

  const { getDataById: getRoutinizedHospitals } = useGetData<
    RoleData[],
    string
  >("Client/RoutinizedHospitals", "GET");
  const [clientInfoSelectedState, setClientInfoSelectedState] =
    useState<any>("0");

  const clientSearchRef = useRef<ClientSearchValidationRef>({ firstName: '', lastName: '' });

  const firstNameRequired = clientSearchRef.current.lastName.trim() === "";
  const lastNameRequired = clientSearchRef.current.firstName.trim() === "";

  const SOURCEDROPDOWN_OPTIONS: SourceSelectOption[] = [
    { value: "All", label: "All" },
    { value: "HIV", label: "HIV" },
    { value: "SYPHILIS", label: "SYPHILIS" }
  ];

  const getSourceOptionsByRoleName = (roleName: string | undefined, userDetails: any): SourceSelectOption[] => {
    if (userDetails?.roleName == 'HIV Provider' || userDetails?.roleName == "HIV Staff" ||
    userDetails?.roleName === "HIV Program Admin") {
      setSource("HIV");
      return SOURCEDROPDOWN_OPTIONS.filter(opt => ["HIV"].includes(opt.value));

    }
    if (userDetails?.roleName == 'STD Provider' || userDetails?.roleName == "STD Staff" ||
    userDetails?.roleName === "STD Program Admin") {
      setSource("SYPHILIS");
      return SOURCEDROPDOWN_OPTIONS.filter(opt => ["SYPHILIS"].includes(opt.value));
    }
    setSource("All");
    return SOURCEDROPDOWN_OPTIONS;
  }

  const handleStateChange = (event: any) => {
    setClientInfoSelectedState(event.target.value);
    setClientInfoSelectedCounty(68);

    //handleFormFieldChange(event);
  };

  const [clientInfoCountyData, setClientInfoCountyData] = useState<
    SelectOption[]
  >([]);



  const { getDataById: getCounties } = useGetData<SelectOption[], string>(
    "Client/Counties",
    "GET"
  );
  const [clientInfoSelectedCounty, setClientInfoSelectedCounty] =
    useState<any>("");

  const handleCountyChange = (event: any) => {
    setClientInfoSelectedCounty(event.target.value);
    /// handleFormFieldChange(event);
  };

  const clientSearchFormRef = useRef<HTMLFormElement>(null);
  const clientInfoUpdateFormRef = useRef<HTMLFormElement>(null);
  const caseReportCreateFomrRef = useRef<HTMLFormElement>(null);

  const handleTouchAllFields = (formRef: React.RefObject<HTMLFormElement>) => {
    if (formRef.current) {
      const inputs = formRef.current.querySelectorAll('input, textarea, select');
      inputs.forEach((input) => {
        const field = input as HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement;
        if (field.focus) field.focus();
        if (field.blur) field.blur();
      })
    }
  }

  const {
    register,
    setValue,
    handleSubmit,
    getValues,
    reset,
    trigger,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(NewCaseReportValidationSchema),
    defaultValues: {
      isNew: false,
      section1: true,
      section2: false,
      section3: false,
      Source: "",
    },
  });

  const {
    register: clientSearchRegister,
    getValues: clientSearchGetValues,
    reset: clientSearchReset,
    trigger: clientSearchTrigger,
  } = useForm({
    resolver: yupResolver(ClientSearchValidationSchema),
  });

  const {
    register: wildCardSearchRegister,
    getValues: wildCardSearchGetValues,
    reset: wildCardSearchReset,
  } = useForm({
    resolver: yupResolver(wildCardSearchValidationSchema)
  })

  const {
    register: clientInfoRegister,
    getValues: clientInfoGetValues,
    setValue: clientInfoSetValue,
    trigger: clientInfoTrigger,
    reset: clientInfoReset,
  } = useForm({
    resolver: yupResolver(ClientInfoValidationSchema(isEditingContactInfo)),
  });

  const [newCaseReportValidationErrors, setnewCaseReportValidationErrors] =
    useState<{
      [key: string]: string;
    }>({});

  const [clientSearchValidationErrors, setclientSearchValidationErrors] =
    useState<{
      [key: string]: string;
    }>({});

  const [wildCardSearchValidationErrors, setWildCardSearchValidationerrors] = useState<{ [key: string]: string }>({});

  const [clientInfoValidationErrors, setclientInfoValidationErrors] = useState<{
    [key: string]: string;
  }>({});
  const diseaseHistory: DiseaseHistoryRow[] = clientInfo?.DieaseHistory ?? [];

  const historicalTests: HistoricalTestRow[] = diseaseHistory.map(
    (h: DiseaseHistoryRow): HistoricalTestRow => ({
      testName: h.testName,
      testSpecimenDate: h.testSpecimenDate,
      diseaseCategory: h.diseaseCategory,
      qualitativeResult: h.qualitativeResult ?? "",
      quantitativeResult: h.quantitativeResult ?? "",
      testHistoryRowNum: h.testHistoryRowNum,
      resultType: h.resultType,
      specimenId: h.specimenId
    })
  );


  const handleUpdateContactDetail = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (source == "HIV" && (userDetails?.roleName == 'Staff' || userDetails?.roleName == 'HIV Staff' || userDetails?.roleName == 'STD Provider' || userDetails?.roleName == 'STD Staff')) {
      toast.error("You are not allowed to Update!", {
        position: "top-right",
        autoClose: 2000,
      });
      return;
    }
    if (source == "SYPHILIS" && (userDetails?.roleName == 'Staff' || userDetails?.roleName == 'HIV Staff' || userDetails?.roleName == 'HIV Provider' || userDetails?.roleName == 'STD Staff')) {
      toast.error("You are not allowed to Update!", {
        position: "top-right",
        autoClose: 2000,
      });
      return;
    }


    setIsEditingContactInfo(true);
  };

  const handleClientInfoSave = async () => {
    setValue('isNew', false);
    setValue('Source', source);

    handleTouchAllFields(clientInfoUpdateFormRef);
    if (isClientInfoSubmitting) {
      toast.success("Data saved successfully!", {
        position: "top-right",
        autoClose: 2000,
      });
      setActiveKey(true);

      clientInfoReset();
      setclientInfoValidationErrors({});
      setIsClientInfoSubmitting(false);
      return;
    }
    setIsClientInfoSubmitting(true);
    await new Promise((resolve) => setTimeout(resolve, 0));

    const clientInfoValues = getValues();
    //setValue("addressTypeDetailNewCase",addressTypeNewCase)
    //setValue("addressTypeDetail",addressType)
    // clientInfoValues.Source=source;
    if (!caseReportPregnant) {
      setValue("EditCaseIsPregnant", '')
    }
    const clientInfoValidationResult = NewCaseReportValidationSchema.validate(
      clientInfoValues,
      { abortEarly: false }
    );

    setclientInfoValidationErrors({});

    clientInfoValidationResult
      .then(async (clientInfoValidatedData) => {
        const request: ClientUpdateRequest = {
          source: clientInfoSource,
          firstName: clientInfoFirstName,
          middleName: clientInfoMiddleName === "" ? null : clientInfoMiddleName,
          lastName: clientInfoLastName,
          dob: clientInfoDob,
          birthGender: clientInfoBirthGender,
          street1: clientInfoStreet,
          street2: clientInfoStreet2,
          city: clientInfoCity,
          stateId:
            clientInfoSelectedState == 0 ? null : clientInfoSelectedState,
          zipCode: clientInfoZip,
          countyId:
            clientInfoSelectedCounty == "OUT OF STATE" ? 68 : clientInfoSelectedCounty,
          ssn: maskedSSN === "" ? null : maskedSSN, // This is not needed while we update client into FLCareLookUp DB.
          primaryPhone: clientInfoPhone1,
          secondPhone: clientInfoPhone2,
          erContactName: clientInfoErContactPerson,
          relationshipId: clientInfoErContactPersonRelation,
          erContactPhone: clientInfoErContactPersonPhone,
          modeofTransmission: clientInfoModeOfTransmission,
          hivdateofDiagnosis: clientInfoHivDateOfDiagnosis,
          dateofLastDocumented: clientInfoDateOfLastDocumented,
          viralLoad: clientInfoViralLoad,
          cd4count: clientInfoCD4Count,
          clientSource: clientInfoSource,
          sourceClientId: clientInfoSourceClientId,
          sourceIdNumber: clientInfoSourceId, //EharsId and StartsID will be save in "fc.Client.SourceIdNumber"
          clientId: "", // Maybe not needed
          userId: account.name, // Hard coded for now

          routinizedHospitalId: caseReportSelectedRoutinizedHospital,
          routinizedFacilityId: caseReportSelectedRoutinizedFacility,
          medicalRecord: caseReportMedicalRecord,
          dateReceived: caseReportDateReceived,
          comments: caseReportComments,
          linkageToCareStatus: linkageCareStatus, //If DW Client it will be Updated
          LinkageToCareStatusForHivDiagnosis: Number.parseInt(l2CName),
          LinkageCareStatusOtherDetails: linkageCareStatusOtherDetails,
          RPR_Specimen_Collection_Date: caseReportRPRSpecimanDate,
          RPR_Specimen_ID: caseReportRPRSpecimanID,
          rPR_Details: detailsToRPRTest,
          rPR_Titer: titer,
          VDRL_Specimen_Collection_Date: caseReportVDRLSpecimanDate,
          VDRL_Specimen_ID: caseReportVDRLSpecimanID,
          vDRL_Details: detailsToVDRLTest,
          vDRL_Titer: caseReportVDRLTiter,
          FTA_ABS_Specimen_Collection_Date: caseReportFTAABSSpecimanDate,
          FTA_ABS_Specimen_ID: caseReportFTAABSSpecimanID,
          fTA_ABS_Details: detailsToFTAABSTest,
          fTA_ABS_Titer: '',
          EIA_IgG_Specimen_Collection_Date: caseReportEIAIgGSpecimenDate,
          EIA_IgG_Specimen_ID: caseReportEIAIgGSpecimenID,
          EIA_IgG_Details: detailsToEIAIgGTest,
          EIA_IgG_Titer: '',
          Chlamydia_Details: detailsToChlamydiaTest,
          ChlamydiaDate: caseReportChlamydiaSpecimanDate,
          ChlamydiaSpecimen_ID: caseReportChlamydiaSpecimanID,
          Chlamydia_Titer: '',
          gonorrhea_Details: detailsGonorrheaTest,
          Gonorrhea_Specimen_Collection_Date: caseReportGonorrheaSpecimanDate,
          Gonorrhea_Specimen_ID: caseReportGonorrheaSpecimanID,
          gonorrhea_Titer: '',
          last_viral_load_date: lastUpdatedDate.lastViralLoad,
          last_cd4_count_date: lastUpdatedDate.lastCd4,
          naatDate: caseReportNAATDate,
          naat: caseReportNAAT,
          hivAgAb: caseReportHIVAGAB,
          hivAgAbDate: caseReportHivAgAbDate,
          hivIa: caseReportHIVIA,
          hivIaDate: caseReportHivIaDate,
          disclosed: caseReportDisclosed,
          disclosedDate: caseReportDisclosedDate,
          inCare: caseReportInCare,
          inCareDate: caseReportInCareDate,
          medication: caseReportMedication,
          linkageCareStatusId: linkageCareStatus,
          pregnantId: caseReportPregnant,
          edd: caseReportEDD,
          dateLmp: caseReportDateLMP,
          isSelfReported: isPositiveTestResult ? isPositiveTestResult : caseReportCheckBox,
          IsPositiveTest: isPositiveTestResult,
          IsCaseReport: caseReportCheckBox,
          //Updated HIV
          UpdatedHIVDateofDiagnosis: updatedLastUpdatedDate.dateOfDiagnosis,
          Updatedlast_viral_load_date: updatedLastUpdatedDate.lastViralLoad,
          Updatedlast_cd4_count_date: updatedLastUpdatedDate.lastCd4,
          UpdatedViralLoad: updatedClientInfoViralLoad,
          UpdatedCD4Count: updatedClientInfoCD4Count,
          UpdatedLinkageToCareStatusForHivDiagnosis: updatedL2CName,
          additionalNotes: clientAdditionalNotes,
          dohNotes: clientDOHNotes,

          AIDSDate: clientInfoAidsDate,
          HIVReportedDate: clientInfoHIVReportedDate,
          HIVModeOfTransmissionId: clientInfoHIVModeOfTransmissionId,

          UpdatedAIDSDate: UpdateClientInfoAidsDate,
          UpdatedHIVReportedDate: UpdateClientInfoHIVReportedDate,
          UpdatedHIVModeOfTransmissionId: UpdateClientInfoHIVModeOfTransmissionId,

          //UPdated STD
          UpdatedRprType: UpdatedRprType == "Other" ? UpdatedRprType1 : UpdatedRprType,
          UpdatedRprSpecimenCollectionDate: UpdatedRprSpecimenCollectionDate,
          UpdatedRprSpecimenId: UpdatedRprSpecimenId,
          UpdatedRprDetails: UpdatedRprDetails,
          UpdatedRprTiter: UpdatedRprTiter,

          UpdatedVdrlType: UpdatedVdrlType == "Other" ? UpdatedVdrlType1 : UpdatedVdrlType,
          UpdatedVdrlSpecimenCollectionDate: UpdatedVdrlSpecimenCollectionDate,
          UpdatedVdrlSpecimenId: UpdatedVdrlSpecimenId,
          UpdatedVdrlDetails: UpdatedVdrlDetails,
          UpdatedVdrlTiter: UpdatedVdrlTiter,

          UpdatedTpPaType: UpdatedTpPaType == "Other" ? UpdatedTpPaType1 : UpdatedTpPaType,
          UpdatedTpPaSpecimenCollectionDate: UpdatedTpPaSpecimenCollectionDate,
          UpdatedTpPaSpecimenId: UpdatedTpPaSpecimenId,
          UpdatedTpPaDetails: UpdatedTpPaDetails,
          //UpdatedTpPaTiter: UpdatedTpPaTiter,

          UpdatedFtaAbsType: UpdatedFtaAbsType == "Other" ? UpdatedFtaAbsType1 : UpdatedFtaAbsType,
          UpdatedFtaAbsSpecimenCollectionDate: UpdatedFtaAbsSpecimenCollectionDate,
          UpdatedFtaAbsSpecimenId: UpdatedFtaAbsSpecimenId,
          UpdatedFtaAbsDetails: UpdatedFtaAbsDetails,
          //UpdatedFtaAbsTiter: UpdatedFtaAbsTiter,

          updatedEIAType: UpdatedEiaType === "Other" ? UpdatedEiaType1 : UpdatedEiaType,
          updatedEIADate: UpdatedEiaSpecimenCollectionDate,
          updatedEIASpecimenId: UpdatedEiaSpecimenId,
          updatedEIADetails: UpdatedEiaDetails,
          // updatedEiaTiter: UpdatedEiaTiter, 

          UpdatedChlamydiaType: UpdatedChlamydiaType == "Other" ? UpdatedChlamydiaType1 : UpdatedChlamydiaType,
          UpdatedChlamydiaDate: UpdatedChlamydiaDate,
          UpdatedChlamydiaSpecimenId: UpdatedChlamydiaSpecimenId,
          UpdatedChlamydiaDetails: UpdatedChlamydiaDetails,
          //UpdatedChlamydiaTiter: UpdatedChlamydiaTiter,

          UpdatedGonorrheaType: UpdatedGonorrheaType == "Other" ? UpdatedGonorrheaType1 : UpdatedGonorrheaType,
          UpdatedGonorrheaSpecimenCollectionDate: UpdatedGonorrheaSpecimenCollectionDate,
          UpdatedGonorrheaSpecimenId: UpdatedGonorrheaSpecimenId,
          UpdatedGonorrheaDetails: UpdatedGonorrheaDetails,
          //UpdatedGonorrheaTiter: UpdatedGonorrheaTiter,

          // Medical Info section
          datePresented: caseReportDatePresented,
          dateDischarged: caseReportDateDischarged,
          chiefComplaint: caseReportChiefComplaint,
          symptoms: caseReportSymptoms,
          hospitalAdmit: caseReportHospitalAdmit === "Yes" ? true : false,
          hospitalLocation: caseReportHospitalLocation,
          hospitalRoom: caseReportHospitalRoom,

          //STD Info new logi
          updatedRPR_Type: updatedRPR_Type,
          updatedRPR_Result: updatedRPR_Result,
          updatedVDRL_Type: updatedVDRL_Type,
          updatedVDRL_Result: updatedVDRL_Result,

          updatedTPPA_Type: updatedTPPA_Type,
          updatedTPPA_Result: updatedTPPA_Result,
          updatedFTAABS_Type: updatedFTAABS_Type,
          updatedFTAABS_Result: updatedFTAABS_Result,
          updatedEIA_Type: UpdatedEiaType,
          updatedEIA_Result: UpdatedEiaDetails,


          updatedChlamydia_Type: updatedChlamydia_Type,
          updatedChlamydia_Result: updatedChlamydia_Result,
          updatedGonorrhea_Type: updatedGonorrhea_Type,
          updatedGonorrhea_Result: updatedGonorrhea_Result,

          HistoricalTests: historicalTests ?? [],
          TreatmentHistory: syphilisTreatmentHistory.map((row) => ({
            addedDate: row.starsAddedDate,
            providerName: row.providerName,
            screeningDate: row.screeningDate,
            examDate: row.examDate,
            treatmentDate: row.treatedDate,
            treatmentName: row.treatmentData,
            treatmentAdministeredBy: row.treatmentAdministeredName,
          }))

        };
        if (!showTestingInformationError && !isSTDProvider) {
          toast.error('Enter at least one test information', { position: 'top-right', autoClose: 2000 });
          setIsClientInfoSubmitting(false);
          const firstErrorElement = document.querySelector('[name=NAAT]');
          if (firstErrorElement)
            (firstErrorElement as HTMLElement).focus();
          return;
        } else {
          const userConfirmed = window.confirm(
            "Please confirm if you would like to save?"
          );
          if (!userConfirmed) {
            setIsClientInfoSubmitting(false);
            return;
          }
          setIsLoader(true);
          try {
            var resp = await postClientUpdate(request);
            if (resp && resp.status == 200) {
              toast.success('Client Saved Sucessfully.', {
                position: "top-right",
                autoClose: 2000,
              });
              setActiveKey(false);
              setIsLoader(false);
              clientInfoReset();
              setclientInfoValidationErrors({});
              setIsClientInfoSubmitting(false);

              window.scrollTo({ top: 0, behavior: "smooth" });
          
            setIsSearchTableVisible(true);
            setIsTableVisible(false);

            await new Promise((resolve) => setTimeout(resolve, 100));
            setSource(source);
            setFirstName("");
            setLastName("");
            setBirthGender("");
            setDob("");
            setSearchResults([]);
            setShowPatientInfo(false);
            setIsNavCollapsed(prev => !prev);
            } else {
              setIsLoader(false);
              toast.error("An Error Occured while updating client Information.", {
                position: "top-right",
                autoClose: 2000,
              });
              setIsClientInfoSubmitting(false);
            };

          } catch (error) {
            setIsLoader(false);
            toast.error("An Error Occured while updating client Information.", {
              position: "top-right",
              autoClose: 2000,
            });
            setIsClientInfoSubmitting(false);
          }
          
       }
      })
      .catch((ValidationErrors) => {
        setIsLoader(false);
        const tempClientInfoValidationErrors: { [key: string]: string } = {};
        ValidationErrors.inner.forEach((err: any) => {
          tempClientInfoValidationErrors[err.path] = err.message;
        });
        setclientInfoValidationErrors(tempClientInfoValidationErrors);
        setnewCaseReportValidationErrors(tempClientInfoValidationErrors);

        // toast.error("An Error Occured while updating client Information. 2", {
        //   position: "top-right",
        //   autoClose: 2000,
        // });
        setIsClientInfoSubmitting(false);

        // focus on the first invalid field
        const firstErrorField = Object.keys(tempClientInfoValidationErrors)[0];
        const firstErrorElement = document.querySelector(
          `[name="${firstErrorField}"]`
        );
        if (firstErrorElement)
          (firstErrorElement as HTMLElement).focus();
      });
  

      //Back to the top of the page after saving client info
          setSource(source);
          setFirstName("");
          setLastName("");
          setBirthGender("");
          setDob("");
    


    };

  const [isMedicalCollapsed, setIsMedicalCollapsed] = useState(false);

  const toggleMedical = () => {
    setIsMedicalCollapsed(prev => !prev);
  };

  const [isStdInfoCollapsed, setIsStdInfoCollapsed] = useState(false);

  const toggleStdInfo = () => {
    setIsStdInfoCollapsed(prev => !prev);
  };

  const handleSearchClear = () => {
    // Note: The default value of source always should be All
    setSource(source);
    setFirstName("");
    setLastName("");
    setBirthGender("");
    setDob("");
    setShowNewCase(false);
    setErrorMessage(""); // Clear previous error messages

    // Clear client Search and new case report Validations
    setclientSearchValidationErrors({});
    setWildCardSearchValidationerrors({});
    clientSearchReset();
    clientInfoReset();
    wildCardSearchReset();
    setclientInfoValidationErrors({});
    reset();
    setnewCaseReportValidationErrors({});

    // close the new case report tab
    setNewCaseKey(false);

    setSearchResults([]);
    handleClearPatientInfo();
    handleSectionValidation(true, false, false);
    handleCaseReportClear(); // Clear Case report
  };

  const handleClearPatientInfo = () => {
    setClientInfoErrorMessage("");

    setClientInfoSourceClientId("");
    setClientInfoSource("");
    setClientInfoFirstName("");
    setClientInfoMiddleName("");
    setClientInfoLastName("");
    setClientInfoBirthGender("");
    setClientInfoDob("");
    setClientInfoLabDate("");

    setClientInfoStreet1("");
    setClientInfoStreet2("");
    setClientInfoCity("");
    setClientInfoZip("");
    setClientInfoPhone1("");
    setClientInfoPhone2("");
    setClientInfoErContactPerson("");
    setClientInfoErContactPersonRelation("");
    setClientInfoErContactPersonPhone("");

    setClientInfoModeOfTransmission("");
    setClientInfoHivDateOfDiagnosis("");
    setClientInfoDateOfLastDocumented("");
    setClientInfoViralLoad("");
    setClientInfoCD4Count("");

    setClientInfoSelectedState(0);
    setClientInfoSelectedCounty("");
    setl2CName("");
    setClientInfoSource("");
    setClientInfoSourceId("");
  };

  const handleSearch = async () => {
    setShowPatientInfo(false);
    handleTouchAllFields(clientSearchFormRef);
    setErrorMessage(""); // Clear previous error messages
    setnewCaseReportValidationErrors({});
    // Clear client Search and new case report Validations
    reset();
    setnewCaseReportValidationErrors({});
    handleCaseReportClear();
    handleClearPatientInfo();
    setSearchResults([]); // Clear the results grid
    setShowNewCase(false);

    setclientSearchValidationErrors({});
    setWildCardSearchValidationerrors({});
    if (wildCardSearch) {
      const wildCardSearchValues = wildCardSearchGetValues();

      const wildCardSearchValidationResult = wildCardSearchValidationSchema.validate(
        wildCardSearchValues,
        { abortEarly: false }
      );

      wildCardSearchValidationResult
        .then(handleSearchValuesResponse)
        .catch((ValidationErrors) => {
          const tempClientSearchValidationErrors: { [key: string]: string } = {};
          ValidationErrors?.inner?.forEach((err: any) => {
            tempClientSearchValidationErrors[err.path] = err.message;
          });
          setWildCardSearchValidationerrors(tempClientSearchValidationErrors);

          // focus on the first invalid field
          const firstErrorField = Object.keys(
            tempClientSearchValidationErrors
          )[0];
          const firstErrorElement = document.querySelector(
            `[name="${firstErrorField}"]`
          );
        });
    } else {
      const clientSearchValues = clientSearchGetValues();

      const clientSearchValidationResult = ClientSearchValidationSchema.validate(
        clientSearchValues,
        { abortEarly: false }
      );

      clientSearchValidationResult
        .then(handleSearchValuesResponse)
        .catch((ValidationErrors) => {
          const tempClientSearchValidationErrors: { [key: string]: string } = {};
          ValidationErrors?.inner?.forEach((err: any) => {
            tempClientSearchValidationErrors[err.path] = err.message;
          });
          setclientSearchValidationErrors(tempClientSearchValidationErrors);

          // focus on the first invalid field
          const firstErrorField = Object.keys(
            tempClientSearchValidationErrors
          )[0];
          const firstErrorElement = document.querySelector(
            `[name="${firstErrorField}"]`
          );
          //(firstErrorElement as HTMLElement).focus();
        });
    }
    setIsTableVisible(true);
  };

  const handleSearchValuesResponse = async () => {
    const searchInfoRequest: SearchInfoRequest = {
      source: source,
      firstName: firstName,
      lastName: lastName,
      dob: dob,
      userId: userId,
      birthGender: birthGender,
      wildCardSearch: wildCardSearch
    };
    setIsLoader(true);
    var searchResponse: any = await postDataById(searchInfoRequest);
    setIsLoader(false);
    if (!searchResponse.searchResults || searchResponse.searchResults.length === 0) {
      setErrorMessage(
        "No Clients Found. Please try a different search criteria."
      );
      setShowNewCase(true);
    }
    if (wildCardSearch) {
      if (searchResponse.errorCode && searchResponse.errorMessage) {
        setErrorMessage(searchResponse.errorMessage);
      }
      else if (searchResponse.errorMessage) {
        setErrorMessage(searchResponse.errorMessage);
        //toast.error(searchResponse.errorMessage);
        setShowNewCase(true);
      } else {
        let filterResults: any[] = JSON.parse(JSON.stringify(searchResponse.searchResults));
        if (filterResults.length > 1) {
          setErrorMessage("");
          //setErrorMessage("Multiple Matches Found. Please contact CHD staff for confirmation.");
          setShowNewCase(true);
        } else {
          if (searchResponse.searchResults.length > 0 && filterResults.some(x => x.firstName.toLowerCase() === firstName.toLowerCase())) {
            filterResults = filterResults.filter(x => x.firstName.toLowerCase() === firstName.toLowerCase());
          }
          filterResults.forEach(x => x.dob = x.dob.split(' ')[0]);
        }
        if (searchResponse.searchResults[0]?.linkageToCareStatus) {
          let l2cId = allLinkageCareStatusesData.find(x => x.value === searchResponse.searchResults[0]?.linkageToCareStatus)?.id ?? '';
          setl2CName(l2cId);
        }
        setSearchResults(filterResults);
        setActiveKey(false);
        setWildCardSearchValidationerrors({});
        wildCardSearchReset();
      }
    }
    else {
      if (searchResponse) {
        if (searchResponse.errorCode && searchResponse.errorMessage) {
          setErrorMessage(searchResponse.errorMessage);
        }
        else if (searchResponse.errorMessage) {
          setErrorMessage(searchResponse.errorMessage);
          //toast.error(searchResponse.errorMessage);
          setShowNewCase(true);
        } else {
          if (searchResponse.searchResults.length > 1) {
            setErrorMessage("");
            // setErrorMessage(
            //   "Multiple Matches Found. Please contact CHD staff for confirmation."
            // );
          }
          if (searchResponse.searchResults[0]?.linkageToCareStatus) {
            let l2cId = allLinkageCareStatusesData.find(x => x.value === searchResponse.searchResults[0]?.linkageToCareStatus)?.id ?? '';
            setl2CName(l2cId);
          }
          if (searchResponse.searchResults) {
            let searchResults: any[] = searchResponse.searchResults;
            searchResults = searchResults.filter(x => x.source === 'Stars');
            const diseaseHistory: DiseaseHistoryRow[] = searchResults[0]?.dieaseHistory || [];
            setClientInfo(prev => ({
              ...prev,
              DieaseHistory: diseaseHistory
            }));

            // RPR
            setHistoricalRPR(
              diseaseHistory
                .filter((x: DiseaseHistoryRow) => x.testName === "RPR" && x.resultType === "Historical")
                .sort((a, b) => a.testHistoryRowNum - b.testHistoryRowNum)
            );


            // VDRL
            setHistoricalVDRL(
              diseaseHistory
                .filter((x: any) => x.testName === "VDRL" && x.resultType === "Historical")
                .sort((a: any, b: any) => a.testHistoryRowNum - b.testHistoryRowNum)
            );

            // FTA-ABS
            setHistoricalFTAABS(
              diseaseHistory
                .filter((x: any) => x.testName === "FTA-ABS" && x.resultType === "Historical")
                .sort((a: any, b: any) => a.testHistoryRowNum - b.testHistoryRowNum)
            );

            // TP-PA
            setHistoricalTPPA(
              diseaseHistory
                .filter((x: any) => x.testName === "TP-PA" && x.resultType === "Historical")
                .sort((a: any, b: any) => a.testHistoryRowNum - b.testHistoryRowNum)
            );

            // EIA IgG
            setHistoricalEIAIgG(
              diseaseHistory
                .filter((x: any) => x.testName === "EIA-IgG" && x.resultType === "Historical")
                .sort((a: any, b: any) => a.testHistoryRowNum - b.testHistoryRowNum)
            );

            setHistoricalChlamydia(
              diseaseHistory
                .filter((x: DiseaseHistoryRow) =>
                  x.diseaseCategory?.toLowerCase() === "chlamydia" && x.resultType === "Historical"
                )
                .sort((a, b) => a.testHistoryRowNum - b.testHistoryRowNum)
            );

            setHistoricalGonorrhea(
              diseaseHistory
                .filter((x: DiseaseHistoryRow) =>
                  x.diseaseCategory?.toLowerCase() === "gonorrhea" &&
                  x.resultType === "Historical"
                )
                .sort((a, b) => a.testHistoryRowNum - b.testHistoryRowNum)
            );

            setClientInfoAidsDate(searchResults[0]?.aids_date?.split('T')[0] ?? "");
            setRprTestInfo((prev) => ({ ...prev, specimenDdate: searchResults[0]?.rpR_Specimen_Collection_Date?.split('T')[0] ?? "", details: searchResults[0]?.rpR_Details ?? "", titer: searchResults[0]?.rpR_Titer ?? "" }));
            setVdrlTestInfo((prev) => ({ ...prev, specimenDdate: searchResults[0]?.vdrL_Specimen_Collection_Date?.split('T')[0] ?? "", details: searchResults[0]?.vdrL_Details ?? "", titer: searchResults[0]?.vdrL_Titer ?? "" }));
            setTppaTestInfo((prev) => ({ ...prev, specimenDdate: searchResults[0]?.tP_PA_Specimen_collection_date?.split('T')[0] ?? "", details: searchResults[0]?.tP_PA_details ?? "" }));
            setFtaAbsInfo((prev) => ({ ...prev, specimenDdate: searchResults[0]?.ftA_ABS_Specimen_Collection_Date?.split('T')[0] ?? "", details: searchResults[0]?.ftA_ABS_Details ?? "" }));
            setEiaIgGInfo((prev) => ({ ...prev, specimenDdate: searchResults[0]?.eiA_IgG_Specimen_collection_date?.split('T')[0] ?? "", details: searchResults[0]?.eiA_IgG_details ?? "" }));
            setLastUpdatedDate({ lastCd4: searchResults[0]?.last_viral_load_date?.split('T')[0] ?? "", lastViralLoad: searchResults[0]?.last_cd4_count_date?.split('T')[0] ?? "" });
          }
          if (searchResponse.searchResults.length > 1) {
            let copySearchResults: any[] = searchResponse.searchResults;
            copySearchResults = copySearchResults.map(item => item['source']);
            let hasDuplicateSource: boolean = copySearchResults.some((value, index) => copySearchResults.indexOf(value) !== index);
            if (!hasDuplicateSource) {
              let filteredResults: any[] = searchResponse.searchResults;
              setLastUpdatedDate({ lastCd4: filteredResults[0]?.last_viral_load_date?.split('T')[0] ?? "", lastViralLoad: filteredResults[0]?.last_cd4_count_date?.split('T')[0] ?? "" });
              searchResponse.searchResults = filteredResults;
            }
          }
          if (searchResponse.searchResults.length === 1) {
            setErrorMessage("");
          }

          setSearchResults(searchResponse.searchResults);
          clientSearchReset();
          setclientSearchValidationErrors({});
        }
      }
    }
    navigate("/dashboard");
  }

  const handleRowButtonClick = async (client: any) => {
    setShowPatientInfo(true);
    setClientInfoErrorMessage("");
    setClient(client);
    setClientInfoSourceClientId(client.clientId ?? "");
    setClientInfoSource(client.source ?? "");
    setClientInfoSourceId(client.sourceId ?? "");
    setClientInfoSource(client.source ?? "");
    setClientInfoFirstName(client.firstName ?? "");
    setClientInfoMiddleName(client.middleName ?? "");
    setClientInfoLastName(client.lastName ?? "");
    setClientInfoBirthGender(client.birthGender ?? "");
    setClientInfoDob(client.dob ?? "");
    setClientInfoLabDate(client.labDate ?? "");
    clientInfoSetValue("clientInfoStreetAddress", client.street || "", { shouldValidate: true, });
    clientInfoSetValue("clientInfoCity", client.city || "", { shouldValidate: true, });
    clientInfoSetValue("clientInfoZipcode", client.zipCode || "", { shouldValidate: true, });
    setClientInfoStreet1(client.street ?? "");
    setClientInfoStreet2(client.street2 ?? "");
    setClientInfoCity(client.city ?? "");
    setClientInfoZip(client.zipCode ?? "");
    setClientInfoPhone1(client.phone1 ?? "");
    setClientInfoPhone2(client.phone2 ?? "");
    setClientInfoErContactPerson(client.erContactPerson ?? "");
    setClientInfoErContactPersonRelation(client.erContactPersonRelationship ?? "");
    setClientInfoErContactPersonPhone(client.erContactPersonPhone ?? "");
    setClientInfoAidsDate(client?.aids_date?.split('T')[0] ?? "");
    setClientInfoHIVReportedDate(client?.hiv_rep_date?.split('T')[0] ?? "");
    const ModeOfTransmissionId = allModeoftransmissionData?.find(X => X.value == client.mode_of_hiv_exposure)?.id;
    setClientInfoModeOfTransmissionId(ModeOfTransmissionId ?? "");
    setClientInfoSelectedState(client.stateId?.toString() ?? "");
    setClientInfoSelectedCounty(client.countyId?.toString() ?? "");
    //RPR Test Information
    setcaseReportRPRSpecimanDate(client.rpR_Specimen_Collection_Date?.split('T')[0] ?? "");
    if (client.rpR_Details == null || client.rpR_Details === "-" || client.rpR_Details === "") {
      setdetailsToRPRTest("-");
    } else {
      setdetailsToRPRTest(client.rpR_Details === "R" || client.rpR_Details === "P" || client.rpR_Details === "Reactive" || client.rpR_Details === "Positive" ? "Positive" : "Negative");
    }
    //CSF-VDRL Test Information
    setcaseReportVDRLSpecimanDate(client.vdrL_Specimen_Collection_Date?.split('T')[0] ?? "");
    if (client.vdrL_Details == null || client.vdrL_Details === "-" || client.vdrL_Details === "") {
      // The value is empty or "-"
      setdetailsToVDRLTest("-");
    } else {
      setdetailsToVDRLTest(client.vdrL_Details === "R" || client.vdrL_Details === "P" || client.vdrL_Details === "Reactive" || client.vdrL_Details === "Positive" ? "Positive" : "Negative");
    }
    setcaseReportVDRLTiter(client.vdrL_Titer ?? "");
    //TP-PA Information
    setcaseReportTPPASpecimanDate(client.tP_PA_Specimen_collection_date?.split('T')[0] ?? "");
    if (client.tP_PA_details == null || client.tP_PA_details === "-" || client.tP_PA_details === "") {
      // The value is empty or "-"
      setdetailsToTPPATest("-");
    } else {
      setdetailsToTPPATest(client.tP_PA_details === "R" || client.tP_PA_details === "P" || client.tP_PA_details === "Reactive" || client.tP_PA_details === "Positive" ? "Positive" : "Negative");
    }
    //FTA-ABS Information
    setcaseReportFTAABSpecimanDate(client.ftA_ABS_Specimen_Collection_Date?.split('T')[0] ?? "");
    if (client.ftA_ABS_Details == null || client.ftA_ABS_Details === "-" || client.ftA_ABS_Details === "") {
      // The value is empty or "-"
      setdetailsToFTAABSTest("-");
    } else {
      setdetailsToFTAABSTest(client.ftA_ABS_Details === "R" || client.ftA_ABS_Details === "P" || client.ftA_ABS_Details === "Reactive" || client.ftA_ABS_Details === "Positive" ? "Positive" : "Negative");
    }

    // EIA IgG Information
    setCaseReportEIAIgGSpecimenDate(client.eiA_IgG_Specimen_collection_date?.split("T")[0] ?? "");
    if (client.eiA_IgG_details == null || client.eiA_IgG_details === "-" || client.eiA_IgG_details === "") {
      setDetailsToEIAIgGTest("-");
    } else {
      setDetailsToEIAIgGTest(
        client.eiA_IgG_details === "R" ||
          client.eiA_IgG_details === "P" ||
          client.eiA_IgG_details === "Reactive" ||
          client.eiA_IgG_details === "Positive"
          ? "Positive"
          : "Negative"
      );
    }
    //Chlamydia [200] Test Information
    setcaseReportChlamydiaSpecimanDate(client.chlamydiaDate?.split('T')[0] ?? "");
    if (client.chlamydia_Details == null || client.chlamydia_Details === "-" || client.chlamydia_Details === "") {
      // The value is empty or "-"
      setdetailsToChlamydiaTest("-");
    } else {
      setdetailsToChlamydiaTest(client.chlamydia_Details === "R" || client.chlamydia_Details === "P" || client.chlamydia_Details === "Reactive" || client.chlamydia_Details === "Positive" ? "Positive" : "Negative");
    }
    //Gonorrhea [300] Test Information
    setcaseReportGonorrheaSpecimanDate(client.gonorrhea_Specimen_Collection_Date?.split('T')[0] ?? "");
    if (client.gonorrhea_Details == null || client.gonorrhea_Details === "-" || client.gonorrhea_Details === "") {
      // The value is empty or "-"
      setdetailsToGonorrheaTest("-");
    } else {
      setdetailsToGonorrheaTest(client.gonorrhea_Details === "R" || client.gonorrhea_Details === "P" || client.gonorrhea_Details === "Reactive" || client.gonorrhea_Details === "Positive" ? "Positive" : "Negative");
    }

    const request: SearchLabRequest = {
      clientId: client.clientId,
      labDate: client.labDate,
      source: client.source,
    };
    const searchResponse = await postByObject(request);
    const clientTreatmentHistory =
      client.treatmentHistoryResults ??
      client.TreatmentHistoryResults ??
      [];

    if (clientTreatmentHistory.length > 0) {
      setSyphilisTreatmentHistory(clientTreatmentHistory);
    } else {
      const histrequest: SearchTreatmentHistoryRequest = {
        clientId: client.clientId
      };
      const searchhistResponse = await postTreatmentHistory(histrequest);
      setSyphilisTreatmentHistory((searchhistResponse as any)?.treatmentHistoryResults ?? []);
    }
    if (searchResponse) {
      setClientInfoModeOfTransmission(
        searchResponse.labResults?.modeOfTransmission ?? ""
      );
      setClientInfoHivDateOfDiagnosis(
        searchResponse.labResults?.hivDateOfDiagnosis ?? ""
      );
      setClientInfoDateOfLastDocumented(
        searchResponse.labResults?.dateOfLastDocumented ?? ""
      );
      setClientInfoViralLoad(client.last_viral_load_count ?? "");
      setClientInfoCD4Count(client.last_cd4_load_count ?? "");

      setLastUpdatedDate({
        lastViralLoad: client?.last_viral_load_date?.split('T')[0] ?? "",
        lastCd4: client?.last_cd4_count_date?.split('T')[0] ?? ""
      });
      setActiveKey(true);
    }

    setIsSearchTableVisible(false);
    setIsTableVisible(false);
  };
  const handleCancelClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    handleClearPatientInfo();
    handleCaseReportClear();
    setIsEditingContactInfo(false);
    setNewCaseKey(false);
    setActiveKey(false);
  }

  const { getDataById: getUserId } = useGetData<any, string>(
    "UserSecurity/GetUserSecurityByEmail/" + account.username,
    "GET"
  );

  const [userDetails, setUserDetails] = useState<UserDetails>();

  const hasFetched = useRef(false); // Declare outside useEffect

  const [sourceOptions, setSourceOptions] = useState<SourceSelectOption[]>(SOURCEDROPDOWN_OPTIONS);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setIsLoader(true);
        const userData = await getUserId("");
        if (userData?.user && userData.user.isActive) {
          setIsAdmin(userData?.user?.roleName.toLowerCase() === "admin");
          setIsSTDProvider(userData?.user?.roleName.toLowerCase() === "std provider");
          setIsHivProvider(userData?.user?.roleName.toLowerCase() === "hiv provider");
          setShowStdTestInfo(userData?.user?.roleName.toLowerCase() === "hiv provider" || userData?.user?.roleName.toLowerCase() === "hiv staff")
          setUserDetails({ ...userData.user }); // Update state
          setSourceOptions(getSourceOptionsByRoleName(userData.user.roleName, userData.user));
        }
        else {
          navigate('/unauthorized');
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
      finally {
        setIsLoader(false);
      }
    };

    if (isAuthenticated && !hasFetched.current) {
      hasFetched.current = true; // Mark as fetched

      fetchUserData();
    }
  }, [isAuthenticated, getUserId]); // Dependency array

  const mapToSelectOptions = (data: RoleData[]): SelectOption[] => {
    return data.map((item) => ({
      id: item.id.toString(),
      value: item.value,
    }));
  };

  useEffect(() => {
    // Set the max date to today
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];
    setMaxDate(formattedDate);

    const loadStateData = async () => {
      const statesData = await getStates("");
      if (statesData) {
        setClientInfoStateData(statesData);
        setCaseReportStateData(statesData);
      }
    };
    loadStateData();

    const loadCountyData = async () => {
      const countyData = await getCounties("");
      if (countyData) {
        setClientInfoCountyData(countyData);
        setCaseReportCountyData(countyData);
      }
    };
    loadCountyData();

    const loadResultData = async () => {
      const resultData = await getResults("");
      if (resultData) {
        setClientInfoResultData(resultData);
        setCaseReportResultData(resultData);
      }
    }
    loadResultData();

    const loadTestData = async () => {
      const testData = await getTests("");
      if (testData) {
        setClientInfoTestData(testData);
        setCaseReportTestData(testData);
      }
    }
    loadTestData();

    const loadRelationshipData = async () => {
      const relationshipData = await getRelationshipTypes("");
      if (relationshipData) {
        setClientInfoRelationshipData(relationshipData);
        setCaseReportRelationshipData(relationshipData);
      }
    }
    loadRelationshipData();

    const loadStatusTypeData = async () => {
      const statusTypeData = await getStatusTypes("");
      if (statusTypeData) {
        setCaseReportStatusTypeData(statusTypeData);
        setClientInfoStatusTypeData(statusTypeData);
      }
    }
    loadStatusTypeData();

    const fetchRoutinizedHospitals = async () => {
      try {
        var data: RoleData[] = await getRoutinizedHospitals("");
        // try filter if userDetails.role = Provider / staff
        if (data) {
          if (userDetails?.roleName == 'Provider' || userDetails?.roleName == 'Staff' || userDetails?.roleName == 'HIV Provider' || userDetails?.roleName == 'STD Provider') {
            data = data.filter(
              (hospital) => hospital.value == userDetails.routinizedHospitalName
            )
          }
          const mappedRoles = mapToSelectOptions(data);
          setallRoutinizedHospitalsData([
            { id: "", value: "----- Select Routinized Hospitals -----" },
            ...mappedRoles,
          ]);
        }
      } catch (error) {
        console.error("Failed to fetch roles", error);
      }
    };

    fetchRoutinizedHospitals();

    const fetchLinkageCareStatuses = async () => {
      try {
        const data: RoleData[] = await getLinkageCareStatuses("");
        if (data) {
          const mappedRoles = mapToSelectOptions(data);
          setallLinkageCareStatusesData([
            { id: "", value: "--" },
            ...mappedRoles,
          ]);
        }
      } catch (error) {
        console.error("Failed to fetch roles", error);
      }
    };
    fetchLinkageCareStatuses();

    const fetchModeofTransmission = async () => {
      try {
        const dataMOT: RoleData[] = await getModeofTransmission("");
        if (dataMOT) {
          const mappedMOT = mapToSelectOptions(dataMOT);
          setallModeoftransmissionData([
            { id: "", value: "--" },
            ...mappedMOT,
          ]);
        }
      } catch (error) {
        console.error("Failed to fetch roles", error);
      }
    };
    fetchModeofTransmission();


  }, [activeKey, userDetails]);



  // ******** Case Report  ************************************************************************************************************/

  // ******** Patient Identification **************************************************************************************************/

  const [caseReportErrorMessage, setCaseReportErrorMessage] =
    useState<string>("");

  const [caseReportRoutinizedHospital, setCaseReportRoutinizedHospital] =
    useState<SelectOption[]>([
      {
        id: "Jackson Memorial Hospital",
        value: "Jackson Memorial Hospital",
      },
      {
        id: "Baptist Hospital",
        value: "Baptist Hospital",
      },
    ]);
  const [
    caseReportSelectedRoutinizedHospital,
    setCaseReportSelectedRoutinizedHospital,
  ] = useState<string>("");

  const [caseReportRoutinizedFacility, setCaseReportRoutinizedFacility] =
    useState<SelectOption[]>([]);
  const [
    caseReportSelectedRoutinizedFacility,
    setCaseReportSelectedRoutinizedFacility,
  ] = useState<string>("");

  const [caseReportOtherFacilityDetail, setCaseReportSetOtherFacilityDetail] =
    useState<string>("");
  const [
    caseReportOtherFacilityDetailIsDisabled,
    setCaseReportOtherFacilityDetailIsDisabled,
  ] = useState(true);

  const [caseReportMedicalRecord, setCaseReportMedicalRecord] =
    useState<string>("");
  const [caseReportDateReceived, setCaseReportDateReceived] =
    useState<string>("");
  const [caseReportSource, setCaseReportSource] = useState<string>("");
  const [caseReportFirstName, setCaseReportFirstName] = useState<string>("");
  const [caseReportLastName, setCaseReportLastName] = useState<string>("");
  const [caseReportMiddleName, setCaseReportMiddleName] = useState<string>("");
  const [caseReportDOB, setCaseReportDOB] = useState<string>("");
  const [caseReportBirthGender, setCaseReportBirthGender] =
    useState<string>("");
  const [caseReportLast4SSN, setCaseReportLast4SSN] = useState<string>("");
  const [ssnIsMasked, setssnIsMasked] = useState<boolean>(false);


  const handleCaseReportScrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const top = element.getBoundingClientRect().top + window.scrollY - 70;
      window.scrollTo({
        top,
        behavior: 'smooth',
      });
    }
  };


  const handleNavCaseReportItemClick = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    id: string
  ) => {
    e.preventDefault();

    switch (id) {
      case 'CaseReportMedicalInformation':
        setIsMedicalCollapsed(false);
        break;
      case 'CaseReportTestingInformation':
        setIsTestingInfoCollapsed(false);
        break;
      case 'CaseReportHIVDetails':
        setIsHivDetailsCollapsed(false);
        break;
      case 'CaseReportSTDTestInformation':
        setIsStdInfoCollapsed(false);
        break;

      default:
        break;
    }

    handleCaseReportScrollToSection(id);
  };

  const navCaseReportItems: NavItem[] = [
    { id: 'CaseReportPatientIdentification', label: 'Patient Identification' },
    { id: 'CaseReportPatientContactIdentification', label: 'Patient Contact Identification' },
    { id: 'CaseReportEmergencyContactInformation', label: 'Emergency Contact Information' },
    { id: 'CaseReportMedicalInformation', label: 'Medical Information' },
    { id: 'CaseReportLinkageToCareStatus', label: 'Linkage to Care Status' },
    { id: 'CaseReportTestingInformation', label: 'Testing Information' },

    ...(source !== "SYPHILIS"
      ? [{ id: 'CaseReportHIVDetails', label: 'HIV Details' }] : []),

    ...(source !== "HIV"
      ? [{ id: 'CaseReportSTDTestInformation', label: 'STD Test Information' }]
      : []),

    ...(caseReportBirthGender?.toLowerCase() == "female"
      ? [{ id: 'CaseReportPregnancyInformation', label: 'Pregnancy Information' }]
      : []),
    { id: 'CaseReportAdditionalNotes', label: 'Additional Notes' },
  ];

  // ******** Patient Contact Information ********************************************************************************************/

  const [caseReportStreet1, setCaseReportStreet1] = useState<string>("");
  const [caseReportStreet2, setCaseReportStreet2] = useState<string>("");
  const [caseReportCity, setCaseReportCity] = useState<string>("");

  const [caseReportStateData, setCaseReportStateData] = useState<
    SelectOption[]
  >([]);
  const [caseReportStateId, setCaseReportStateId] = useState<string>("");

  const [caseReportCountyData, setCaseReportCountyData] = useState<
    SelectOption[]
  >([]);

  const [caseReportRelationshipData, setCaseReportRelationshipData] = useState<SelectOption[]>([]);

  const [caseReportTestData, setCaseReportTestData] = useState<SelectOption[]>([]);
  const [caseReportResultData, setCaseReportResultData] = useState<SelectOption[]>([]);

  const [caseReportCountyId, setCaseReportCountyId] = useState<string>("");

  const [caseReportZipCode, setCaseReportZipCode] = useState<string>("");
  const [caseReportPrimaryPhone, setCaseReportPrimaryPhone] =
    useState<string>("");

  const [caseReportComments, setCaseReportComments] = useState<string>("");

  const [caseReportErContactPerson, setCaseReportErContactPerson] =
    useState<string>("");
  const [caseReportErContactRelation, setCaseReportErContactRelation] =
    useState<string>("");
  const [caseReportErContactPhone, setCaseReportErContactPhone] =
    useState<string>("");

  const [caseReportDatePresented, setCaseReportDatePresented] =
    useState<string>("");
  const [caseReportDateDischarged, setCaseReportDateDischarged] =
    useState<string>("");
  const [caseReportChiefComplaint, setCaseReportChiefComplaint] =
    useState<string>("");
  const [caseReportSymptoms, setCaseReportDateSymptoms] = useState<string>("");

  const [caseReportHospitalAdmit, setCaseReportHospitalAdmit] =
    useState<string>("");
  const [caseReportHospitalLocation, setCaseReportHospitalLocation] =
    useState<string>("");
  const [
    caseReportHospitalLocationIsDisabled,
    setCaseReportHospitalLocationIsDisabled,
  ] = useState(true);
  const [caseReportHospitalRoom, setCaseReportHospitalRoom] =
    useState<string>("");
  const [
    caseReportHospitalRoomIsDisabled,
    setCaseReportHospitalRoomIsDisabled,
  ] = useState(true);

  const [caseReportTest, setCaseReportTest] = useState<string>("");
  const [caseReportResult, setCaseReportResult] = useState<string>("");

  const [caseReportDateTest, setCaseReportDateTest] = useState<string>("");
  const [caseReportNAATDate, setCaseReportNAATDate] = useState<string>("");
  const [caseReportHivAgAbDate, setCaseReportHivAgAbDate] =
    useState<string>("");
  const [caseReportHivIaDate, setCaseReportHivIaDate] = useState<string>("");
  const [caseReportDisclosedDate, setCaseReportDisclosedDate] =
    useState<string>("");
  const [caseReportInCareDate, setCaseReportInCareDate] = useState<string>("");
  const [caseReportRPRTest, setCaseReportRPRTest] = useState<string>("");
  const [caseReportRPRTestDetail, setCaseReportRPRTestDetail] =
    useState<string>("");
  const [
    caseReportRPRTestDetailIsDisabled,
    setCaseReportRPRTestDetailIsDisabled,
  ] = useState(true);

  const [caseReportTPPATest, setCaseReportTPPATest] = useState<string>("");
  const [caseReportTPPATestDetail, setCaseReportTPPATestDetail] =
    useState<string>("");
  const [
    caseReportTPPATestDetailIsDisabled,
    setCaseReportTPPATestDetailIsDisabled,
  ] = useState(true);

  const [caseReportFTAABSTest, setCaseReportFTAABSTest] = useState<string>("");
  const [caseReportFTAABSTestDetail, setCaseReportFTAABSTestDetail] =
    useState<string>("");
  const [
    caseReportFTAABSTestDetailIsDisabled,
    setCaseReportFTAABSTestDetailIsDisabled,
  ] = useState(true);

  const [caseReportEIATest, setCaseReportEIATest] = useState<string>("");
  const [caseReportEIATestDetail, setCaseReportEIATestDetail] =
    useState<string>("");
  const [
    caseReportEIATestDetailIsDisabled,
    setCaseReportEIATestDetailIsDisabled,
  ] = useState(true);

  const [caseReport200Test, setCaseReport200Test] = useState<string>("");
  const [caseReport200TestDetail, setCaseReport200TestDetail] =
    useState<string>("");
  const [
    caseReport200TestDetailIsDisabled,
    setCaseReport200TestDetailIsDisabled,
  ] = useState(true);

  const [caseReport300Test, setCaseReport300Test] = useState<string>("");
  const [caseReport300TestDetail, setCaseReport300TestDetail] =
    useState<string>("");
  const [
    caseReport300TestDetailIsDisabled,
    setCaseReport300TestDetailIsDisabled,
  ] = useState(true);

  const [caseReportNAAT, setCaseReportNAAT] = useState<string>("");
  const [caseReportHIVAGAB, setCaseReportHIVAGAB] = useState<string>("");
  const [caseReportHIVIA, setCaseReportHIVIA] = useState<string>("");
  const [caseReportDisclosed, setCaseReportDisclosed] = useState<string>("");
  const [caseReportInCare, setCaseReportInCare] = useState<string>("");
  const [caseReportMedication, setCaseReportMedication] = useState<string>("");
  const [showTestingInformationError, setShowTestingInformationError] = useState(true);
  const [linkageCareStatus, setLinkageCareStatus] = useState<string>("");
  const [linkageCareStatusOtherDetails, setLinkageCareStatusOtherDetails] = useState<string>("");
  const [linkageToCareStatusForHivDiagnosis, setLinkageToCareStatusForHivDiagnosis] = useState<string>("");

  const [caseReportDateLabs, setCaseReportDateLabs] = useState<string>("");
  const [lastUpdatedDate, setLastUpdatedDate] = useState({
    lastViralLoad: "",
    lastCd4: ""
  });

  const [caseReportPregnant, setCaseReportPregnant] = useState<string>("");
  const [caseReportPregnantIsDisabled, setCaseReportPregnantIsDisabled] =
    useState(true);

  const [caseReportEDD, setCaseReportEDD] = useState<string>("");
  const [caseReportEDDIsDisabled, setCaseReportEDDIsDisabled] = useState(true);
  const [caseReportDetailsDisableGonnorhea, setcaseReportDetailsDisableGonnorhea] = useState(true)

  const [caseReportDateLMP, setCaseReportDateLMP] = useState<string>("");
  const [caseReportDateLMPIsDisabled, setCaseReportDateLMPIsDisabled] =
    useState(true);

  const [caseReportAdditionalNotes, setCaseReportAdditionalNotes] =
    useState<string>("");
  const [caseReportDOHNotes, setCaseReportDOHNotes] = useState<string>("");

  const [showNewCase, setShowNewCase] = useState(true);
  const { postByObject: postCaseReportUpdate } = usePost<
    ApiResponse,
    CaseReportFormRequest
  >("Client/add/casereport", "POST");

  const [addressDisable, setAddressDisable] = useState(false);
  const [addressDisableNewCase, setAddressDisableNewCase] = useState(false);

  const [addressType, setAddressType] = useState<string>("");
  const [addressTypeNewCase, setAddressTypeNewCase] = useState<string>("");

  // const [showPatientInfo, setShowPatientInfo] = useState<boolean>(false);

  const [isClientInfoSubmitting, setIsClientInfoSubmitting] =
    useState<boolean>(false);
  const [isCaseReportSubmitting, setIsCaseReportSubmitting] =
    useState<boolean>(false);
  const [caseReportRPRSpecimanID, setcaseReportRPRSpecimanID] = useState<string>("");
  const [caseReportRPRSpecimanDate, setcaseReportRPRSpecimanDate] = useState<string>("");
  const [caseReportVDRLSpecimanID, setcaseReportVDRLSpecimanID] = useState<string>("");
  const [caseReportVDRLSpecimanDate, setcaseReportVDRLSpecimanDate] = useState<string>("");
  const [caseReportVDRLTiter, setcaseReportVDRLTiter] = useState<string>("");
  const [caseReportTPPASpecimanID, setcaseReportTPPASpecimanID] = useState<string>("");
  const [caseReportTPPASpecimanDate, setcaseReportTPPASpecimanDate] = useState<string>("");
  const [caseReportFTAABSSpecimanID, setcaseReportFTAABSpecimanID] = useState<string>("");
  const [caseReportFTAABSSpecimanDate, setcaseReportFTAABSpecimanDate] = useState<string>("");
  const [caseReportEIAIgGSpecimenID, setCaseReportEIAIgGSpecimenID] = useState<string>("");
  const [caseReportEIAIgGSpecimenDate, setCaseReportEIAIgGSpecimenDate] = useState<string>("");
  const [caseReportChlamydiaSpecimanID, setcaseReportChlamydiaSpecimanID] = useState<string>("");
  const [caseReportChlamydiaSpecimanDate, setcaseReportChlamydiaSpecimanDate] = useState<string>("");
  const [caseReportGonorrheaSpecimanID, setcaseReportGonorrheaSpecimanID] = useState<string>("");
  const [caseReportGonorrheaSpecimanDate, setcaseReportGonorrheaSpecimanDate] = useState<string>("");
  const [detailsToRPRTest, setdetailsToRPRTest] = useState<string>("");
  const [detailsToVDRLTest, setdetailsToVDRLTest] = useState<string>("");
  const [detailsToTPPATest, setdetailsToTPPATest] = useState<string>("");
  const [detailsToFTAABSTest, setdetailsToFTAABSTest] = useState<string>("");
  const [detailsToEIAIgGTest, setDetailsToEIAIgGTest] = useState<string>("");
  const [detailsToChlamydiaTest, setdetailsToChlamydiaTest] = useState<string>("");
  const [detailsGonorrheaTest, setdetailsToGonorrheaTest] = useState<string>("");
  const [titer, setTiter] = useState<string>("")

  //New saving logic for STD test type and result
  const [rPR_Type, setRPR_Type] = useState<string>("");
  const [rPR_Result, setRPR_Result] = useState<string>("");
  const [vDRL_Type, setVDRL_Type] = useState<string>("");
  const [vDRL_Result, setVDRL_Result] = useState<string>("");

  const [tPPA_Type, setTPPA_Type] = useState<string>("");
  const [tPPA_Result, setTPPA_Result] = useState<string>("");
  const [fTAABS_Type, setFTAABS_Type] = useState<string>("");
  const [eIAIgG_Type, setEIAIgG_Type] = useState<string>("");
  const [fTAABS_Result, setFTAABS_Result] = useState<string>("");
  const [eIAIgG_Result, setEIAIgG_Result] = useState<string>("");

  const [chlamydia_Type, setChlamydia_Type] = useState<string>("");
  const [chlamydia_Result, setChlamydia_Result] = useState<string>("");
  const [gonorrhea_Type, setGonorrhea_Type] = useState<string>("");
  const [gonorrhea_Result, setGonorrhea_Result] = useState<string>("");

  // Updated STD Info
  const [UpdatedRprType, setUpdatedRprType] = useState<string>("");
  const [UpdatedRprType1, setUpdatedRprType1] = useState<string>("");
  const [UpdatedRprSpecimenCollectionDate, setUpdatedRprSpecimenCollectionDate] = useState<string>("");
  const [UpdatedRprSpecimenId, setUpdatedRprSpecimenId] = useState<string>("");
  const [UpdatedRprDetails, setUpdatedRprDetails] = useState<string>("");
  const [UpdatedRprTiter, setUpdatedRprTiter] = useState<string>("");

  const [UpdatedVdrlType, setUpdatedVdrlType] = useState<string>("");
  const [UpdatedVdrlType1, setUpdatedVdrlType1] = useState<string>("");
  const [UpdatedVdrlSpecimenCollectionDate, setUpdatedVdrlSpecimenCollectionDate] = useState<string>("");
  const [UpdatedVdrlSpecimenId, setUpdatedVdrlSpecimenId] = useState<string>("");
  const [UpdatedVdrlDetails, setUpdatedVdrlDetails] = useState<string>("");
  const [UpdatedVdrlTiter, setUpdatedVdrlTiter] = useState<string>("");

  const [UpdatedTpPaType, setUpdatedTpPaType] = useState<string>("");
  const [UpdatedTpPaType1, setUpdatedTpPaType1] = useState<string>("");
  const [UpdatedTpPaSpecimenCollectionDate, setUpdatedTpPaSpecimenCollectionDate] = useState<string>("");
  const [UpdatedTpPaSpecimenId, setUpdatedTpPaSpecimenId] = useState<string>("");
  const [UpdatedTpPaDetails, setUpdatedTpPaDetails] = useState<string>("");

  const [UpdatedFtaAbsType, setUpdatedFtaAbsType] = useState<string>("");
  const [UpdatedFtaAbsType1, setUpdatedFtaAbsType1] = useState<string>("");
  const [UpdatedFtaAbsSpecimenCollectionDate, setUpdatedFtaAbsSpecimenCollectionDate] = useState<string>("");
  const [UpdatedFtaAbsSpecimenId, setUpdatedFtaAbsSpecimenId] = useState<string>("");
  const [UpdatedFtaAbsDetails, setUpdatedFtaAbsDetails] = useState<string>("");

  const [UpdatedEiaType, setUpdatedEiaType] = useState<string>("");
  const [UpdatedEiaType1, setUpdatedEiaType1] = useState<string>(""); // for "Other"
  const [UpdatedEiaSpecimenCollectionDate, setUpdatedEiaSpecimenCollectionDate] = useState<string>("");
  const [UpdatedEiaSpecimenId, setUpdatedEiaSpecimenId] = useState<string>("");
  const [UpdatedEiaDetails, setUpdatedEiaDetails] = useState<string>("");

  const [UpdatedChlamydiaType, setUpdatedChlamydiaType] = useState<string>("");
  const [UpdatedChlamydiaType1, setUpdatedChlamydiaType1] = useState<string>("");
  const [UpdatedChlamydiaDate, setUpdatedChlamydiaDate] = useState<string>("");
  const [UpdatedChlamydiaSpecimenId, setUpdatedChlamydiaSpecimenId] = useState<string>("");
  const [UpdatedChlamydiaDetails, setUpdatedChlamydiaDetails] = useState<string>("");

  const [UpdatedGonorrheaType, setUpdatedGonorrheaType] = useState<string>("");
  const [UpdatedGonorrheaType1, setUpdatedGonorrheaType1] = useState<string>("");
  const [UpdatedGonorrheaSpecimenCollectionDate, setUpdatedGonorrheaSpecimenCollectionDate] = useState<string>("");
  const [UpdatedGonorrheaSpecimenId, setUpdatedGonorrheaSpecimenId] = useState<string>("");
  const [UpdatedGonorrheaDetails, setUpdatedGonorrheaDetails] = useState<string>("");

  //New save logic - have to delete the above logic later
  const [updatedRPR_Type, setupdatedRPR_Type] = useState<string>("");
  const [updatedRPR_Result, setupdatedRPR_Result] = useState<string>("");
  const [updatedVDRL_Type, setupdatedVDRL_Type] = useState<string>("");
  const [updatedVDRL_Result, setupdatedVDRL_Result] = useState<string>("");

  const [updatedTPPA_Type, setupdatedTPPA_Type] = useState<string>("");
  const [updatedTPPA_Result, setupdatedTPPA_Result] = useState<string>("");
  const [updatedFTAABS_Type, setupdatedFTAABS_Type] = useState<string>("");
  const [updatedFTAABS_Result, setupdatedFTAABS_Result] = useState<string>("");
  const [updatedEIA_Type, setupdatedEIA_Type] = useState<string>("");
  const [updatedEIA_Result, setupdatedEIA_Result] = useState<string>("");

  const [updatedChlamydia_Type, setupdatedChlamydia_Type] = useState<string>("");
  const [updatedChlamydia_Result, setupdatedChlamydia_Result] = useState<string>("");
  const [updatedGonorrhea_Type, setupdatedGonorrhea_Type] = useState<string>("");
  const [updatedGonorrhea_Result, setupdatedGonorrhea_Result] = useState<string>("");

  const hasMedicalData =
    Boolean(caseReportDatePresented) ||
    Boolean(caseReportDateDischarged) ||
    Boolean(caseReportChiefComplaint) ||
    Boolean(caseReportSymptoms) ||
    Boolean(caseReportHospitalAdmit);

  const [isMedicalInfoCollapsed, setIsMedicalInfoCollapsed] = useState(true);

  useEffect(() => {
    if (hasMedicalData) {
      setIsMedicalCollapsed(false);
    } else {
      setIsMedicalCollapsed(false);
    }
  }, [
    hasMedicalData
  ]);
  const toggleInfoMedical = () => {
    setIsMedicalInfoCollapsed(prev => !prev);
  };

  const hasTestingData =
    Boolean(caseReportHIVIA) ||
    Boolean(caseReportHIVAGAB) ||
    Boolean(caseReportNAAT);
  const [isTestingInfoCollapsed, setIsTestingInfoCollapsed] = useState(true);
  useEffect(() => {
    if (hasTestingData) {
      setIsTestingInfoCollapsed(false);   // expand when any field has data
    } else {
      setIsTestingInfoCollapsed(true);    // collapse when all fields empty
    }
  }, [
    hasTestingData
  ]);
  const toggleTestingInfo = () => {
    setIsTestingInfoCollapsed(prev => !prev);
  };

  const hasHivData =
    Boolean(clientInfoHIVReportedDate) ||
    Boolean(clientInfoAidsDate) ||
    Boolean(clientInfoHivDateOfDiagnosis) ||
    Boolean(lastUpdatedDate.lastCd4) ||
    Boolean(lastUpdatedDate.lastViralLoad);
  const [isHivDetailsCollapsed, setIsHivDetailsCollapsed] = useState(true);
  useEffect(() => {
    if (hasHivData) {
      setIsHivDetailsCollapsed(false);   // expand when any field has data
    } else {
      setIsHivDetailsCollapsed(true);    // collapse when all fields empty
    }
  }, [
    hasHivData
  ]);
  const toggleHivDetails = () => {
    setIsHivDetailsCollapsed(prev => !prev);
  };

  const hasUpdatedHivData =
    Boolean(updatedLastUpdatedDate.dateOfDiagnosis) ||
    Boolean(updatedLastUpdatedDate.lastViralLoad) ||
    Boolean(updatedLastUpdatedDate.lastCd4) ||
    Boolean(UpdateClientInfoHIVReportedDate) ||
    Boolean(UpdateClientInfoAidsDate);
  const [isUpdatedHivCollapsed, setIsUpdatedHivCollapsed] = useState(true);
  useEffect(() => {
    if (hasUpdatedHivData) {
      setIsUpdatedHivCollapsed(false);   // expand when any field has data
    } else {
      setIsUpdatedHivCollapsed(true);    // collapse when all fields empty
    }
  }, [
    hasUpdatedHivData
  ]);
  const toggleUpdatedHiv = () => {
    setIsUpdatedHivCollapsed(prev => !prev);
  };

  const hasSyphilisTreatmentData = syphilisTreatmentHistory.length > 0;
  const [isSyphilisTreatmentCollapsed, setIsSyphilisTreatmentCollapsed] = useState(true);
  useEffect(() => {
    setIsSyphilisTreatmentCollapsed(!hasSyphilisTreatmentData);
  }, [
    hasSyphilisTreatmentData
  ]);
  const toggleSyphilisTreatment = () => {
    setIsSyphilisTreatmentCollapsed(prev => !prev);
  };

const hasStdData =
  Boolean(caseReportRPRSpecimanDate) ||
  Boolean(caseReportVDRLSpecimanDate) ||
  Boolean(caseReportTPPASpecimanDate) ||
  Boolean(caseReportFTAABSSpecimanDate) ||
  Boolean(caseReportEIAIgGSpecimenDate) ||
  Boolean(caseReportChlamydiaSpecimanDate) ||
  Boolean(caseReportGonorrheaSpecimanDate);

const toHistoricalStdRows = (
  rows: DiseaseHistoryRow[]
): StdTestInformationRow[] =>
  rows.map((row, index) => ({
    specimenDate: row.testSpecimenDate,
    specimenId: row.specimenId,
    details: row.qualitativeResult,
    titer: row.quantitativeResult,
    historyNumber: row.testHistoryRowNum
      ? row.testHistoryRowNum - 1
      : index + 1,
  }));

const createStdTestGroup = (
  testName: string,
  currentRow: StdTestInformationRow,
  historicalRows: DiseaseHistoryRow[]
): StdTestInformationGroup => ({
  testName,
  rows: [
    ...(currentRow.specimenDate ||
    currentRow.specimenId ||
    currentRow.details ||
    currentRow.titer
      ? [currentRow]
      : []),
    ...toHistoricalStdRows(historicalRows),
  ],
});

const stdTestInformationGroups: StdTestInformationGroup[] = [
  createStdTestGroup(
    "RPR Test Information",
    {
      specimenDate: caseReportRPRSpecimanDate,
      specimenId: caseReportRPRSpecimanID,
      details: detailsToRPRTest,
      titer: rprTestInfo.titer,
    },
    historicalRPR
  ),
  createStdTestGroup(
    "CSF-VDRL Test Information",
    {
      specimenDate: caseReportVDRLSpecimanDate,
      specimenId: caseReportVDRLSpecimanID,
      details: detailsToVDRLTest,
      titer: caseReportVDRLTiter,
    },
    historicalVDRL
  ),
  createStdTestGroup(
    "TP-PA Information",
    {
      specimenDate: caseReportTPPASpecimanDate,
      specimenId: caseReportTPPASpecimanID,
      details: detailsToTPPATest,
    },
    historicalTPPA
  ),
  createStdTestGroup(
    "FTA-ABS Information",
    {
      specimenDate: caseReportFTAABSSpecimanDate,
      specimenId: caseReportFTAABSSpecimanID,
      details: detailsToFTAABSTest,
    },
    historicalFTAABS
  ),
  createStdTestGroup(
    "EIA Information",
    {
      specimenDate: caseReportEIAIgGSpecimenDate,
      specimenId: caseReportEIAIgGSpecimenID,
      details: detailsToEIAIgGTest,
    },
    historicalEIAIgG
  ),
  createStdTestGroup(
    "Chlamydia [200] Test Information",
    {
      specimenDate: caseReportChlamydiaSpecimanDate,
      specimenId: caseReportChlamydiaSpecimanID,
      details: detailsToChlamydiaTest,
    },
    historicalChlamydia
  ),
  createStdTestGroup(
    "Gonorrhea [300] Test Information",
    {
      specimenDate: caseReportGonorrheaSpecimanDate,
      specimenId: caseReportGonorrheaSpecimanID,
      details: detailsGonorrheaTest,
    },
    historicalGonorrhea
  ),
];

const hasHistoricalStdData =
  historicalRPR.length > 0 ||
  historicalVDRL.length > 0 ||
  historicalTPPA.length > 0 ||
  historicalFTAABS.length > 0 ||
  historicalEIAIgG.length > 0 ||
  historicalChlamydia.length > 0 ||
  historicalGonorrhea.length > 0;

  const [isStdCollapsed, setIsStdCollapsed] = useState(true);
useEffect(() => {
  if (hasStdData || hasHistoricalStdData) {
    setIsStdCollapsed(false);   // expand when any field has data
  } else {
    setIsStdCollapsed(true);    // collapse when all fields empty
  }
}, [
  hasStdData,
  hasHistoricalStdData
]);
const toggleStd = () => {
  setIsStdCollapsed(prev => !prev);
};

  const hasUpdatedStdData =
    Boolean(UpdatedRprSpecimenCollectionDate) ||
    Boolean(UpdatedVdrlSpecimenCollectionDate) ||
    Boolean(UpdatedTpPaSpecimenCollectionDate) ||
    Boolean(UpdatedFtaAbsSpecimenCollectionDate) ||
    Boolean(UpdatedEiaSpecimenCollectionDate) ||
    Boolean(UpdatedChlamydiaDate) ||
    Boolean(UpdatedGonorrheaSpecimenCollectionDate);
  const [isUpdatedStdCollapsed, setIsUpdatedStdCollapsed] = useState(true);
  useEffect(() => {
    if (hasUpdatedStdData) {
      setIsUpdatedHivCollapsed(false);   // expand when any field has data
    } else {
      setIsUpdatedHivCollapsed(true);    // collapse when all fields empty
    }
  }, [
    hasUpdatedStdData
  ]);
  const toggleUpdatedStd = () => {
    setIsUpdatedStdCollapsed(prev => !prev);
  };

  const caseReportRef = useRef<HTMLDivElement>(null);

  useEffect(() => {

  }, [newCaseKey]);
  const handleAddCaseReport = () => {
    // handleSearchClear();
    handleCaseReportClear();
    //setNewCaseKey("0");
    setCaseReportSource(source);
    setCaseReportFirstName(firstName);
    setCaseReportLastName(lastName);
    setCaseReportDOB(dob);
    setCaseReportBirthGender(birthGender);
    setNewCaseKey(true);



    setIsSearchTableVisible(false);
    setTimeout(() => {
      if (caseReportRef.current) {
        requestAnimationFrame(() => {
          caseReportRef.current?.focus({ preventScroll: true });
          caseReportRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        });
      }
    }, 750);
  };

  const { getDataById: getRoutinizedFacilities } = useGetData<
    RoleData[],
    string
  >("Client/RoutinizedFacilities", "GET");

  const handleRoutinizedHospitalChange = async (e: any) => {
    const selectedHospital = e.target.value;
    setCaseReportSelectedRoutinizedHospital(e.target.value);
    setCaseReportOtherFacilityDetailIsDisabled(true);
    setCaseReportSetOtherFacilityDetail("");

    setCaseReportSelectedRoutinizedFacility("");
    if (selectedHospital == "0") {
      setFilteredRoutinizedFacilities([]);
    } else {
      try {
        const facilityData = await getRoutinizedFacilities(
          `${selectedHospital}`
        );

        if (facilityData) {
          const mappedFacilities = mapToSelectOptions(facilityData);
          setFilteredRoutinizedFacilities([
            { id: "0", value: "----- Select Routinized Facilities -----" },
            ...mappedFacilities,
          ]);
        }
      } catch (error) {
        setFilteredRoutinizedFacilities([]);
      }
    }
  };

  const handleRoutinizedFacilityChange = (e: any) => {
    setCaseReportSelectedRoutinizedFacility(e.target.value);
    const selectedOption = e.target.options[e.target.selectedIndex];
    const dataValue = selectedOption.getAttribute("data-value");
    handleFormFieldChange(e);
    if (e.target.value === "Other" || dataValue === "Other") {
      // Enable Other Facility Textbox
      setCaseReportOtherFacilityDetailIsDisabled(false);
    } else {
      setCaseReportOtherFacilityDetailIsDisabled(true);
      setCaseReportSetOtherFacilityDetail("");
    }
  };

  const handleCaseReportStateChange = (event: any) => {
    setCaseReportStateId(event.target.value);
    handleFormFieldChange(event);
    setCaseReportCountyId("OUT OF STATE")

  };

  const handleCaseReportCountyChange = (event: any) => {
    setCaseReportCountyId(event.target.value);
    handleFormFieldChange(event);
  };

  // Test Flags Change events -- Start

  const handleRPRTestChange = (e: any) => {
    setCaseReportRPRTest(e.target.value);

    if (e.target.value === "Specify Results") {
      setCaseReportRPRTestDetailIsDisabled(false);
    } else {
      setCaseReportRPRTestDetailIsDisabled(true);
      setCaseReportRPRTestDetail("");
    }
  };

  const handleTPPATestChange = (e: any) => {
    setCaseReportTPPATest(e.target.value);

    if (e.target.value === "Specify Results") {
      setCaseReportTPPATestDetailIsDisabled(false);
    } else {
      setCaseReportTPPATestDetailIsDisabled(true);
      setCaseReportTPPATestDetail("");
    }
  };

  const handleFTAABSTestChange = (e: any) => {
    setCaseReportFTAABSTest(e.target.value);

    if (e.target.value === "Specify Results") {
      setCaseReportFTAABSTestDetailIsDisabled(false);
    } else {
      setCaseReportFTAABSTestDetailIsDisabled(true);
      setCaseReportFTAABSTestDetail("");
    }
  };

  const handleEIATestChange = (e: any) => {
    setCaseReportEIATest(e.target.value);

    if (e.target.value === "Specify Results") {
      setCaseReportEIATestDetailIsDisabled(false);
    } else {
      setCaseReportEIATestDetailIsDisabled(true);
      setCaseReportEIATestDetail("");
    }
  };

  const handle200TestChange = (e: any) => {
    setCaseReport200Test(e.target.value);

    if (e.target.value === "Specify Results") {
      setCaseReport200TestDetailIsDisabled(false);
    } else {
      setCaseReport200TestDetailIsDisabled(true);
      setCaseReport200TestDetail("");
    }
  };

  const handle300TestChange = (e: any) => {
    setCaseReport300Test(e.target.value);

    if (e.target.value === "Specify Results") {
      setCaseReport300TestDetailIsDisabled(false);
    } else {
      setCaseReport300TestDetailIsDisabled(true);
      setCaseReport300TestDetail("");
    }
  };

  // Test Flags Change events -- End

  // Hospital Admit Change

  const handleHospitalAdmitChange = (e: any) => {
    setCaseReportHospitalAdmit(e.target.value);
    // handleFormFieldChange(e);
    if (e.target.value === "Yes") {
      setCaseReportHospitalLocationIsDisabled(false);
      setCaseReportHospitalRoomIsDisabled(false);
    } else {
      setCaseReportHospitalLocationIsDisabled(true);
      setCaseReportHospitalLocation("");

      setCaseReportHospitalRoomIsDisabled(true);
      setCaseReportHospitalRoom("");
    }
  };

  const handleAddressType = (e: any) => {
    const selectedValue = e.target.value;
    setAddressType(selectedValue);
    handleFormFieldChange(e);
    if (selectedValue === "Yes") {
      setClientInfoStreet1(clientData?.street);
      setClientInfoStreet2(clientData?.street2);
      setClientInfoCity(clientData?.city);
      setClientInfoZip(clientData?.zipCode);
      setClientInfoSelectedState(clientData?.stateId?.toString());
      setClientInfoSelectedCounty(clientData?.countyId?.toString());
    }
    if (selectedValue === "No" || selectedValue === "No1") {
      setAddressDisable(false); // Disable fields for "Homeless" or "Unknown"
      setClientInfoStreet1("");
      setClientInfoStreet2("");
      setClientInfoCity("");
      setClientInfoZip("");
      setClientInfoSelectedState(0);
      setClientInfoSelectedCounty("");
    } else {
      setAddressDisable(false); // Enable fields for other options which is "--""
    }
    setAddressType(e.target.value);
  };

  const handleAddressTypeNewCase = (e: any) => {
    const selectedValue = e.target.value;
    setAddressTypeNewCase(selectedValue);
    if (selectedValue === "Yes") {
      setCaseReportStreet1("");
      setCaseReportStreet2("");
      setCaseReportCity("");
      setCaseReportStateId("");
      setCaseReportCountyId("");
      setCaseReportZipCode("");
    }
    if (selectedValue === "No" || selectedValue === "No1") {
      setAddressDisableNewCase(false); // Disable fields for "Homeless" or "Unknown"
      setCaseReportStreet1("");
      setCaseReportStreet2("");
      setCaseReportCity("");
      setCaseReportStateId("");
      setCaseReportCountyId("");
      setCaseReportZipCode("");
    } else {
      setAddressDisableNewCase(false); // Enable fields for other options which is "--""
    }
    setAddressTypeNewCase(e.target.value);
    handleFormFieldChange(e);
  };

  // Birth Gender Change

  const handleCaseReportBirthGenderChange = (e: any) => {
    setCaseReportBirthGender(e.target.value);

    if (e.target.value === "Female") {
      setCaseReportPregnantIsDisabled(false);
      setCaseReportDateLMPIsDisabled(false);
    } else {
      setCaseReportPregnantIsDisabled(true);
      setCaseReportPregnant("");

      setCaseReportDateLMPIsDisabled(true);
      setCaseReportDateLMP("");
    }

    // Always reset EDD if birth gender changes. This is enabled for only when patient is female and pregnant
    setCaseReportEDDIsDisabled(true);
    setCaseReportEDD("");
  };

  // Pregnant Change

  const handlePregnantChange = (e: any) => {
    setCaseReportPregnant(e.target.value);
    handleFormFieldChange(e)
    if (e.target.value === "Yes") {
      setCaseReportEDDIsDisabled(false);
    } else {
      setCaseReportEDDIsDisabled(true);
      setCaseReportEDD("");
      setCaseReportDateLMP("");
    }
  };

  const handleCaseReportSave = async () => {
    setValue('isNew', true);

    //     if(addressTypeNewCase!=""){
    //     setValue('addressTypeDetail', addressTypeNewCase);
    //     setValue('addressTypeDetailNewCase',addressTypeNewCase);
    //     }else{
    // setValue('addressTypeDetail', " ");
    //     setValue('addressTypeDetailNewCase'," ");
    //     } 

    handleTouchAllFields(caseReportCreateFomrRef);
    if (isCaseReportSubmitting) {
      handleCaseReportClear();
      reset();
      setCaseReportErrorMessage(
        "New case report submitted successfully. CHD staff has been notified."
      );
      setErrorMessage("");
      toast.success("Case Report saved successfully!", {
        position: "top-right",
        autoClose: 2000,
      });
      setNewCaseKey(false);
      setIsCaseReportSubmitting(false);
      return;
    }
    setIsCaseReportSubmitting(true);
    let tpT = tPPA_Type;
    let tpR = tPPA_Result;
    await new Promise((resolve) => setTimeout(resolve, 0));
    setValue("tPPA_Type", tpT);
    setValue("tPPA_Result", tpR);
    setnewCaseReportValidationErrors({});
    let caseReportValues = getValues();
    // if(addressTypeNewCase==""){

    //   caseReportValues.addressTypeDetailNewCase="Yes";

    // }
    if (addressTypeNewCase == "No" || addressTypeNewCase == "No1") {
      caseReportValues.stateId = undefined;
      caseReportValues.countyId = undefined;
    } else {
      var countyIdData = caseReportCountyData.find(x => x.value == caseReportCountyId)?.id;
      caseReportValues.countyId = countyIdData

    }

    var stateIdData = caseReportStateData.find(x => x.value == caseReportStateId)?.id;
    caseReportValues.stateId = stateIdData

    caseReportValues.routinizedHospitalId =
      caseReportSelectedRoutinizedHospital;
    caseReportValues.routinizedFacilityId =
      caseReportSelectedRoutinizedFacility;
    if (caseReportValues.testRPR == "0"
      && caseReportValues.tppa == "0"
      && caseReportValues.ftaAbs == "0"
      && caseReportValues.Equine_infectious_anemia == "0"
      && caseReportValues.Chlamydia == ""
      && caseReportValues.Gonorrhea == "" && !isChecked
    ) {
      setError(true);
    } else {
      setError(false);

    }

    const caseReportValidationResult = NewCaseReportValidationSchema.validate(
      caseReportValues,
      { abortEarly: false }
    );

    caseReportValidationResult
      .then(async (validatedData) => {
        if (!showTestingInformationError) {
          toast.error('Enter at least one test information', { position: 'top-right', autoClose: 2000 });
          setIsCaseReportSubmitting(false);
          const firstErrorElement = document.querySelector('[name=NAAT]');
          if (firstErrorElement)
            (firstErrorElement as HTMLElement).focus();
          return;
        } else {
          if (isError) {
            setIsCaseReportSubmitting(false);
            return;
          }
          const userConfirmed = window.confirm(
            "Please confirm if you would like to save?"
          );
          if (!userConfirmed) {
            setIsCaseReportSubmitting(false);
            return;
          }
          setIsLoader(true);
          const request: CaseReportFormRequest = {
            source: caseReportSource,
            firstName: caseReportFirstName,
            middleName: caseReportMiddleName || null,
            lastName: caseReportLastName,
            dob: caseReportDOB,
            birthGender: caseReportBirthGender,
            street1: caseReportStreet1,
            street2: caseReportStreet2,
            city: caseReportCity,
            stateId: parseInt(stateIdData ?? "0") || null,
            zipCode: caseReportZipCode,
            countyId: parseInt(countyIdData ?? "0") || null,
            ssn: caseReportLast4SSN || null,
            primaryPhone: caseReportPrimaryPhone,
            secondPhone: "", //Not Needed for case report
            comments: caseReportComments,
            erContactName: caseReportErContactPerson,
            relationshipId: caseReportErContactRelation,
            erContactPhone: caseReportErContactPhone,
            modeofTransmission: "", //Not Needed for case report
            hivdateofDiagnosis: clientInfoHivDateOfDiagnosis, //Not Needed for case report
            dateofLastDocumented: clientInfoDateOfLastDocumented, //Not Needed for case report
            viralLoad: clientInfoViralLoad,
            cd4count: clientInfoCD4Count,
            clientSource: "FLCareLookUp",
            sourceClientId: "", //Not Needed for case report
            clientId: "", //Not Needed for case report
            caseReportId: undefined, //should be null
            datePresented: caseReportDatePresented,
            dateDischarged: caseReportDateDischarged,
            chiefComplaint: caseReportChiefComplaint,
            symptoms: caseReportSymptoms,
            hospitalAdmit: caseReportHospitalAdmit === "Yes" ? true : false,
            hospitalLocation: caseReportHospitalLocation,
            hospitalRoom: caseReportHospitalRoom,
            dateTest: caseReportDateTest,
            rprTest: caseReportRPRTestDetail,
            tppaTest: caseReportTPPATestDetail,
            ftaAbsTest: caseReportFTAABSTestDetail,
            eiaTest: caseReportEIATestDetail,
            _200Test: caseReport200TestDetail,
            _300Test: caseReport300TestDetail,
            naat: caseReportNAAT,
            hivAgAb: caseReportHIVAGAB,
            hivIa: caseReportHIVIA,
            disclosed: caseReportDisclosed,
            inCare: caseReportInCare,
            isSelfReported: isPositiveTestResult,
            IsCaseReport: caseReportCheckBox,
            IsPositiveTest: isPositiveTestResult,
            medication: caseReportMedication,
            dateLabs: caseReportDateLabs,
            pregnantId: caseReportPregnant,
            edd: caseReportEDD,
            dateLmp: caseReportDateLMP,
            additionalNotes: clientAdditionalNotes,
            dohNotes: clientDOHNotes,
            routinizedHospitalId: caseReportSelectedRoutinizedHospital,
            routinizedFacilityId: caseReportSelectedRoutinizedFacility,
            medicalRecord: caseReportMedicalRecord,
            dateReceived: caseReportDateReceived,
            userId: account.name,
            naatDate: caseReportNAATDate,
            hivAgAbDate: caseReportHivAgAbDate,
            hivIaDate: caseReportHivIaDate,
            inCareDate: caseReportInCareDate,
            disclosedDate: caseReportDisclosedDate,
            linkageCareStatusId: linkageCareStatus,
            LinkageToCareStatus: linkageCareStatus,
            LinkageCareStatusOtherDetails: linkageCareStatusOtherDetails,
            linkageToCareStatusForHivDiagnosis: linkageToCareStatusForHivDiagnosis,
            rpR_Specimen_Collection_Date: caseReportRPRSpecimanDate,
            rpr_Specimen_ID: caseReportRPRSpecimanID,
            rpR_Details: detailsToRPRTest,
            rpR_Titer: titer,
            vdrL_Specimen_Collection_Date: caseReportVDRLSpecimanDate,
            vdrl_Specimen_ID: caseReportVDRLSpecimanID,
            vdrL_Details: detailsToVDRLTest,
            vdrL_Titer: caseReportVDRLTiter,
            ftA_ABS_Specimen_Collection_Date: caseReportFTAABSSpecimanDate,
            fta_ABS_Specimen_ID: caseReportFTAABSSpecimanID,
            ftA_ABS_Details: detailsToFTAABSTest,
            fTA_ABS_Titer: '',
            EIA_IgG_Specimen_Collection_Date: caseReportEIAIgGSpecimenDate,
            EIA_IgG_Specimen_ID: caseReportEIAIgGSpecimenID,
            EIA_IgG_Details: detailsToEIAIgGTest,
            EIA_IgG_Titer: "",
            chlamydia_Details: detailsToChlamydiaTest,
            chlamydiaDate: caseReportChlamydiaSpecimanDate,
            chlamydiaSpecimen_ID: caseReportChlamydiaSpecimanID,
            chlamydia_Titer: '',
            gonorrhea_Details: detailsGonorrheaTest,
            gonorrhea_Specimen_Collection_Date: caseReportGonorrheaSpecimanDate,
            gonorrhea_Specimen_ID: caseReportGonorrheaSpecimanID,
            gonorrhea_Titer: '',
            tP_PA_details: detailsToTPPATest,
            tP_PA_Specimen_collection_date: caseReportTPPASpecimanDate,
            tp_PA_Specimen_ID: caseReportTPPASpecimanID,
            last_viral_load_date: lastUpdatedDate.lastViralLoad,
            last_cd4_count_date: lastUpdatedDate.lastCd4,


            AIDSDate: clientInfoAidsDate,
            HIVReportedDate: clientInfoHIVReportedDate,
            HIVModeOfTransmissionId: clientInfoHIVModeOfTransmissionId,

            rPR_Type: rPR_Type,
            rPR_Result: rPR_Result,
            vDRL_Type: vDRL_Type,
            vDRL_Result: vDRL_Result,
            tPPA_Type: tPPA_Type,
            tPPA_Result: tPPA_Result,
            fTAABS_Type: fTAABS_Type,
            fTAABS_Result: fTAABS_Result,
            eIAIgG_Type: eIAIgG_Type,
            eIAIgG_Result: eIAIgG_Result,
            chlamydia_Type: chlamydia_Type,
            chlamydia_Result: chlamydia_Result,
            gonorrhea_Type: gonorrhea_Type,
            gonorrhea_Result: gonorrhea_Result,
          };

          try {
            const resp = await postCaseReportUpdate(request);

            // setIsPositiveTestResult(false);
            handleCaseReportClear();
            reset();
            setCaseReportErrorMessage(
              "New case report submitted successfully. CHD staff has been notified."
            );
            setErrorMessage("");
            toast.success("Case Report saved successfully!", {
              position: "top-right",
              autoClose: 2000,
            });
            setNewCaseKey(false);
            setIsCaseReportSubmitting(false);
            setIsLoader(false);
              if (resp && resp.status == 200) {
          window.scrollTo({ top: 0, behavior: "smooth" });
          
          setIsSearchTableVisible(true);
          setIsTableVisible(false);

          await new Promise((resolve) => setTimeout(resolve, 100));
          setSource(source);
          setFirstName("");
          setLastName("");
          setBirthGender("");
          setDob("");
          setSearchResults([]);
          setShowPatientInfo(false);
          setIsNavCollapsed(prev => !prev);
        }
          } catch (error) {
            setIsLoader(false);
            toast.error("An Error Occured while saving Case Report.", {
              position: "top-right",
              autoClose: 2000,
            });
            setIsCaseReportSubmitting(false);
          }
        }
      })
      .catch((ValidationErrors) => {
        setIsLoader(false);
        const newCaseReportValidationErrors: { [key: string]: string } = {};
        ValidationErrors.inner.forEach((err: any) => {
          newCaseReportValidationErrors[err.path] = err.message;
        });
        setnewCaseReportValidationErrors(newCaseReportValidationErrors);

        // toast.error("An Error Occured while saving Case Report.", {
        //   position: "top-right",
        //   autoClose: 2000,
        // });
        setIsCaseReportSubmitting(false);

        // focus on the first invalid field
        const firstErrorField = Object.keys(newCaseReportValidationErrors)[0];
        const firstErrorElement = document.querySelector(
          `[name="${firstErrorField}"]`
        );

        if (firstErrorElement) {
          (firstErrorElement as HTMLElement).focus();
        }
      });

    setCaseReportErrorMessage("");
  };

  const handleCaseReportClear = () => {
    setnewCaseReportValidationErrors({});
    setClientInfoErrorMessage("");
    setCaseReportErrorMessage("");

    setCaseReportSelectedRoutinizedHospital("");
    setCaseReportSelectedRoutinizedFacility("");

    setCaseReportSetOtherFacilityDetail(""); // Need to add column in DB
    setCaseReportOtherFacilityDetailIsDisabled(true);

    setCaseReportMedicalRecord("");
    setCaseReportDateReceived("");

    setCaseReportSource("");
    setCaseReportFirstName("");
    setCaseReportLastName("");
    setCaseReportMiddleName("");
    setCaseReportDOB("");
    setCaseReportBirthGender("");
    setCaseReportLast4SSN("");

    setCaseReportStreet1("");
    setCaseReportStreet2("");
    setCaseReportCity("");
    setCaseReportStateId("");
    setCaseReportCountyId("");
    setCaseReportZipCode("");
    setCaseReportPrimaryPhone("");

    setCaseReportErContactPerson("");
    setCaseReportErContactRelation("");
    setCaseReportErContactPhone("");
    setCaseReportComments("");
    setCaseReportDatePresented("");
    setCaseReportDateDischarged("");
    setCaseReportChiefComplaint("");
    setCaseReportDateSymptoms("");

    setCaseReportHospitalAdmit("");
    setCaseReportHospitalLocation("");
    setCaseReportHospitalLocationIsDisabled(true);
    setCaseReportHospitalRoom("");
    setCaseReportHospitalRoomIsDisabled(true);

    setCaseReportDateTest("");

    setCaseReportRPRTest("");
    setCaseReportRPRTestDetail("");
    setCaseReportRPRTestDetailIsDisabled(true);

    setCaseReportTPPATest("");
    setCaseReportTPPATestDetail("");
    setCaseReportTPPATestDetailIsDisabled(true);

    setCaseReportFTAABSTest("");
    setCaseReportFTAABSTestDetail("");
    setCaseReportFTAABSTestDetailIsDisabled(true);

    setCaseReportEIATest("");
    setCaseReportEIATestDetail("");
    setCaseReportEIATestDetailIsDisabled(true);

    setCaseReport200Test("");
    setCaseReport200TestDetail("");
    setCaseReport200TestDetailIsDisabled(true);

    setCaseReport300Test("");
    setCaseReport300TestDetail("");
    setCaseReport300TestDetailIsDisabled(true);

    setCaseReportNAAT("");
    setCaseReportHIVAGAB("");
    setCaseReportHIVIA("");
    setCaseReportDisclosed("");
    setCaseReportInCare("");
    setCaseReportMedication("");
    setCaseReportNAATDate("");
    setCaseReportHivAgAbDate("");
    setCaseReportHivIaDate("");
    setCaseReportInCareDate("");
    setCaseReportDisclosedDate("");

    setCaseReportDateLabs("");
    setCaseReportPregnant("");
    setCaseReportPregnantIsDisabled(true);
    setCaseReportEDD("");
    setCaseReportEDDIsDisabled(true);
    setCaseReportDateLMP("");
    setCaseReportDateLMPIsDisabled(true);
    setCaseReportAdditionalNotes("");
    setCaseReportDOHNotes("");
    setcaseReportRPRSpecimanDate("");
    setcaseReportVDRLSpecimanDate("");
    setcaseReportFTAABSpecimanDate("");
    setCaseReportEIAIgGSpecimenDate("");
    setcaseReportTPPASpecimanDate("");
    setcaseReportChlamydiaSpecimanDate("");
    setcaseReportGonorrheaSpecimanDate("");
    setcaseReportRPRSpecimanID("");
    setcaseReportVDRLSpecimanID("");
    setcaseReportFTAABSpecimanID("");
    setcaseReportTPPASpecimanID("");
    setcaseReportChlamydiaSpecimanID("");
    setcaseReportGonorrheaSpecimanID("");
    setClientInfoHivDateOfDiagnosis('');
    setClientInfoAidsDate('');
    setClientInfoHIVReportedDate('');
    setClientInfoViralLoad('');
    setClientInfoCD4Count('');
    setClientInfoModeOfTransmissionId('');
    setLastUpdatedDate({ lastCd4: '', lastViralLoad: '' });
    setl2CName('');
    setNewCaseKey(false);

    setLinkageCareStatus("");

    //Updated HIV Diagnosis
    setUpdatedLastUpdatedDate((prev) => ({
      ...prev,
      dateOfDiagnosis: "",
      lastViralLoad: "",
      lastCd4: "",
    }));
    setUpdateClientInfoAidsDate("");
    setUpdateClientInfoHIVModeOfTransmissionId("");
    setUpdateClientInfoHIVReportedDate("");
    setUpdatedClientInfoViralLoad("");
    setUpdatedClientInfoCD4Count("");
    setSyphilisTreatmentHistory([]);

    //Updated STD Test Information
    setupdatedRPR_Type("");
    setUpdatedRprSpecimenCollectionDate("");
    setUpdatedRprSpecimenId("");
    setupdatedRPR_Result("");
    setUpdatedRprTiter("");

    setupdatedVDRL_Type("");
    setUpdatedVdrlSpecimenCollectionDate("");
    setUpdatedVdrlSpecimenId("");
    setupdatedVDRL_Result("");
    setUpdatedVdrlTiter("");

    setupdatedTPPA_Type("");
    setUpdatedTpPaSpecimenCollectionDate("");
    setUpdatedTpPaSpecimenId("");
    setupdatedTPPA_Result("");

    setupdatedFTAABS_Type("");
    setUpdatedFtaAbsSpecimenCollectionDate("");
    setUpdatedFtaAbsSpecimenId("");
    setupdatedFTAABS_Result("");

    setUpdatedEiaType("");
    setUpdatedEiaSpecimenCollectionDate("");
    setUpdatedEiaSpecimenId("");
    setUpdatedEiaDetails("");

    setupdatedChlamydia_Type("");
    setUpdatedChlamydiaDate("");
    setUpdatedChlamydiaSpecimenId("");
    setupdatedChlamydia_Result("");

    setupdatedGonorrhea_Type("");
    setUpdatedGonorrheaSpecimenCollectionDate("");
    setUpdatedGonorrheaSpecimenId("");
    setupdatedGonorrhea_Result("");

    //New client STD
    setRPR_Type("");
    setRPR_Result("");
    setcaseReportRPRSpecimanDate("");
    setcaseReportRPRSpecimanID("");
    setTiter("");

    setVDRL_Type("");
    setVDRL_Result("");
    setcaseReportVDRLSpecimanDate("");
    setcaseReportVDRLSpecimanID("");
    setcaseReportVDRLTiter("");

    setTPPA_Type("");
    setTPPA_Result("");
    setcaseReportTPPASpecimanDate("");
    setcaseReportTPPASpecimanID("");

    setFTAABS_Type("");
    setcaseReportFTAABSpecimanDate("");
    setcaseReportFTAABSpecimanID("");
    setFTAABS_Result("");

    setEIAIgG_Type("");
    setCaseReportEIAIgGSpecimenDate("");
    setCaseReportEIAIgGSpecimenID("");
    setEIAIgG_Result("");

    setChlamydia_Type("");
    setcaseReportChlamydiaSpecimanDate("");
    setcaseReportChlamydiaSpecimanID("");
    setChlamydia_Result("");

    setGonorrhea_Type("");
    setcaseReportGonorrheaSpecimanDate("");
    setcaseReportGonorrheaSpecimanID("");
    setGonorrhea_Result("");

    setClientAdditionalNotes("");
    setClientDOHNotes("");

  };

  const [isChecked, setIsChecked] = useState(false);
  const [isError, setError] = useState(false);
  const [isPositiveTestResult, setIsPositiveTestResult] = useState<boolean>(true);
  const [caseReportCheckBox, setCaseReportCheckBox] = useState<boolean>(false);
  const positiveTestResultRef = useRef({
    naat: true,
    disclosed: true,
    hivagab: true,
    incare: true,
    hivIa: true
  });
  const caseReportCheckBoxRef = useRef(false);

  const handleCheckboxChange = (e: { target: { checked: boolean | ((prevState: boolean) => boolean); }; }) => {
    setIsChecked(e.target.checked);
    console.log("Checkbox clicked:", e.target.checked);

  };

  const handleFirstnameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setFirstName(value);
    setWildCardSearch(true);
  }

  const handleOnTabChange = (key: string | null) => {
    setFirstName("");
    setLastName("");
    setDob("");
    setWildCardSearch(false);
    if (key?.toLowerCase() === 'wildcard search') {
      setWildCardSearch(true);
    }
    setShowNewCase(false);
    setErrorMessage("");
    if (searchResults && searchResults.length > 0)
      setSearchResults([]);
  }

  const wildCardTitle = (
    <span>
      Wildcard Search{' '}
      <OverlayTrigger
        placement="right"
        overlay={
          <Tooltip id="wildcard-tooltip" className="wildcard-tooltip">
            {wildCardSearchTitle}
          </Tooltip>
        }
      >
        <span style={{ cursor: 'pointer' }}>
          <InfoCircle color="blue" />
        </span>
      </OverlayTrigger>
    </span>
  );

  const handlePositiveTestResultSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    setIsPositiveTestResult(checked);
    if (checked) {
      setCaseReportCheckBox(false);
      caseReportCheckBoxRef.current = false;
    }
    setShowTestingInformationError(false);
  }

  const handleCaseReportCheckBoxSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    setShowTestingInformationError(true);

    setCaseReportCheckBox(checked);
    caseReportCheckBoxRef.current = checked;
    setCaseReportNAAT("");
    setCaseReportNAATDate('');
    setCaseReportDisclosed('');
    setCaseReportDisclosedDate('');
    setCaseReportHIVAGAB('');
    setCaseReportHivAgAbDate('');
    setCaseReportInCare('');
    setCaseReportInCareDate('');
    setCaseReportHIVIA('');
    setCaseReportHivIaDate('');
    setCaseReportMedication('');
    handleSectionValidation(false, false, false);
    if (!caseReportPregnant) {
      setValue("EditCaseIsPregnant", ' ')
    }
    if (checked) {
      setIsPositiveTestResult(false);

      // Reset form values
      setValue("NAAT", "");
      setValue("naatDate", "");
      setValue("Disclosed", "");
      setValue("disclosedDate", "")
      setValue("hivAgAb", "");
      setValue("hivAgAbDate", "");
      setValue("NewCaseInCare", "");
      setValue("inCareDate", "");
      setValue("hivIASupplemental", "");
      setValue("hivIaSupplementalDate", "");
    }
    const clientInfoValues = getValues();
    const clientInfoValidationResult = NewCaseReportValidationSchema.validate(
      clientInfoValues,
      { abortEarly: false }
    );

    setclientInfoValidationErrors({});

    clientInfoValidationResult.then(() => { })
      .catch((ValidationErrors) => {
        const tempClientInfoValidationErrors: { [key: string]: string } = {};
        ValidationErrors.inner.forEach((err: any) => {
          tempClientInfoValidationErrors[err.path] = err.message;
        });

        setclientInfoValidationErrors(tempClientInfoValidationErrors);
        setnewCaseReportValidationErrors(tempClientInfoValidationErrors);
      });
  }

  useEffect(() => {
    const requiredFields = [caseReportNAAT, caseReportDisclosed, caseReportHIVAGAB, caseReportInCare, caseReportHIVIA];
    const allFieldsInvalid = requiredFields.filter(item => item !== "0" && item != "" && item);
    setShowTestingInformationError(allFieldsInvalid.length > 0);
  }, [caseReportNAAT, caseReportDisclosed, caseReportHIVAGAB, caseReportInCare, caseReportHIVIA])

  const handleSectionValidation = (section1: boolean, section2: boolean, section3: boolean) => {
    setValue('section1', section1);
    setValue('section2', section2);
    setValue('section3', section3);
  }

  const handleFormFieldChange = (event: React.ChangeEvent<any>) => {
    const { name, value } = event.target;
    const fieldName = name as keyof caseReportSchema;
    setValue(fieldName, value, {
      shouldValidate: true,
      shouldDirty: true
    });

    NewCaseReportValidationSchema
      .validateAt(fieldName, { [fieldName]: value })
      .then(() => {
        setnewCaseReportValidationErrors(prev => {
          const newErrors = { ...prev };
          delete newErrors[fieldName];
          return newErrors;
        });
        setclientInfoValidationErrors(prev => {
          const newErrors = { ...prev };
          delete newErrors[fieldName];
          return newErrors;
        });
      })
      .catch((validationErrors) => {
        setnewCaseReportValidationErrors(prev => ({
          ...prev,
          [fieldName]: validationErrors.message
        }));
        setclientInfoValidationErrors(prev => ({
          ...prev,
          [fieldName]: validationErrors.message
        }));
      });
  }

  useEffect(() => {

    if (clientInfoStreet && clientInfoStreet.trim() !== "") {
      setAddressType("Yes");
      setValue("addressTypeDetailNewCase", "Yes");
    }
  }, [clientInfoStreet]);


  //  useEffect(() => {
  //   if (clientInfoStreet && clientInfoStreet.trim() !== "") {
  //     setAddressType("Yes"); // Home Address
  //     setAddressTypeNewCase("Yes")
  //    // setValue("addressTypeDetail","Yes")
  //   } else {
  //     setAddressType(""); // Or some other default value
  //   }
  // }, [clientInfoStreet]);

  const testingInformationTitle = (
    <div className="w-100">
      <div className="section-header">


        <span className="section-title">
          Testing Information{" "}
          {!showTestingInformationError && !caseReportCheckBoxRef.current ? (
            <span className="px-3 fs-6" style={{ color: "#ffcc00", fontWeight: 600 }}>
              Enter at least one test information
            </span>
          ) : null}
        </span>

        <div className="d-flex align-items-center" style={{ gap: "8px", marginRight: "12px" }}>
          <Form.Check
            type="checkbox"
            id="custom-checkbox"
            checked={isPositiveTestResult}
            onChange={handlePositiveTestResultSelect}
            style={{ paddingRight: "3px" }}
          />
          <span className="me-2" style={{ fontSize: "1rem" }}>
            T1: Positive Test Result
          </span>

          <Form.Check
            {...register("caseReportCheckBox")}
            type="checkbox"
            id="custom-checkbox"
            checked={caseReportCheckBox}
            onChange={handleCaseReportCheckBoxSelect}
          />
          <span className="me-2" style={{ fontSize: "1rem" }}>
            T2: Case Report
          </span>
        </div>

        <span
          onClick={toggleTestingInfo}
          className="section-toggle"
          title={isTestingInfoCollapsed ? "Expand" : "Collapse"}
          aria-label={isTestingInfoCollapsed ? "Expand" : "Collapse"}
        >
          {isTestingInfoCollapsed ? "+" : "−"}
        </span>

      </div>
    </div>
  )

  return (
    <>
      <input type="hidden" name="clientInfoSourceClientId" value={clientInfoSourceClientId}></input>
      {isLoader && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.3)", // semi-transparent gray
            zIndex: 9999, // high value to overlay all
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "auto", // ensure overlay captures clicks
          }}
        >
          <Loader />
        </div>
      )}

      <Container>
        <AppCard
          title={
            <div
              style={{ display: 'flex', alignItems: 'center', width: '100%', cursor: 'pointer' }}
              className="collapsible-card-header"
              onClick={handleSearchToggle}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  handleSearchToggle();
                }
              }}
              role="button"
              tabIndex={0}
              title={isSearchTableVisible ? "Collapse" : "Expand"}
              aria-label={`${isSearchTableVisible ? "Collapse" : "Expand"} Client Search`}
              aria-expanded={isSearchTableVisible}
            >
              <span>Client Search</span>
              {/* The Toggle Button */}
              <div style={{ marginLeft: 'auto' }}>
                <div
                  //variant="secondary" 
                  title={isSearchTableVisible ? "Collapse" : "Expand"}
                  aria-label={isSearchTableVisible ? "Collapse" : "Expand"}
                >
                  {isSearchTableVisible ? "-" : "+"}
                </div>
              </div>
            </div>
          }
          bottomMargin
        >
          {isSearchTableVisible && (
            <div>
              <form ref={clientSearchFormRef}>
                <Tabs defaultActiveKey="Client Search" className="mb-3" onSelect={handleOnTabChange}>
                  <Tab eventKey="Client Search" title="Client Search">
                    <Row className="mb-3">
                      <Col>
                        <AppLabel label={"Source"}></AppLabel>
                        <Form.Select
                          name="clientSearchSource"
                          value={source}
                          onChange={(e) => setSource(e.target.value)}>
                          {sourceOptions.map((opt) => (
                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                          ))}
                        </Form.Select>
                      </Col>
                      <Col>
                        <AppLabel label={"First Name"} required={!firstNameRequired && !lastNameRequired ? true : firstNameRequired}></AppLabel>
                        <Form.Control
                          {...clientSearchRegister("clientSearchFirstName")}
                          name="clientSearchFirstName"
                          type="text"
                          placeholder="First Name"
                          value={firstName}
                          onChange={(e) => {
                            setFirstName(e.target.value);
                            clientSearchRef.current.firstName = e.target.value;
                          }}
                          maxLength={30}
                        />
                        <div className="error m-0">
                          {clientSearchValidationErrors.clientSearchFirstName}
                        </div>
                      </Col>
                      <Col>
                        <AppLabel label={"Last Name"} required={!lastNameRequired && !firstNameRequired ? true : lastNameRequired}></AppLabel>
                        <Form.Control
                          {...clientSearchRegister("clientSearchLastName")}
                          name="clientSearchLastName"
                          type="text"
                          placeholder="Last Name"
                          value={lastName}
                          onChange={(e) => {
                            setLastName(e.target.value)
                            clientSearchRef.current.lastName = e.target.value;
                          }}
                          maxLength={30}
                        />
                        <div className="error m-0">
                          {clientSearchValidationErrors.clientSearchLastName}
                        </div>
                      </Col>
                      <Col>
                        <AppLabel label={"Date of Birth"} required></AppLabel>
                        <Form.Control
                          {...clientSearchRegister("clientSearchDateOfBirth")}
                          name="clientSearchDateOfBirth"
                          type="date"
                          value={dob}
                          onChange={(e) => setDob(e.target.value)}
                          max={maxDate} // Set the max attribute to today
                          min={minDate}
                        />
                        <div className="error m-0">
                          {clientSearchValidationErrors.clientSearchDateOfBirth}
                        </div>
                      </Col>
                      <Col>
                        <AppLabel label={"Birth Sex"}></AppLabel>
                        <Form.Select
                          value={birthGender}
                          onChange={(e) => setBirthGender(e.target.value)}
                        >
                          <option value="">Select Birth Sex</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                        </Form.Select>
                      </Col>
                    </Row>
                  </Tab>
                  <Tab eventKey="Wildcard Search" title={wildCardTitle}>
                    <Row className="mb-3">
                      <Col>
                        <AppLabel label={"Source"}></AppLabel>
                        <Form.Select
                          name="clientSearchSource"
                          value={source}
                          onChange={(e) => setSource(e.target.value)}
                        >
                          {sourceOptions.map((opt) => (
                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                          ))}
                        </Form.Select>
                      </Col>
                      <Col>
                        <AppLabel label={"First Name"} required></AppLabel>
                        <Form.Control
                          {...wildCardSearchRegister("clientSearchFirstName")}
                          name="clientSearchFirstName"
                          type="text"
                          placeholder="First Name"
                          value={firstName}
                          onChange={handleFirstnameChange}
                          maxLength={30}
                        />
                        <div className="error m-0">
                          {wildCardSearchValidationErrors.clientSearchFirstName}
                        </div>
                      </Col>
                      <Col>
                        <AppLabel label={"Date of Birth"} required></AppLabel>
                        <Form.Control
                          {...wildCardSearchRegister("clientSearchDateOfBirth")}
                          name="clientSearchDateOfBirth"
                          type="date"
                          value={dob}
                          onChange={(e) => setDob(e.target.value)}
                          max={maxDate} // Set the max attribute to today
                          min={minDate}
                        />
                        <div className="error m-0">
                          {wildCardSearchValidationErrors.clientSearchDateOfBirth}
                        </div>
                      </Col>
                    </Row>
                  </Tab>
                </Tabs>
              </form>
              <Row className="mb-3 justify-content-end">
                <div className="container d-flex justify-content-end align-items-center flex-wrap flex-column flex-lg-row">
                  <Col className="text-end">
                    <AppButton variant="secondary" onClick={handleSearchClear}>
                      Clear
                    </AppButton>
                    &nbsp;&nbsp;&nbsp;
                    <AppButton variant="primary" onClick={handleSearch}>
                      Search
                    </AppButton>
                  </Col>
                </div>
              </Row>
            </div>
          )}
        </AppCard>

        {!isLoader && searchResults && searchResults.length > 0 ? (
          <AppCard
            title={
              <div
                style={{ display: 'flex', alignItems: 'center', width: '100%', cursor: 'pointer' }}
                className="collapsible-card-header"
                onClick={handleToggle}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    handleToggle();
                  }
                }}
                role="button"
                tabIndex={0}
                title={isTableVisible ? "Collapse" : "Expand"}
                aria-label={`${isTableVisible ? "Collapse" : "Expand"} Matching Record`}
                aria-expanded={isTableVisible}
              >
                <span>Matching Record</span>
                {/* The Toggle Button */}
                <div style={{ marginLeft: 'auto' }}>
                  <div
                    //variant="secondary" 
                    title={isTableVisible ? "Collapse" : "Expand"}
                    aria-label={isTableVisible ? "Collapse" : "Expand"}
                  >
                    {isTableVisible ? "-" : "+"}
                  </div>
                </div>
              </div>
            }
            bottomMargin
          >
            {isTableVisible && (
              <Row>
                <Col>
                  <AppDataTable
                    columns={clientSearchCols(
                      handleRowButtonClick,
                      searchResults.length >= 1,
                      focusRef,
                      showPatientInfo
                    )}
                    data={searchResults}
                    pagination={true}
                    loading={isProgress}
                    noDataComponent={<></>}
                    expandableRows={true}
                    expandableRowsComponent={ExpandableRowsComponent}
                    expandableRowExpanded={(row: any) => row.street}
                  />
                </Col>
              </Row>
            )}
          </AppCard>
        ) : (
          ""
        )}

        {showPatientInfo ? (
          <div className="dashboard-container" ref={focusRef}
            tabIndex={-1}
            style={{ outline: 'none' }}>

            {searchResults && searchResults.length >= 1 ? (<>
              {activeKey && <div className='col-12' style={{ marginBottom: '20px', border: '1px solid #dee2e6', borderRadius: '5px' }}>
                <div style={{ backgroundColor: '#005F85', color: 'whitesmoke', height: '30px' }}><h4 className="p-1">Patient Information</h4></div>
                <form ref={clientInfoUpdateFormRef}>
                  <main className="main-content">
                    <AppCard
                      title={

                        <div className="w-100" id="PatientIdentification" >
                          <div className="section-header">
                            <span className="section-title">
                              Patient Identification
                            </span>
                          </div>
                        </div>
                      } bottomMargin
                    >
                      <Card.Body>
                        <Row className="mb-3">
                          <Col>
                            <AppLabel label={"Source"}></AppLabel>
                            <Form.Control
                              type="text"
                              placeholder="Source"
                              disabled
                              readOnly
                              value={clientInfoSource}
                            />
                          </Col>
                          <Col>
                            <AppLabel label={"First Name"} required></AppLabel>
                            <Form.Control
                              // {...clientInfoRegister("clientInfoFirstName")}
                              name="clientInfoFirstName"
                              type="text"
                              disabled
                              readOnly
                              value={clientInfoFirstName}
                              maxLength={30}
                            />
                            <div className="error m-0">
                              {clientInfoValidationErrors.clientInfoFirstName}
                            </div>
                          </Col>
                          <Col>
                            <AppLabel label={"Middle Name"}></AppLabel>
                            <Form.Control
                              type="text"
                              disabled
                              readOnly
                              value={clientInfoMiddleName}
                              maxLength={30}
                            />
                          </Col>
                          <Col>
                            <AppLabel label={"Last Name"} required></AppLabel>
                            <Form.Control
                              // {...clientInfoRegister("clientInfoLastName")}
                              name="clientInfoLastName"
                              type="text"
                              disabled
                              readOnly
                              value={clientInfoLastName}
                              maxLength={30}
                            />
                            <div className="error m-0">
                              {clientInfoValidationErrors.clientInfoLastName}
                            </div>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col>
                            <AppLabel
                              label={"Date of Birth"}
                              required
                            ></AppLabel>
                            <Form.Control
                              // {...clientInfoRegister("clientInfoDateOfBirth")}
                              name="clientInfoDateOfBirth"
                              type="text"
                              value={clientInfoDob}
                              disabled
                              max={maxDate} // Set the max attribute to today
                              min={minDate}
                            />
                            <div className="error m-0">
                              {clientInfoValidationErrors.clientInfoDateOfBirth}
                            </div>
                          </Col>
                          <Col>
                            <AppLabel label={"Birth Sex"}></AppLabel>
                            <Form.Control
                              {...register("EditCaseBirthGender")}
                              type="text"
                              style={{ backgroundColor: "var(--bs-secondary-bg)", opacity: 1 }}
                              placeholder="Birth Sex"
                              readOnly
                              value={clientInfoBirthGender}
                            />
                          </Col>
                          <Col></Col>
                        </Row>
                        <Row>
                          <Col>
                            <AppLabel
                              label={
                                "Routinized Testing Focus Project - Hospital"
                              }
                              required
                            ></AppLabel>
                            <Form.Select
                              {...register("routinizedHospitalId")}
                              name="routinizedHospitalId"
                              // id="RoutinizedHospital"
                              value={caseReportSelectedRoutinizedHospital}
                              onChange={(event) => { handleRoutinizedHospitalChange(event); handleFormFieldChange(event); }}
                            >
                              {/* <option value="0"> -- </option> */}
                              {/* {allRoutinizedHospitalsData.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.value}
                                </option>
                              ))} */}
                              {allRoutinizedHospitalsData.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.value}
                                </option>
                              ))}
                            </Form.Select>
                            <div className="error m-0">
                              {clientInfoValidationErrors.routinizedHospitalId}
                            </div>
                          </Col>
                          <Col>
                            <AppLabel
                              label={
                                "Routinized Testing Focus Project - Facility"
                              }
                              required
                            ></AppLabel>
                            <Form.Select
                              {...register("routinizedFacilityId")}
                              name="routinizedFacilityId"
                              value={caseReportSelectedRoutinizedFacility}
                              onChange={handleRoutinizedFacilityChange}
                            >
                              {/* <option value="0"> -- </option> */}
                              {filteredRoutinizedFacilities.map((option) => (
                                <option
                                  key={option.id}
                                  value={option.id}
                                  data-value={option.value}
                                >
                                  {option.value}
                                </option>
                              ))}
                            </Form.Select>
                            <div className="error m-0">
                              {clientInfoValidationErrors.routinizedFacilityId}
                            </div>
                          </Col>
                          {/* <Col>
                            <AppLabel label={"Details"}></AppLabel>
                            <Form.Control
                              type="text"
                              value={caseReportOtherFacilityDetail}
                              onChange={(e) =>
                                setCaseReportSetOtherFacilityDetail(
                                  e.target.value
                                )
                              }
                              disabled={caseReportOtherFacilityDetailIsDisabled}
                            />
                          </Col> */}
                        </Row>
                        <Row className="mt-3">
                          <Col>
                            <AppLabel
                              label={"Date Received"}
                              required
                            ></AppLabel>
                            <Form.Control
                              {...register("dateReceived")}
                              name="dateReceived"
                              type="date"
                              value={caseReportDateReceived}
                              onChange={(e) => {
                                const date = adjustDateToMax(
                                  e.target.value,
                                  maxDate
                                );
                                setCaseReportDateReceived(date)
                                handleFormFieldChange(e);
                              }
                              }
                              max={maxDate} // Set the max attribute to today
                              min={minDate}
                            />
                            <div className="error m-0">
                              {clientInfoValidationErrors.dateReceived}
                            </div>
                          </Col>
                          <Col>
                            <AppLabel
                              label={"Medical record #"}
                              required
                            ></AppLabel>
                            <Form.Control
                              {...register("medicalRecordNumber")}
                              name="medicalRecordNumber"
                              type="text"
                              value={caseReportMedicalRecord}
                              maxLength={25}
                              onChange={(e) => {
                                setCaseReportMedicalRecord(e.target.value)
                                handleFormFieldChange(e);
                              }}
                            />
                            <div className="error m-0">
                              {clientInfoValidationErrors.medicalRecordNumber}
                            </div>
                          </Col>
                          <Col>
                            {userDetails?.roleName == 'Admin' && (
                              <div>
                                <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                                  <div>
                                    <b>Source:</b> {clientInfoSource} ({clientInfoSource} ID)
                                  </div>
                                </div>
                                <Form.Control
                                  type="text"
                                  disabled
                                  readOnly
                                  value={clientInfoSourceId}
                                  name="clientInfoSourceId"
                                />
                              </div>
                            )}
                          </Col>
                        </Row>
                      </Card.Body>
                    </AppCard>
                    <AppCard
                      bottomMargin
                    >
                      <div className="w-100" id="PatientContactIdentification">
                        <div className="section-header">
                          <span className="section-title">
                            Patient Contact Information
                          </span>
                        </div>
                      </div>
                      <div className="d-flex justify-content-end mb-2">
                        <AppButton
                          type="button"
                          variant="primary"
                          onClick={(e) => handleUpdateContactDetail(e)}
                        >
                          Update
                        </AppButton>
                      </div>
                      <Card.Body>
                        <Row className="mb-3">
                          <Col>
                            <AppLabel label={"Address Type"} required={isEditingContactInfo} />
                            <Form.Select
                              {...register("addressTypeDetailNewCase")}
                              name="addressTypeDetailNewCase"
                              onChange={handleAddressType}
                              value={addressType}
                              disabled={!isEditingContactInfo}
                            >
                              <option value="">--</option>
                              <option value="Yes">Home Address</option>
                              <option value="No">Unhoused</option>
                              <option value="No1">Unknown/ No Response</option>
                            </Form.Select>
                            <div className="error m-0">
                              {clientInfoValidationErrors.addressTypeDetailNewCase}
                            </div>
                          </Col>
                          <Col>
                            <AppLabel label={"Street Address 1"} required />
                            <Form.Control
                              {...clientInfoRegister("clientInfoStreetAddress")}
                              name="clientInfoStreetAddress"
                              type="text"
                              value={clientInfoStreet}
                              onChange={(e) => {
                                setClientInfoStreet1(e.target.value)
                                handleFormFieldChange(e);
                              }}
                              disabled={addressDisable || !isEditingContactInfo}
                              maxLength={100}
                            />
                            <div className="error m-0">
                              {
                                clientInfoValidationErrors.clientInfoStreetAddress
                              }
                            </div>
                          </Col>
                          <Col>
                            <AppLabel label={"Street Address 2"} />
                            <Form.Control
                              type="text"
                              value={clientInfoStreet2}
                              onChange={(e) =>
                                setClientInfoStreet2(e.target.value)
                              }
                              disabled={addressDisable || !isEditingContactInfo}
                              maxLength={50}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col>
                            <AppLabel label={"City"} required />
                            <Form.Control
                              {...clientInfoRegister("clientInfoCity")}
                              name="clientInfoCity"
                              type="text"
                              value={clientInfoCity}
                              onChange={(e) => {
                                setClientInfoCity(e.target.value)
                                handleFormFieldChange(e);
                              }}
                              disabled={addressDisable || !isEditingContactInfo}
                              maxLength={100}
                            />
                            <div className="error m-0">
                              {clientInfoValidationErrors.clientInfoCity}
                            </div>
                          </Col>
                          <Col>
                            <AppLabel label={"State"} />
                            <Form.Select
                              id="state"
                              name="state"
                              value={clientInfoSelectedState}
                              onChange={handleStateChange}
                              disabled={addressDisable || !isEditingContactInfo}
                            >
                              <option value=""> -- </option>
                              {clientInfoStateData.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.value}
                                </option>
                              ))}
                            </Form.Select>
                            <div className="error m-0">
                              {clientInfoValidationErrors.state}
                            </div>
                          </Col>
                          <Col>
                            <AppLabel label={"ZIP Code"} required />
                            <Form.Control
                              {...clientInfoRegister("clientInfoZipcode")}
                              name="clientInfoZipcode"
                              type="text"
                              value={clientInfoZip}
                              onChange={(e) => {
                                setClientInfoZip(e.target.value)
                                handleFormFieldChange(e);
                              }}
                              maxLength={5}
                              disabled={addressDisable || !isEditingContactInfo}
                            />
                            <div className="error m-0">
                              {clientInfoValidationErrors.clientInfoZipcode}
                            </div>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col>
                            <AppLabel label={"County"} />
                            <Form.Select
                              id="county"
                              value={clientInfoSelectedCounty}
                              onChange={handleCountyChange}
                              disabled={(addressDisable || !isEditingContactInfo) || clientInfoSelectedState !== "10"}
                            >
                              <option value="">Select County</option>

                              {clientInfoSelectedState == 10
                                ? clientInfoCountyData.map((county) => (
                                  <option key={county.id} value={county.id}>
                                    {county.value}
                                  </option>
                                ))
                                : clientInfoCountyData
                                  .filter((county) => county.id == "68")
                                  .map((county) => (
                                    <option key={county.id} value={county.id}>
                                      {county.value}
                                    </option>
                                  ))}

                            </Form.Select>
                            <div className="error m-0">
                              {clientInfoValidationErrors.county}
                            </div>
                          </Col>
                          <Col>
                            <AppLabel label={"Primary Phone"} />
                            <Form.Control
                              type="text"
                              value={clientInfoPhone1}
                              placeholder={
                                "10 digit phone number (ex: 555-555-5555)"
                              }
                              onChange={(e) => {
                                const { name, value } = e.target;
                                const formattedPhoneNumber =
                                  formatPhoneNumber(value);
                                setClientInfoPhone1(formattedPhoneNumber);
                              }}
                              disabled={!isEditingContactInfo}
                            />
                          </Col>
                          <Col>
                            <AppLabel label={"Alternate Phone"} />
                            <Form.Control
                              type="text"
                              value={clientInfoPhone2}
                              placeholder={
                                "10 digit phone number (ex: 555-555-5555)"
                              }
                              onChange={(e) => {
                                const { name, value } = e.target;
                                const formattedPhoneNumber =
                                  formatPhoneNumber(value);
                                setClientInfoPhone2(formattedPhoneNumber);
                              }}
                              disabled={!isEditingContactInfo}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col>
                            <AppLabel label={"Comments"} />
                            <Form.Control
                              as="textarea"
                              value={caseReportComments}
                              onChange={(e) =>
                                setCaseReportComments(e.target.value)
                              }
                              maxLength={1500}
                              rows={2}
                            />
                            <div style={{ fontSize: '0.85rem', color: '#6c757d', textAlign: 'right', marginTop: '4px' }}>
                              Character Count: {caseReportComments ? caseReportComments.length : 0} / 1500
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </AppCard>
                    <AppCard title={
                      <div className="w-100" id="EmergencyContactInformation">
                        <div className="section-header">
                          <span className="section-title">
                            Emergency Contact Information
                          </span>
                        </div>
                      </div>
                    } bottomMargin>
                      <Card.Body>
                        <Row className="mb-3">
                          <Col>
                            <AppLabel label={"Emergency Contact Person"} />
                            <Form.Control
                              type="text"
                              value={clientInfoErContactPerson}
                              onChange={(e) =>
                                setClientInfoErContactPerson(e.target.value)
                              }
                              maxLength={60}
                            />
                          </Col>
                          <Col>
                            <AppLabel label="Relationship" />
                            <Form.Select
                              value={clientInfoErContactPersonRelation || ""}
                              onChange={(e) => {
                                setClientInfoErContactPersonRelation(e.target.value);
                              }}
                            >
                              <option value=""> -- </option> {/* Placeholder */}
                              {clientInfoRelationshipData.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.value}
                                </option>
                              ))}
                            </Form.Select>

                          </Col>
                          <Col>
                            <AppLabel label={"Phone"} />
                            <Form.Control
                              type="text"
                              value={clientInfoErContactPersonPhone}
                              placeholder={
                                "10 digit phone number (ex: 555-555-5555)"
                              }
                              onChange={(e) => {
                                const { name, value } = e.target;
                                const formattedPhoneNumber =
                                  formatPhoneNumber(value);
                                setClientInfoErContactPersonPhone(
                                  formattedPhoneNumber
                                );
                              }}
                            />
                          </Col>
                        </Row>
                      </Card.Body>
                    </AppCard>
                    <AppCard
                      title={
                        <div className="w-100" id="MedicalInformation">
                          <div className="section-header">
                            <span className="section-title">
                              Medical Information
                            </span>

                            <span
                              onClick={toggleInfoMedical}
                              className="section-toggle"
                              title={isMedicalInfoCollapsed ? "Expand" : "Collapse"}
                              aria-label={isMedicalInfoCollapsed ? "Expand" : "Collapse"}
                            >
                              {isMedicalInfoCollapsed ? "+" : "−"}
                            </span>
                          </div>
                        </div>
                      }
                      bottomMargin
                    >
                      {!isMedicalInfoCollapsed && (
                        <Card.Body>
                          <Row className="mb-3">
                            <Col>
                              <AppLabel label={"Date of Presented To"} />
                              <Form.Control
                                name="datePresented"
                                type="date"
                                value={caseReportDatePresented}
                                onChange={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setCaseReportDatePresented(date)
                                }
                                }
                                max={maxDate} // Set the max attribute to today
                                min={minDate}
                              />
                            </Col>
                            <Col>
                              <AppLabel label={"Date of Discharge"} />
                              <Form.Control
                                type="date"
                                value={caseReportDateDischarged}
                                onChange={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setCaseReportDateDischarged(date)
                                }
                                }
                                max={maxDate} // Set the max attribute to today
                                min={minDate}
                              />
                            </Col>
                            <Col>
                              <AppLabel label={"Chief Complaint"} />
                              <Form.Control
                                name="chiefComplaint"
                                type="text"
                                value={caseReportChiefComplaint}
                                onChange={(e) =>
                                  setCaseReportChiefComplaint(e.target.value)
                                }
                                maxLength={200}
                              />
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col>
                              <AppLabel label={"List of Symptoms"} />
                              <Form.Control
                                name="listOfSymptoms"
                                as="textarea"
                                value={caseReportSymptoms}
                                onChange={(e) =>
                                  setCaseReportDateSymptoms(e.target.value)
                                }
                                maxLength={1500}
                                rows={2}
                              />
                              <div style={{ fontSize: '0.85rem', color: '#6c757d', textAlign: 'right', marginTop: '4px' }}>
                                Character Count: {caseReportSymptoms ? caseReportSymptoms.length : 0} / 1500
                              </div>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col>
                              <AppLabel label={"Admitted to Hospital"} />
                              <Form.Select
                                name="admittedToHospitalClient"
                                value={caseReportHospitalAdmit}
                                onChange={handleHospitalAdmitChange}
                              >
                                <option value="0">--</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </Form.Select>
                            </Col>
                            <Col>
                              <AppLabel label={"Where"} />
                              <Form.Control
                                {...register("admittedToHospitalWhereClient")}
                                type="text"
                                value={caseReportHospitalLocation}
                                onChange={(e) =>
                                  setCaseReportHospitalLocation(e.target.value)
                                }
                                disabled={caseReportHospitalLocationIsDisabled}
                                maxLength={50}
                              />
                              <div className="error m-0">
                                {newCaseReportValidationErrors.admittedToHospitalWhereClient}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"Room #"} />
                              <Form.Control
                                type="text"
                                value={caseReportHospitalRoom}
                                onChange={(e) =>
                                  setCaseReportHospitalRoom(e.target.value)
                                }
                                disabled={caseReportHospitalRoomIsDisabled}
                                maxLength={25}
                              />
                            </Col>
                          </Row>
                        </Card.Body>)}
                    </AppCard>
                    <AppCard title={
                      <div className="w-100" id="LinkageToCareStatus">
                        <div className="section-header">
                          <span className="section-title">
                            Linkage to Care Status
                          </span>
                        </div>
                      </div>
                    } bottomMargin>
                      <Card.Body>
                        <Row className="mb-3">
                          <Col>
                            <AppLabel label={"Linkage to Care Status"} />
                            <Form.Select
                              name="LinkageToCareStatusId"
                              value={l2CName}
                              onChange={(e) => {
                                setLinkageToCareStatusForHivDiagnosis(e.target.value);
                                setl2CName(e.target.value)
                              }}
                              disabled
                            //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                            >
                              {allLinkageCareStatusesData.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.value}
                                </option>
                              ))}
                            </Form.Select>
                          </Col>
                          <Col>
                            <AppLabel label={"Updated Linkage Care Status"} />
                            <Form.Select
                              //{...register("LinkageCareStatus")}
                              name="LinkageCareStatusId"
                              value={linkageCareStatus}
                              onChange={(e) => {
                                setLinkageCareStatus(e.target.value)
                                if (String(e.target.selectedOptions[0].text) !== 'Others') setLinkageCareStatusOtherDetails("");
                                handleSectionValidation(false, false, true);
                              }}

                            >
                              {allLinkageCareStatusesData.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.value}
                                </option>
                              ))}
                            </Form.Select>
                          </Col>
                          {String(linkageCareStatus ?? "") === "7" && ( // linkageCareStatus 7 is "Others"
                            <Col>
                              <AppLabel label={"Details"} />
                              <Form.Control
                                type="text"
                                value={linkageCareStatusOtherDetails}
                                onChange={(e) =>
                                  setLinkageCareStatusOtherDetails(e.target.value)
                                }
                                maxLength={50}
                              />
                            </Col>
                          )}
                          {String(linkageCareStatus ?? "") !== "7" && ( // linkageCareStatus 7 is "Others"
                            <Col>
                            </Col>
                          )}
                        </Row>

                      </Card.Body>
                    </AppCard>


                    <>
                      <AppCard titleNode={testingInformationTitle} hasTitleNode={true} bottomMargin>
                        <div id="TestingInformation"></div>
                        {!isTestingInfoCollapsed && (
                          <Card.Body>
                            <Row className="mb-3">
                              <Col>
                                <AppLabel  label={"NAAT"}
            required={
              isPositiveTestResult === true &&
              caseReportCheckBox === false
            } />
                                <Form.Select
                                  value={caseReportNAAT}
                                  {...register("naat")}
                                  name="NAAT"
                                  onChange={(e) => {
                                    setCaseReportNAAT(e.target.value)
                                    handleSectionValidation(true, false, false);
                                    if (e.target.value && e.target.value !== '0') {
                                      positiveTestResultRef.current.naat = false;
                                    } else {
                                      positiveTestResultRef.current.naat = true;
                                    }
                                    handleFormFieldChange(e);
                                  }}
                                  disabled={caseReportCheckBox}
                                >
                                  <option value="0">--</option>
                                  <option value="Positive">Positive</option>
                                  <option value="Negative">Negative</option>
                                  <option value="Indetermine">Indetermine</option>
                                  <option value="Notperformed">Not Performed</option>
                                </Form.Select>
                                <div className="error m-0">
                                  {newCaseReportValidationErrors.naat}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"NAAT Date"} required={caseReportNAAT == "Positive"}></AppLabel>
                                <Form.Control
                                  {...register("naatDate")}
                                  name="naatDate"
                                  type="date"
                                  value={caseReportNAATDate}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setCaseReportNAATDate(date)
                                    handleSectionValidation(true, true, false);
                                    handleFormFieldChange(e);
                                  }}
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                  disabled={caseReportCheckBox}
                                />
                                <div className="error m-0">
                                  {newCaseReportValidationErrors.naatDate}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"Disclosed"} />
                                <Form.Select
                                  {...register("Disclosed")}
                                  name="Disclosed"
                                  value={caseReportDisclosed}
                                  onChange={(e) => {
                                    setCaseReportDisclosed(e.target.value)
                                    handleSectionValidation(true, false, false);
                                    if (e.target.value && e.target.value !== '0') {
                                      positiveTestResultRef.current.disclosed = false;
                                    } else {
                                      positiveTestResultRef.current.disclosed = true;
                                    }
                                    handleFormFieldChange(e);
                                  }}
                                  disabled={caseReportCheckBox}
                                >
                                  <option value="0">--</option>
                                  <option value="Yes">Yes</option>
                                  <option value="No">No</option>
                                </Form.Select>
                                <div className="error m-0">
                                  {newCaseReportValidationErrors.Disclosed}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"Disclosed Date"} required={caseReportDisclosed == "Yes"}></AppLabel>
                                <Form.Control
                                  {...register("disclosedDate")}
                                  name="disclosedDate"
                                  type="date"
                                  value={caseReportDisclosedDate}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setCaseReportDisclosedDate(date)
                                    handleSectionValidation(true, false, false);
                                    handleFormFieldChange(e);
                                  }}
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                  disabled={caseReportCheckBox}
                                />
                                <div className="error m-0">
                                  {newCaseReportValidationErrors.disclosedDate}
                                </div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col>
                                <AppLabel label={"HIV-1/2 Ag/Ab"} />
                                <Form.Select
                                  {...register("hivAgAb")}
                                  name="hivAgAb"
                                  value={caseReportHIVAGAB}
                                  onChange={(e) => {
                                    setCaseReportHIVAGAB(e.target.value)
                                    handleSectionValidation(false, true, false)
                                    if (e.target.value && e.target.value !== '0') {
                                      positiveTestResultRef.current.hivagab = false;
                                    } else {
                                      positiveTestResultRef.current.hivagab = true;
                                    }
                                    handleFormFieldChange(e);
                                  }}
                                  disabled={caseReportCheckBox}
                                >
                                  <option value="0">--</option>
                                  <option value="Positive">Positive</option>
                                  <option value="Negative">Negative</option>
                                  <option value="Indetermine">Indetermine</option>
                                </Form.Select>
                                <div className="error m-0">
                                  {newCaseReportValidationErrors.hivAgAb}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"HIV-1/2 Ag/Ab Date"} required={caseReportHIVAGAB == "Positive"}></AppLabel>
                                <Form.Control
                                  {...register("hivAgAbDate")}
                                  name="hivAgAbDate"
                                  type="date"
                                  value={caseReportHivAgAbDate}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setCaseReportHivAgAbDate(date)
                                    handleSectionValidation(false, true, false)
                                    handleFormFieldChange(e);
                                  }}
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                  disabled={caseReportCheckBox}
                                />
                                <div className="error m-0">
                                  {newCaseReportValidationErrors.hivAgAbDate}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"In Care"} />
                                <Form.Select
                                  {...register("NewCaseInCare")}
                                  name="NewCaseInCare"
                                  value={caseReportInCare}
                                  onChange={(e) => {
                                    setCaseReportInCare(e.target.value)
                                    handleSectionValidation(false, true, false);
                                    if (e.target.value && e.target.value !== '0') {
                                      positiveTestResultRef.current.incare = false;
                                    } else {
                                      positiveTestResultRef.current.incare = true;
                                    }
                                    handleFormFieldChange(e);
                                  }}
                                  disabled={caseReportCheckBox}
                                >
                                  <option value="0">--</option>
                                  <option value="Yes">Yes</option>
                                  <option value="No">No</option>
                                </Form.Select>
                                <div className="error m-0">
                                  {newCaseReportValidationErrors.NewCaseInCare}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"In Care Date"} required={caseReportInCare == "Yes"}></AppLabel>
                                <Form.Control
                                  {...register('inCareDate')}
                                  name="inCareDate"
                                  type="date"
                                  value={caseReportInCareDate}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setCaseReportInCareDate(date)
                                    handleSectionValidation(false, true, false);
                                    handleFormFieldChange(e);
                                  }}
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                  disabled={caseReportCheckBox}
                                />
                                <div className="error m-0">
                                  {newCaseReportValidationErrors.inCareDate}
                                </div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col>
                                <AppLabel
                                  label={"HIV - 1/2 IA (Supplemental)"}
                                />
                                <Form.Select
                                  {...register("hivIASupplemental")}
                                  name="hivIASupplemental"
                                  value={caseReportHIVIA}
                                  onChange={(e) => {
                                    setCaseReportHIVIA(e.target.value)
                                    handleSectionValidation(false, false, true);
                                    if (e.target.value && e.target.value !== '0') {
                                      positiveTestResultRef.current.hivIa = false;
                                    } else {
                                      positiveTestResultRef.current.hivIa = true;
                                    }
                                    handleFormFieldChange(e);
                                  }}
                                  disabled={caseReportCheckBox}
                                >
                                  <option value="0">--</option>
                                  <option value="Positive">Positive</option>
                                  <option value="Negative">Negative</option>
                                  <option value="Indetermine">Indetermine</option>
                                </Form.Select>
                                <div className="error m-0">
                                  {newCaseReportValidationErrors.hivIASupplemental}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel
                                  label={"HIV - 1/2 IA (Supplemental) Date"}
                                  required={caseReportHIVIA == "Positive"}
                                ></AppLabel>
                                <Form.Control
                                  {...register('hivIaSupplementalDate')}
                                  name="hivIaSupplementalDate"
                                  type="date"
                                  value={caseReportHivIaDate}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    handleSectionValidation(false, false, true);
                                    setCaseReportHivIaDate(date)
                                    handleFormFieldChange(e);
                                  }}
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                  disabled={caseReportCheckBox}
                                />
                                <div className="error m-0">
                                  {newCaseReportValidationErrors.hivIaSupplementalDate}
                                </div>
                              </Col>
                              <Col>

                              </Col>
                              <Col></Col>
                            </Row>
                            <Row className="mb-3">
                              <Col>
                                <AppLabel label={"Medication"} />
                                <Form.Control
                                  type="text"
                                  value={caseReportMedication}
                                  onChange={(e) =>
                                    setCaseReportMedication(e.target.value)
                                  }
                                  disabled={caseReportCheckBox}
                                  maxLength={200}
                                />
                              </Col>
                            </Row>
                          </Card.Body>
                        )}
                      </AppCard>
                      {source !== "SYPHILIS" && (<AppCard
                        title={
                          <div className="w-100" id="HIVDetails">
                            <div className="section-header">
                              <span className="section-title">
                                HIV Diagnosis Details
                              </span>

                              <span
                                onClick={toggleHivDetails}
                                className="section-toggle"
                                title={isHivDetailsCollapsed ? "Expand" : "Collapse"}
                                aria-label={isHivDetailsCollapsed ? "Expand" : "Collapse"}
                              >
                                {isHivDetailsCollapsed ? "+" : "−"}
                              </span>
                            </div>
                          </div>
                        }
                        bottomMargin
                      >
                        {!isHivDetailsCollapsed && (
                          <Card.Body>
                            <Row className="mb-3">
                              <Col>
                                <AppLabel label={"HIV Diagnosis Date"} />
                                <Form.Control
                                  {...register('hivDiagnosisDate')}
                                  type="text"
                                  value={clientInfoHivDateOfDiagnosis}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setClientInfoHivDateOfDiagnosis(date)
                                  }
                                  }
                                  disabled
                                  readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                />
                                <div className="error m-0">
                                  {newCaseReportValidationErrors.hivDiagnosisDate}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"AIDS Date"} />
                                <Form.Control
                                  {...register('aidsDate')}
                                  type="date"
                                  value={clientInfoAidsDate}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setClientInfoAidsDate(date)
                                  }
                                  }
                                  disabled
                                  readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                                  max={maxDate} // Set the max attribute to today
                                />
                                <div className="error m-0">
                                  {newCaseReportValidationErrors.aidsDate}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"Mode of Transmission"} />
                                <Form.Select
                                  name="clientInfoHIVModeOfTransmissionId"
                                  value={clientInfoHIVModeOfTransmissionId}
                                  onChange={(e) => setClientInfoModeOfTransmissionId(e.target.value)}
                                  disabled
                                //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                                >
                                  {allModeoftransmissionData.map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value}
                                    </option>
                                  ))}
                                </Form.Select>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col>
                                <AppLabel label={"Date Reported HIV Positive to State"} />
                                <Form.Control
                                  {...register('dateReportedHivPositive')}
                                  type="date"
                                  value={clientInfoHIVReportedDate}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setClientInfoHIVReportedDate(date)
                                  }
                                  }
                                  disabled
                                  readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                                  max={maxDate} // Set the max attribute to today
                                />
                                <div className="error m-0">
                                  {newCaseReportValidationErrors.dateReportedHivPositive}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel
                                  label={
                                    "Date of Last Viral Load"
                                  }
                                />
                                <Form.Control
                                  name="lastViralLoad"
                                  type="date"
                                  value={lastUpdatedDate.lastViralLoad}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setLastUpdatedDate((prev) => ({ ...prev, lastViralLoad: date }));
                                  }
                                  }
                                  disabled
                                  //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                                  readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                >
                                </Form.Control>
                              </Col>
                              <Col>
                                <AppLabel label={"Viral Load"} />
                                <Form.Control
                                  type="text"
                                  value={clientInfoViralLoad}
                                  onChange={(e) =>
                                    setClientInfoViralLoad(e.target.value)
                                  }
                                  disabled
                                  //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                                  readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                                  maxLength={25}
                                />
                              </Col>
                            </Row>
                            <Row className="mb-3">

                              <Col>
                                <AppLabel
                                  label="Date of Last CD4 Count"
                                />
                                <Form.Control
                                  type="date"
                                  value={lastUpdatedDate.lastCd4}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setLastUpdatedDate((prev) => ({ ...prev, lastCd4: date }));
                                  }
                                  }
                                  disabled
                                  //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                                  readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                />
                              </Col>
                              <Col>
                                <AppLabel label={"CD4 Count"} />
                                <Form.Control
                                  type="text"
                                  value={clientInfoCD4Count}
                                  disabled
                                  //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                                  readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                                  onChange={(e) => setClientInfoCD4Count(e.target.value)}
                                  maxLength={25}
                                />
                              </Col>
                              <Col>

                              </Col>
                            </Row>
                          </Card.Body>
                        )}
                      </AppCard>)}


                      {source !== "SYPHILIS" && (<AppCard
                        title={
                          <div className="w-100" id="UpdatedHIVDetails">
                            <div className="section-header">
                              <span className="section-title">
                                Updated HIV Diagnosis Details
                              </span>

                              <span
                                onClick={toggleUpdatedHiv}
                                className="section-toggle"
                                title={isUpdatedHivCollapsed ? "Expand" : "Collapse"}
                                aria-label={isUpdatedHivCollapsed ? "Expand" : "Collapse"}
                              >
                                {isUpdatedHivCollapsed ? "+" : "−"}
                              </span>
                            </div>
                          </div>
                        }
                        bottomMargin
                      >
                        {!isUpdatedHivCollapsed && (
                          <Card.Body>
                            <Row className="mb-3">
                              <Col>
                                <AppLabel label={"HIV Diagnosis Date"} />
                                <Form.Control
                                  {...register('updatedHivDiagnosisDate')}
                                  type="date"
                                  value={updatedLastUpdatedDate.dateOfDiagnosis}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setUpdatedLastUpdatedDate((prev) => ({ ...prev, dateOfDiagnosis: date }));
                                  }
                                  }
                                  //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                                  //readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                />
                                <div className="error m-0">
                                  {newCaseReportValidationErrors.updatedHivDiagnosisDate}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"AIDS Date"} />
                                <Form.Control
                                  {...register('updatedAidsDate')}
                                  type="date"
                                  value={UpdateClientInfoAidsDate}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setUpdateClientInfoAidsDate(date)
                                  }
                                  }
                                  //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                                  //readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                                  max={maxDate} // Set the max attribute to today
                                />
                                <div className="error m-0">
                                  {newCaseReportValidationErrors.updatedAidsDate}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"Mode of Transmission"} />
                                <Form.Select
                                  name="UpdateClientInfoHIVModeOfTransmissionId"
                                  value={UpdateClientInfoHIVModeOfTransmissionId}
                                  onChange={(e) => setUpdateClientInfoHIVModeOfTransmissionId(e.target.value)}
                                //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                                >
                                  {allModeoftransmissionData.map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value}
                                    </option>
                                  ))}
                                </Form.Select>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col>
                                <AppLabel label={"Date Reported HIV Positive to State"} />
                                <Form.Control
                                  {...register('updatedDateReportedHivPositive')}
                                  type="date"
                                  value={UpdateClientInfoHIVReportedDate}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setUpdateClientInfoHIVReportedDate(date)
                                  }
                                  }
                                  //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                                  //readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                                  max={maxDate} // Set the max attribute to today
                                />
                                <div className="error m-0">
                                  {newCaseReportValidationErrors.updatedDateReportedHivPositive}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel
                                  label={
                                    "Date of Last Viral Load"
                                  }
                                />
                                <Form.Control
                                  {...register("updatedLastViralLoad")}
                                  name="updatedLastViralLoad"
                                  type="date"
                                  value={updatedLastUpdatedDate.lastViralLoad}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setUpdatedLastUpdatedDate((prev) => ({ ...prev, lastViralLoad: date }));
                                  }
                                  }
                                  //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                                  //readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                >
                                </Form.Control>
                                <div className="error m-0">
                                  {clientInfoValidationErrors.updatedLastViralLoad}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"Viral Load"} />
                                <Form.Control
                                  type="text"
                                  value={updatedClientInfoViralLoad}
                                  onChange={(e) =>
                                    setUpdatedClientInfoViralLoad(e.target.value)
                                  }
                                  //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                                  //readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                                  maxLength={25}
                                />
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              {/* <Col>
                                  <AppLabel label={"Linkage to Care Status"} />
                                  <Form.Select
                                    name="UpdatedLinkageToCareStatusId"
                                    value={updatedL2CName}
                                    onChange={(e) => setUpdatedL2CName(e.target.value)}
                                    //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                                  >
                                    {allLinkageCareStatusesData.map((option) => (
                                      <option key={option.id} value={option.id}>
                                        {option.value}
                                      </option>
                                    ))}
                                  </Form.Select>
                                </Col> */}
                              <Col>
                                <AppLabel
                                  label="Date of Last CD4 Count"
                                />
                                <Form.Control
                                  {...register("updatedlastCd4")}
                                  name="updatedlastCd4"
                                  type="date"
                                  value={updatedLastUpdatedDate.lastCd4}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setUpdatedLastUpdatedDate((prev) => ({ ...prev, lastCd4: date }));
                                  }
                                  }
                                  //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                                  //readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                />
                                <div className="error m-0">
                                  {clientInfoValidationErrors.updatedlastCd4}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"CD4 Count"} />
                                <Form.Control
                                  type="text"
                                  value={updatedClientInfoCD4Count}
                                  //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                                  //readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                                  onChange={(e) => setUpdatedClientInfoCD4Count(e.target.value)}
                                  maxLength={25}
                                />
                              </Col>
                              <Col>

                              </Col>
                            </Row>
                          </Card.Body>
                        )}
                      </AppCard>)}
                      {source !== "HIV" && (<AppCard
                        title={
                          <div className="w-100" id="SyphilisTreatmentInformation">
                            <div className="section-header">
                              <span className="section-title">
                                STD Treatment History
                              </span>

                              <span
                                onClick={toggleSyphilisTreatment}
                                className="section-toggle"
                                title={isSyphilisTreatmentCollapsed ? "Expand" : "Collapse"}
                                aria-label={isSyphilisTreatmentCollapsed ? "Expand" : "Collapse"}
                              >
                                {isSyphilisTreatmentCollapsed ? "+" : "-"}
                              </span>
                            </div>
                          </div>
                        }
                        bottomMargin
                      >
                        {!isSyphilisTreatmentCollapsed && (
                          <Card.Body>
                            <div className="table-responsive">
                              <table className="table table-bordered table-striped mb-0">
                                <thead>
                                  <tr>
                                    <th>Added Date</th>
                                    <th>Provider Name</th>
                                    <th>Screening Date</th>
                                    <th>Exam Date</th>
                                    <th>Treatment Date</th>
                                    <th>Treatment Name</th>
                                    <th>Treatment Administered By</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {syphilisTreatmentHistory.length > 0 ? (
                                    syphilisTreatmentHistory.map((row, index) => (
                                      <tr key={`${row.source ?? "treatment"}-${row.treatmentHistoryRowNum ?? index}`}>
                                        <td>{formatDisplayDate(row.starsAddedDate)}</td>
                                        <td>{row.providerName ?? ""}</td>
                                        <td>{formatDisplayDate(row.screeningDate)}</td>
                                        <td>{formatDisplayDate(row.examDate)}</td>
                                        <td>{formatDisplayDate(row.treatedDate)}</td>
                                        <td>{row.treatmentData ?? ""}</td>
                                        <td>{row.treatmentAdministeredName ?? ""}</td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan={7} className="text-center">
                                        No treatment history found.
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </Card.Body>
                        )}
                      </AppCard>)}
                    </>


                    {source !== "HIV" && (
                      //Disable STD Section - Data is fetched and populated from DW
                      <AppCard
                        title={
                          <div className="w-100" id="STDTestInformation">
                            <div className="section-header">
                              <span className="section-title">
                                STD Test Information
                              </span>

        <span
          onClick={toggleStd}
          className="section-toggle"
          title={isStdCollapsed ? "Expand" : "Collapse"}
          aria-label={isStdCollapsed ? "Expand" : "Collapse"}
        >
          {isStdCollapsed ? "+" : "−"}
        </span>
      </div>
    </div>
  }
  bottomMargin
>
                          {!isStdCollapsed && (
                            <Card.Body>
                              {stdTestInformationGroups.map((group) => (
                                <section key={group.testName} className="mb-4">
                                  <AppLabel
                                    label={group.testName}
                                    style={{
                                      fontWeight: "bold",
                                      marginBottom: "10px",
                                    }}
                                  />
                                  <div className="table-responsive">
                                    <table
                                      className="table table-bordered table-striped mb-0"
                                      style={{ tableLayout: "fixed", width: "100%" }}
                                    >
                                      <colgroup>
                                        <col style={{ width: "25%" }} />
                                        <col style={{ width: "25%" }} />
                                        <col style={{ width: "25%" }} />
                                        <col style={{ width: "25%" }} />
                                      </colgroup>
                                      <thead>
                                        <tr>
                                          <th>Specimen Collection Date</th>
                                          <th>Specimen ID</th>
                                          <th>Details</th>
                                          <th>Titer</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                          {group.rows.length > 0 ? (
                                            group.rows.map((row, index) =>
                                              row.specimenDate ? (
                                                <tr
                                                  key={`${group.testName}-${row.historyNumber ?? "current"}-${index}`}
                                                >
                                                  <td>{formatStdTableDate(row.specimenDate)}</td>
                                                  <td>{row.specimenId ?? ""}</td>
                                                  <td>{row.details ?? ""}</td>
                                                  <td>{row.titer ?? ""}</td>
                                                </tr>
                                              ) : null
                                            )
                                          ) : (
                                            <tr>
                                              <td colSpan={4} className="text-center">
                                                No test information found.
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                    </table>
                                  </div>
                                </section>
                              ))}
                            </Card.Body>
                          )}
                          {false && (
                          <Card.Body>
                            <Row className="mb-3">
                              <AppLabel style={{
                                fontWeight: "bold",
                                marginBottom: "10px"
                              }} label={"RPR Test Information"} />
                              <Col>
                                <AppLabel label={"Specimen Collection Date"} />
                                <Form.Control
                                  {...register('rprCollectionDate')}
                                  name="rprCollectionDate"
                                  type="date"
                                  value={caseReportRPRSpecimanDate}
                                  disabled
                                  readOnly={isAdmin ? !isAdmin : !isAdmin}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setcaseReportRPRSpecimanDate(date)
                                    handleFormFieldChange(e);
                                  }
                                  }
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                />
                                <div className="error m-0">
                                  {newCaseReportValidationErrors.rprCollectionDate}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"Specimen ID"} />
                                <Form.Control
                                  {...register("rprSpecimenID")}
                                  name="rprSpecimenID"
                                  type="text"
                                  value={caseReportRPRSpecimanID}
                                  disabled
                                  readOnly={isAdmin ? !isAdmin : !isAdmin}
                                  onChange={(e) => setcaseReportRPRSpecimanID(e.target.value)}
                                />
                                <div className="error m-0">
                                  {newCaseReportValidationErrors.rprSpecimenID}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel
                                  label={
                                    "Details"
                                  }
                                />
                                {
                                  isAdmin
                                    ?
                                    <Form.Select
                                      name="detailsToRPRTest"
                                      value={detailsToRPRTest}
                                      onChange={(e) => setdetailsToRPRTest(e.target.value)}
                                      disabled
                                    >
                                      <option value="0">--</option>
                                      <option value="Positive">Positive (Reactive)</option>
                                      <option value="Negative">
                                        Negative (Non-Reactive)
                                      </option>
                                    </Form.Select>
                                    :
                                    <Form.Control
                                      type="text"
                                      value={detailsToRPRTest}
                                      disabled
                                      readOnly={isAdmin ? !isAdmin : !isAdmin}
                                    />
                                }
                              </Col>
                              <Col>
                                <AppLabel label={"Titer"} />
                                <Form.Control
                                  type="text"
                                  value={rprTestInfo.titer}
                                  disabled
                                  readOnly={isAdmin ? !isAdmin : !isAdmin}
                                  onChange={(e) => setTiter(e.target.value)}
                                />
                              </Col>
                            </Row>
                            {historicalRPR.length > 0 && (
                              <div style={{ marginTop: "15px" }}>
                                <AppLabel label="Historical RPR Results" style={{ fontWeight: "bold" }} />

                                {historicalRPR.map((row, index) => (
                                  <Row key={index} className="mb-3" style={{ paddingLeft: "20px" }}>
                                    <Col>
                                      <AppLabel label={`Specimen Date (History #${row.testHistoryRowNum - 1})`} />
                                      <Form.Control
                                        type="date"
                                        value={convertToISODate(row.testSpecimenDate)}
                                        disabled
                                      />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Specimen ID" />
                                      <Form.Control type="text" value={row.specimenId || ""} disabled />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Details" />
                                      <Form.Control type="text" value={row.qualitativeResult || ""} disabled />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Titer" />
                                      <Form.Control type="text" value={row.quantitativeResult || ""} disabled />
                                    </Col>
                                  </Row>
                                ))}
                              </div>
                            )}

                            <Row className="mb-3">
                              <AppLabel style={{
                                fontWeight: "bold",
                                marginBottom: "10px",
                                marginTop: "10px"
                              }} label={"CSF-VDRL Test Information"} />
                              <Col>
                                <AppLabel label={"Specimen Collection Date"} />
                                <Form.Control
                                  {...register('vdrlCollectionDate')}
                                  name="vdrlCollectionDate"
                                  type="date"
                                  value={caseReportVDRLSpecimanDate}
                                  disabled
                                  readOnly={isAdmin ? !isAdmin : !isAdmin}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setcaseReportVDRLSpecimanDate(date)
                                    handleFormFieldChange(e);
                                  }
                                  }
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                />
                                <div className="error m-0">
                                  {newCaseReportValidationErrors.vdrlCollectionDate}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"Specimen ID"} />
                                <Form.Control
                                  name="vdrlSpecimenID"
                                  type="text"
                                  value={caseReportVDRLSpecimanID}
                                  disabled
                                  readOnly={isAdmin ? !isAdmin : !isAdmin}
                                  onChange={(e) => setcaseReportVDRLSpecimanID(e.target.value)}
                                />
                                <div className="error m-0">
                                  {
                                    newCaseReportValidationErrors.vdrlSpecimenID
                                  }
                                </div>
                              </Col>
                              <Col>
                                <AppLabel
                                  label={
                                    "Details"
                                  }
                                />
                                {
                                  isAdmin
                                    ?
                                    <Form.Select
                                      name="tetVDRL"
                                      value={detailsToVDRLTest}
                                      onChange={(e) => setdetailsToVDRLTest(e.target.value)}
                                      disabled
                                    >
                                      <option value="0">--</option>
                                      <option value="Positive">Positive (Reactive)</option>
                                      <option value="Negative">
                                        Negative (Non-Reactive)
                                      </option>
                                    </Form.Select>
                                    :
                                    <Form.Control
                                      type="text"
                                      value={detailsToVDRLTest}
                                      disabled
                                      readOnly={isAdmin ? !isAdmin : !isAdmin}
                                    />
                                }
                              </Col>
                              <Col>
                                <AppLabel label={"Titer"} />
                                <Form.Control
                                  type="text"
                                  value={caseReportVDRLTiter}
                                  onChange={(e) => setcaseReportVDRLTiter(e.target.value)}
                                  disabled
                                  readOnly={isAdmin ? !isAdmin : !isAdmin}
                                />
                              </Col>
                            </Row>
                            {historicalVDRL.length > 0 && (
                              <div style={{ marginTop: "15px" }}>
                                <AppLabel label="Historical VDRL Results" style={{ fontWeight: "bold" }} />

                                {historicalVDRL.map((row, index) => (
                                  <Row key={index} className="mb-3" style={{ paddingLeft: "20px" }}>
                                    <Col>
                                      <AppLabel label={`Specimen Date (History #${row.testHistoryRowNum - 1})`} />
                                      <Form.Control
                                        type="date"
                                        value={convertToISODate(row.testSpecimenDate)}
                                        disabled
                                      />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Specimen ID" />
                                      <Form.Control type="text" value={row.specimenId || ""} disabled />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Details" />
                                      <Form.Control type="text" value={row.qualitativeResult || ""} disabled />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Titer" />
                                      <Form.Control type="text" value={row.quantitativeResult || ""} disabled />
                                    </Col>
                                  </Row>
                                ))}
                              </div>
                            )}

                            <Row className="mb-3">
                              <AppLabel style={{
                                fontWeight: "bold",
                                marginBottom: "10px",
                                marginTop: "10px"
                              }} label={"TP-PA Information"} />
                              <Col>
                                <AppLabel label={"Specimen Collection Date"} />
                                <Form.Control
                                  {...register('tppaCollectionDate')}
                                  name="tppaCollectionDate"
                                  type="date"
                                  value={caseReportTPPASpecimanDate}
                                  disabled
                                  readOnly={isAdmin ? !isAdmin : !isAdmin}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setcaseReportTPPASpecimanDate(date)
                                    handleFormFieldChange(e);
                                  }
                                  }
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                />
                                <div className="error m-0">
                                  {newCaseReportValidationErrors.tppaCollectionDate}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"Specimen ID"} />
                                <Form.Control
                                  name="tppaSpecimenID"
                                  type="text"
                                  value={caseReportTPPASpecimanID}
                                  onChange={(e) => setcaseReportTPPASpecimanID(e.target.value)}
                                  disabled
                                  readOnly={isAdmin ? !isAdmin : !isAdmin}
                                />
                                <div className="error m-0">
                                  {
                                    newCaseReportValidationErrors.tppaSpecimenID
                                  }
                                </div>
                              </Col>
                              <Col>
                                <AppLabel
                                  label={
                                    "Details"
                                  }
                                />
                                {
                                  isAdmin
                                    ?
                                    <Form.Select
                                      name="testTPPA"
                                      value={detailsToTPPATest}
                                      onChange={(e) => setdetailsToTPPATest(e.target.value)}
                                      disabled
                                    >
                                      <option value="0">--</option>
                                      <option value="Positive">Positive</option>
                                      <option value="Negative">
                                        Negative
                                      </option>
                                    </Form.Select>
                                    :
                                    <Form.Control
                                      type="text"
                                      value={detailsToTPPATest}
                                      disabled
                                      readOnly={isAdmin ? !isAdmin : !isAdmin}
                                    />
                                }
                              </Col>
                            </Row>
                            {historicalTPPA.length > 0 && (
                              <div style={{ marginTop: "15px" }}>
                                <AppLabel label="Historical TP-PA Results" style={{ fontWeight: "bold" }} />

                                {historicalTPPA.map((row, index) => (
                                  <Row key={index} className="mb-3" style={{ paddingLeft: "20px" }}>
                                    <Col>
                                      <AppLabel label={`Specimen Date (History #${row.testHistoryRowNum - 1})`} />
                                      <Form.Control
                                        type="date"
                                        value={convertToISODate(row.testSpecimenDate)}
                                        disabled
                                      />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Specimen ID" />
                                      <Form.Control type="text" value={row.specimenId || ""} disabled />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Details" />
                                      <Form.Control type="text" value={row.qualitativeResult || ""} disabled />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Titer" />
                                      <Form.Control type="text" value={row.quantitativeResult || ""} disabled />
                                    </Col>
                                  </Row>
                                ))}
                              </div>
                            )}

                            <Row className="mb-3">
                              <AppLabel style={{
                                fontWeight: "bold",
                                marginBottom: "10px",
                                marginTop: "10px"
                              }} label={"FTA-ABS Information "} />
                              <Col>
                                <AppLabel label={"Specimen Collection Date"} />
                                <Form.Control
                                  {...register('ftaabsCollectionDate')}
                                  name="ftaabsCollectionDate"
                                  type="date"
                                  value={caseReportFTAABSSpecimanDate}
                                  disabled
                                  readOnly={isAdmin ? !isAdmin : !isAdmin}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setcaseReportFTAABSpecimanDate(date)
                                    handleFormFieldChange(e)
                                  }
                                  }
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                />
                                <div className="error m-0">
                                  {newCaseReportValidationErrors.ftaabsCollectionDate}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"Specimen ID"} />
                                <Form.Control
                                  name="ftaabsSpecimenID"
                                  type="text"
                                  value={caseReportFTAABSSpecimanID}
                                  onChange={(e) => setcaseReportFTAABSpecimanID(e.target.value)}
                                  disabled
                                  readOnly={isAdmin ? !isAdmin : !isAdmin}
                                />
                              </Col>
                              <Col>
                                <AppLabel
                                  label={
                                    "Details"
                                  }
                                />
                                {
                                  isAdmin
                                    ?

                                    <Form.Select
                                      name="testFTAABS"
                                      value={detailsToFTAABSTest}
                                      onChange={(e) => setdetailsToFTAABSTest(e.target.value)}
                                      disabled
                                    >
                                      <option value="0">--</option>
                                      <option value="Positive">Positive</option>
                                      <option value="Negative">
                                        Negative
                                      </option>
                                    </Form.Select>
                                    :
                                    <Form.Control
                                      type="text"
                                      value={detailsToFTAABSTest}
                                      disabled
                                      readOnly={isAdmin ? !isAdmin : !isAdmin}
                                    />
                                }
                              </Col>
                            </Row>
                            {historicalFTAABS.length > 0 && (
                              <div style={{ marginTop: "15px" }}>
                                <AppLabel label="Historical FTA-ABS Results" style={{ fontWeight: "bold" }} />

                                {historicalFTAABS.map((row, index) => (
                                  <Row key={index} className="mb-3" style={{ paddingLeft: "20px" }}>
                                    <Col>
                                      <AppLabel label={`Specimen Date (History #${row.testHistoryRowNum - 1})`} />
                                      <Form.Control
                                        type="date"
                                        value={convertToISODate(row.testSpecimenDate)}
                                        disabled
                                      />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Specimen ID" />
                                      <Form.Control type="text" value={row.specimenId || ""} disabled />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Details" />
                                      <Form.Control type="text" value={row.qualitativeResult || ""} disabled />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Titer" />
                                      <Form.Control type="text" value={row.quantitativeResult || ""} disabled />
                                    </Col>
                                  </Row>
                                ))}
                              </div>
                            )}

                            <Row className="mb-3">
                              <AppLabel
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: "10px",
                                  marginTop: "10px"
                                }}
                                label={"EIA Information"}
                              />

                              {/* SPECIMEN COLLECTION DATE */}
                              <Col>
                                <AppLabel label={"Specimen Collection Date"} />
                                <Form.Control
                                  name="eiaIgGSpecimenCollectionDate"
                                  type="date"
                                  value={
                                    caseReportEIAIgGSpecimenDate
                                      ? caseReportEIAIgGSpecimenDate.split("T")[0]
                                      : ""
                                  }
                                  disabled
                                  readOnly
                                />
                              </Col>

                              {/* SPECIMEN ID */}
                              <Col>
                                <AppLabel label={"Specimen ID"} />
                                <Form.Control
                                  name="eiaIgGSpecimenId"
                                  type="text"
                                  value={caseReportEIAIgGSpecimenID}
                                  disabled
                                  readOnly
                                />
                              </Col>

                              {/* DETAILS */}
                              <Col> <AppLabel label={"Details"} /> {isAdmin ? (<Form.Select name="eiaIgGDetails" value={detailsToEIAIgGTest}
                                onChange={(e) => setDetailsToEIAIgGTest(e.target.value)} disabled > <option value="0">--</option>
                                <option value="Positive">Reactive</option>
                                <option value=">Negative">Non-Reactive</option>
                              </Form.Select>) : (<Form.Control type="text" value={detailsToEIAIgGTest} disabled readOnly />)} </Col>
                            </Row>
                            {historicalEIAIgG.length > 0 && (
                              <div style={{ marginTop: "15px" }}>
                                <AppLabel label="Historical EIA IgG Results" style={{ fontWeight: "bold" }} />

                                {historicalEIAIgG.map((row, index) => (
                                  <Row key={index} className="mb-3" style={{ paddingLeft: "20px" }}>
                                    <Col>
                                      <AppLabel label={`Specimen Date (History #${row.testHistoryRowNum - 1})`} />
                                      <Form.Control
                                        type="date"
                                        value={convertToISODate(row.testSpecimenDate)}
                                        disabled
                                      />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Specimen ID" />
                                      <Form.Control type="text" value={row.specimenId || ""} disabled />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Details" />
                                      <Form.Control type="text" value={row.qualitativeResult || ""} disabled />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Titer" />
                                      <Form.Control type="text" value={row.quantitativeResult || ""} disabled />
                                    </Col>
                                  </Row>
                                ))}
                              </div>
                            )}

                            <Row className="mb-3">
                              <AppLabel style={{
                                fontWeight: "bold",
                                marginBottom: "10px",
                                marginTop: "10px"
                              }} label={"Chlamydia [200] Test Information "} />
                              <Col>
                                <AppLabel label={"Specimen Collection Date"} />
                                <Form.Control
                                  {...register('chlamydiaCollectionDate')}
                                  name="chlamydiaCollectionDate"
                                  type="date"
                                  value={caseReportChlamydiaSpecimanDate}
                                  disabled
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setcaseReportChlamydiaSpecimanDate(date)
                                    handleFormFieldChange(e)
                                  }}
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                />
                                <div className="error m-0">
                                  {newCaseReportValidationErrors.chlamydiaCollectionDate}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"Specimen ID"} />
                                <Form.Control
                                  name="chlamydiaSpecimenID"
                                  type="text"
                                  value={caseReportChlamydiaSpecimanID}
                                  disabled
                                  onChange={(e) => setcaseReportChlamydiaSpecimanID(e.target.value)}
                                />
                                <div className="error m-0">
                                  {
                                    newCaseReportValidationErrors.chlamydiaSpecimenID
                                  }
                                </div>
                              </Col>
                              <Col>
                                <AppLabel
                                  label={
                                    "Details"
                                  }

                                />
                                <Form.Select
                                  id="county"
                                  value={detailsToChlamydiaTest}
                                  disabled
                                  onChange={e => setdetailsToChlamydiaTest(e.target.value)}
                                >
                                  <option value="0">--</option>
                                  <option value="Positive"> Positive </option>
                                  <option value="Negative"> Negative </option>
                                </Form.Select>
                              </Col>
                            </Row>
                            {historicalChlamydia.length > 0 && (
                              <div style={{ marginTop: "15px" }}>
                                <AppLabel
                                  label="Historical Chlamydia [200] Results"
                                  style={{ fontWeight: "bold" }}
                                />

                                {historicalChlamydia.map((row, index) => (
                                  <Row key={index} className="mb-3" style={{ paddingLeft: "20px" }}>

                                    <Col>
                                      <AppLabel label={`Specimen Date (History #${row.testHistoryRowNum - 1})`} />
                                      <Form.Control
                                        type="date"
                                        value={convertToISODate(row.testSpecimenDate)}
                                        disabled
                                      />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Specimen ID" />
                                      <Form.Control type="text" value={row.specimenId || ""} disabled />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Details" />
                                      <Form.Control
                                        type="text"
                                        value={row.qualitativeResult || ""}
                                        disabled
                                      />
                                    </Col>

                                  </Row>
                                ))}
                              </div>
                            )}

                            <Row className="mb-3">
                              <AppLabel style={{
                                fontWeight: "bold",
                                marginBottom: "10px",
                                marginTop: "10px"
                              }} label={"Gonorrhea [300] Test Information "} />
                              <Col>
                                <AppLabel label={"Specimen Collection Date"} />
                                <Form.Control
                                  {...register('gonorrheaCollectionDate')}
                                  name="gonorrheaCollectionDate"
                                  type="date"
                                  disabled
                                  value={caseReportGonorrheaSpecimanDate}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setcaseReportGonorrheaSpecimanDate(date)
                                    handleFormFieldChange(e)
                                  }}
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                />
                                <div className="error m-0">
                                  {newCaseReportValidationErrors.gonorrheaCollectionDate}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"Specimen ID"} />
                                <Form.Control
                                  name="gonorrheaSpecimenID"
                                  type="text"
                                  disabled
                                  value={caseReportGonorrheaSpecimanID}
                                  onChange={(e) => setcaseReportGonorrheaSpecimanID(e.target.value)
                                  }
                                />
                                <div className="error m-0">
                                  {
                                    newCaseReportValidationErrors.gonorrheaSpecimenID
                                  }
                                </div>
                              </Col>
                              <Col>
                                <AppLabel
                                  label={
                                    "Details"
                                  }

                                />
                                <Form.Select
                                  id="county"
                                  value={detailsGonorrheaTest}
                                  disabled
                                  onChange={e => setdetailsToGonorrheaTest(e.target.value)}
                                >
                                  <option value="0">--</option>
                                  <option value="Positive"> Positive </option>
                                  <option value="Negative"> Negative </option>
                                </Form.Select>
                              </Col>
                            </Row>
                            {historicalGonorrhea.length > 0 && (
                              <div style={{ marginTop: "15px" }}>
                                <AppLabel
                                  label="Historical Gonorrhea [300] Results"
                                  style={{ fontWeight: "bold" }}
                                />

                                {historicalGonorrhea.map((row, index) => (
                                  <Row key={index} className="mb-3" style={{ paddingLeft: "20px" }}>

                                    <Col>
                                      <AppLabel label={`Specimen Date (History #${row.testHistoryRowNum - 1})`} />
                                      <Form.Control
                                        type="date"
                                        value={convertToISODate(row.testSpecimenDate)}
                                        disabled
                                      />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Specimen ID" />
                                      <Form.Control type="text" value={row.specimenId || ""} disabled />
                                    </Col>

                                    <Col>
                                      <AppLabel label="Details" />
                                      <Form.Control
                                        type="text"
                                        value={row.qualitativeResult || ""}
                                        disabled
                                      />
                                    </Col>

                                  </Row>
                                ))}
                              </div>
                            )}
                          </Card.Body>
                        )}
                      </AppCard>
                    )}
                    <Form.Control
                      {...register('Source')}
                      type="hidden"
                      value={source}

                    />
                    {source !== "HIV" && (
                      <AppCard
                        title={
                          <div className="w-100" id="UpdatedSTDTestInformation">
                            <div className="section-header">
                              <span className="section-title">
                                Updated STD Test Information
                              </span>

                              <span
                                onClick={toggleUpdatedStd}
                                className="section-toggle"
                                title={isUpdatedStdCollapsed ? "Expand" : "Collapse"}
                                aria-label={isUpdatedStdCollapsed ? "Expand" : "Collapse"}
                              >
                                {isUpdatedStdCollapsed ? "+" : "−"}
                              </span>
                            </div>
                          </div>
                        }
                        bottomMargin>
                        {!isUpdatedStdCollapsed && (
                          <Card.Body>
                            {/* RPR */}
                            <Row className="mb-3">
                              <AppLabel style={{
                                fontWeight: "bold",
                                marginBottom: "10px"
                              }} label={"RPR Test Information"} />
                              <Col>
                                <AppLabel
                                  label={
                                    "Type"
                                  }
                                />

                                <Form.Select
                                  {...register('UpdatedRprType')}
                                  name="UpdatedRprType"
                                  value={updatedRPR_Type}
                                  //onChange={(e) => { setupdatedRPR_Type(e.target.value); handleFormFieldChange(e); }}
                                  onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    setupdatedRPR_Type(selectedValue); // Store ID

                                    if (selectedValue === "") {
                                      setUpdatedRprSpecimenCollectionDate("");
                                      setUpdatedRprSpecimenId("");
                                      setupdatedRPR_Result("");
                                      setUpdatedRprTiter("");

                                    }
                                  }}
                                >

                                  <option value="">Select Test Type</option> {/* Placeholder */}
                                  {caseReportTestData
                                    .filter((option) => option.value === 'RPR')
                                    .map((option) => (
                                      <option key={option.id} value={option.id}>
                                        {option.value1}
                                      </option>
                                    ))}
                                </Form.Select>

                                <div className="error m-0">
                                  {clientInfoValidationErrors.UpdatedRprType}
                                </div>

                                {/* {UpdatedRprType === "Other" && (
                                  <div>
                                    <br />
                                    <AppLabel label={"Specify Other Test"} />
                                    <Form.Control
                                      {...register('UpdatedRprType1')}
                                      name="UpdatedRprType1"
                                      type="text"
                                      value={UpdatedRprType1}
                                      onChange={(e) => { setUpdatedRprType1(e.target.value); handleFormFieldChange(e); }}
                                    />
                                    <div className="error m-0">
                                      {clientInfoValidationErrors.UpdatedRprType1}
                                    </div>
                                  </div>
                                )} */}
                              </Col>
                              <Col>
                                <AppLabel label={"Specimen Collection Date"} required={updatedRPR_Type != ""} />
                                <Form.Control
                                  {...register('UpdatedRprSpecimenCollectionDate')}
                                  name="UpdatedRprSpecimenCollectionDate"
                                  type="date"
                                  value={UpdatedRprSpecimenCollectionDate}
                                  //readOnly={isAdmin ? !isAdmin : !isAdmin}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setUpdatedRprSpecimenCollectionDate(date)
                                    handleFormFieldChange(e);
                                  }}
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                  disabled={!updatedRPR_Type}
                                />
                                <div className="error m-0">
                                  {clientInfoValidationErrors.UpdatedRprSpecimenCollectionDate}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"Specimen ID"} />
                                <Form.Control
                                  // {...register("UpdatedRprSpecimenId")}
                                  name="UpdatedRprSpecimenId"
                                  type="text"
                                  value={UpdatedRprSpecimenId}
                                  //readOnly={isAdmin ? !isAdmin : !isAdmin}
                                  onChange={(e) => { setUpdatedRprSpecimenId(e.target.value) }}
                                  maxLength={25}
                                  disabled={!updatedRPR_Type}
                                />
                                <div className="error m-0">
                                  {clientInfoValidationErrors.rprSpecimenID}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel
                                  label={
                                    "Details"
                                  }
                                  required={updatedRPR_Type != ""}
                                />

                                <Form.Select
                                  {...register("UpdatedRprDetails")}
                                  name="UpdatedRprDetails"
                                  value={updatedRPR_Result}
                                  onChange={(e) => {
                                    setupdatedRPR_Result(e.target.value);
                                    handleFormFieldChange(e);
                                    if (e.target.value === "" || e.target.value === "6") { //6 = NOn Reactive
                                      setUpdatedRprTiter("");
                                    }
                                  }}
                                  disabled={!updatedRPR_Type}
                                >
                                  <option value="">--</option>
                                  {caseReportResultData
                                    .filter((option) => option.value === 'Reactive' || option.value === 'Non-Reactive')
                                    .map((option) => (
                                      <option key={option.id} value={option.id}>
                                        {option.value}
                                      </option>
                                    ))}

                                </Form.Select>
                                <div className="error m-0">
                                  {clientInfoValidationErrors.UpdatedRprDetails}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"Titer"} />
                                <Form.Control
                                  // {...register("UpdatedRprTiter")}
                                  type="text"
                                  value={UpdatedRprTiter}
                                  onChange={(e) => setUpdatedRprTiter(e.target.value)}
                                  disabled={updatedRPR_Result !== '5'} // 5 =Reactive
                                  // readOnly={isAdmin ? !isAdmin : !isAdmin}
                                  maxLength={10}
                                />
                              </Col>
                            </Row>
                            {/* VDRL */}
                            <Row className="mb-3">
                              <AppLabel style={{
                                fontWeight: "bold",
                                marginBottom: "10px",
                                marginTop: "10px"
                              }} label={"CSF-VDRL Test Information"} />
                              <Col>
                                <AppLabel
                                  label={
                                    "Type"
                                  }
                                />

                                <Form.Select
                                  {...register("UpdatedVdrlType")}
                                  name="UpdatedVdrlType"
                                  value={updatedVDRL_Type}
                                  //onChange={(e) => { setupdatedVDRL_Type(e.target.value); }}
                                  onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    setupdatedVDRL_Type(selectedValue); // Store ID

                                    if (selectedValue === "") {
                                      setUpdatedVdrlSpecimenCollectionDate("");
                                      setUpdatedVdrlSpecimenId("");
                                      setupdatedVDRL_Result("");
                                      setUpdatedVdrlTiter("");
                                    }
                                  }}
                                >
                                  <option value="">Select Test Type</option> {/* Placeholder */}
                                  {caseReportTestData
                                    .filter((option) => option.value === 'VDRL')
                                    .map((option) => (
                                      <option key={option.id} value={option.id}>
                                        {option.value1}
                                      </option>
                                    ))}
                                </Form.Select>

                                <div className="error m-0">
                                  {clientInfoValidationErrors.UpdatedVdrlType}
                                </div>
                                {/* {UpdatedVdrlType === "Other" && (
                                  <div>
                                    <br />
                                    <AppLabel label={"Specify Other Test"} />
                                    <Form.Control
                                      {...register("UpdatedVdrlType1")}
                                      name="UpdatedVdrlType1"
                                      type="text"
                                      value={UpdatedVdrlType1}
                                      onChange={(e) => { setUpdatedVdrlType1(e.target.value); handleFormFieldChange(e); }}
                                    />
                                    <div className="error m-0">
                                      {clientInfoValidationErrors.UpdatedVdrlType1}
                                    </div>
                                  </div>
                                )} */}
                              </Col>
                              <Col>
                                <AppLabel label={"Specimen Collection Date"} required={updatedVDRL_Type != ""} />
                                <Form.Control
                                  {...register('UpdatedVdrlSpecimenCollectionDate')}
                                  name="UpdatedVdrlSpecimenCollectionDate"
                                  type="date"
                                  value={UpdatedVdrlSpecimenCollectionDate}
                                  // readOnly={isAdmin ? !isAdmin : !isAdmin}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setUpdatedVdrlSpecimenCollectionDate(date)
                                    handleFormFieldChange(e);
                                  }}
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                  disabled={!updatedVDRL_Type}
                                />
                                <div className="error m-0">
                                  {clientInfoValidationErrors.UpdatedVdrlSpecimenCollectionDate}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"Specimen ID"} />
                                <Form.Control
                                  //{...register('UpdatedVdrlSpecimenId')}
                                  name="UpdatedVdrlSpecimenId"
                                  type="text"
                                  value={UpdatedVdrlSpecimenId}
                                  //readOnly={isAdmin ? !isAdmin : !isAdmin}
                                  onChange={(e) => setUpdatedVdrlSpecimenId(e.target.value)}
                                  maxLength={25}
                                  disabled={!updatedVDRL_Type}
                                />
                                <div className="error m-0">
                                  {
                                    clientInfoValidationErrors.vdrlSpecimenID
                                  }
                                </div>
                              </Col>
                              <Col>
                                <AppLabel
                                  label={
                                    "Details"
                                  }
                                  required={updatedVDRL_Type != ""}
                                />

                                <Form.Select
                                  {...register('UpdatedVdrlDetails')}
                                  name="UpdatedVdrlDetails"
                                  value={updatedVDRL_Result}
                                  onChange={(e) => {
                                    setupdatedVDRL_Result(e.target.value);
                                    handleFormFieldChange(e);
                                    if (e.target.value === "" || e.target.value === "6") { //6 = Non reactive
                                      setUpdatedVdrlTiter("");
                                    }
                                  }}
                                  disabled={!updatedVDRL_Type}
                                >
                                  <option value="">--</option>
                                  {caseReportResultData
                                    .filter((option) => option.value === 'Reactive' || option.value === 'Non-Reactive')
                                    .map((option) => (
                                      <option key={option.id} value={option.id}>
                                        {option.value}
                                      </option>
                                    ))}

                                </Form.Select>
                                <div className="error m-0">
                                  {clientInfoValidationErrors.UpdatedVdrlDetails}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"Titer"} />
                                <Form.Control
                                  // {...register('UpdatedVdrlTiter')}
                                  type="text"
                                  value={UpdatedVdrlTiter}
                                  disabled={updatedVDRL_Result !== '5'} //5 =Reactive
                                  onChange={(e) => setUpdatedVdrlTiter(e.target.value)}
                                  //readOnly={isAdmin ? !isAdmin : !isAdmin}
                                  maxLength={10}
                                />
                              </Col>
                            </Row>
                            {/* TP-PA */}
                            <Row className="mb-3">
                              <AppLabel style={{
                                fontWeight: "bold",
                                marginBottom: "10px",
                                marginTop: "10px"
                              }} label={"TP-PA Information"} />
                              <Col>
                                <AppLabel
                                  label={
                                    "Type"
                                  }
                                />

                                <Form.Select
                                  {...register('UpdatedTpPaType')}
                                  name="UpdatedTpPaType"
                                  value={updatedTPPA_Type}
                                  //onChange={(e) => { setupdatedTPPA_Type(e.target.value); }}
                                  onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    setupdatedTPPA_Type(selectedValue); // Store ID

                                    if (selectedValue === "") {
                                      setUpdatedTpPaSpecimenCollectionDate("");
                                      setUpdatedTpPaSpecimenId("");
                                      setupdatedTPPA_Result("");
                                    }
                                  }}
                                >
                                  <option value="">Select Test Type</option> {/* Placeholder */}
                                  {caseReportTestData
                                    .filter((option) => option.value === 'TP-PA')
                                    .map((option) => (
                                      <option key={option.id} value={option.id}>
                                        {option.value1}
                                      </option>
                                    ))}
                                </Form.Select>
                                <div className="error m-0">
                                  {clientInfoValidationErrors.UpdatedTpPaType}
                                </div>
                                {/* {UpdatedTpPaType === "Other" && (
                                  <div>
                                    <br />
                                    <AppLabel label={"Specify Other Test"} />
                                    <Form.Control
                                      {...register('UpdatedTpPaType1')}
                                      name='UpdatedTpPaType1'
                                      type="text"
                                      value={UpdatedTpPaType1}
                                      onChange={(e) => { setUpdatedTpPaType1(e.target.value); handleFormFieldChange(e); }}
                                    />
                                    <div className="error m-0">
                                      {clientInfoValidationErrors.UpdatedTpPaType1}
                                    </div>
                                  </div>
                                )} */}
                              </Col>
                              <Col>
                                <AppLabel label={"Specimen Collection Date"} required={updatedTPPA_Type != ""} />
                                <Form.Control
                                  {...register('UpdatedTpPaSpecimenCollectionDate')}
                                  name="UpdatedTpPaSpecimenCollectionDate"
                                  type="date"
                                  value={UpdatedTpPaSpecimenCollectionDate}
                                  //readOnly={isAdmin ? !isAdmin : !isAdmin}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setUpdatedTpPaSpecimenCollectionDate(date)
                                    handleFormFieldChange(e);
                                  }}
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                  disabled={!updatedTPPA_Type}
                                />
                                <div className="error m-0">
                                  {clientInfoValidationErrors.UpdatedTpPaSpecimenCollectionDate}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"Specimen ID"} />
                                <Form.Control
                                  // {...register('UpdatedTpPaSpecimenId')}
                                  name="UpdatedTpPaSpecimenId"
                                  type="text"
                                  value={UpdatedTpPaSpecimenId}
                                  onChange={(e) => setUpdatedTpPaSpecimenId(e.target.value)}
                                  maxLength={25}
                                  disabled={!updatedTPPA_Type}
                                //readOnly={isAdmin ? !isAdmin : !isAdmin}
                                />
                                <div className="error m-0">
                                  {
                                    clientInfoValidationErrors.tppaSpecimenID
                                  }
                                </div>
                              </Col>
                              <Col>
                                <AppLabel
                                  label={
                                    "Details"
                                  }
                                  required={updatedTPPA_Type != ""}
                                />

                                <Form.Select
                                  {...register('UpdatedTpPaDetails')}
                                  name="UpdatedTpPaDetails"
                                  value={updatedTPPA_Result}
                                  onChange={(e) => { setupdatedTPPA_Result(e.target.value); handleFormFieldChange(e); }}
                                  disabled={!updatedTPPA_Type}
                                >
                                  <option value="">--</option>
                                  {caseReportResultData
                                    .filter((option) => option.value === 'Reactive' || option.value === 'Non-Reactive')
                                    .map((option) => (
                                      <option key={option.id} value={option.id}>
                                        {option.value}
                                      </option>
                                    ))}

                                </Form.Select>
                                <div className="error m-0">
                                  {clientInfoValidationErrors.UpdatedTpPaDetails}
                                </div>
                              </Col>
                            </Row>
                            {/* FTA-ABS */}
                            <Row className="mb-3">
                              <AppLabel style={{
                                fontWeight: "bold",
                                marginBottom: "10px",
                                marginTop: "10px"
                              }} label={"FTA-ABS Information "} />
                              <Col>
                                <AppLabel
                                  label={
                                    "Type"
                                  }
                                />

                                <Form.Select
                                  {...register('UpdatedFtaAbsType')}
                                  name="UpdatedFtaAbsType"
                                  value={updatedFTAABS_Type}
                                  //onChange={(e) => { setupdatedFTAABS_Type(e.target.value); }}
                                  onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    setupdatedFTAABS_Type(selectedValue); // Store ID

                                    if (selectedValue === "") {
                                      setUpdatedFtaAbsSpecimenCollectionDate("");
                                      setUpdatedFtaAbsSpecimenId("");
                                      setupdatedFTAABS_Result("");
                                    }
                                  }}
                                >
                                  <option value="">Select Test Type</option> {/* Placeholder */}
                                  {caseReportTestData
                                    .filter((option) => option.value === 'FTA-ABS')
                                    .map((option) => (
                                      <option key={option.id} value={option.id}>
                                        {option.value1}
                                      </option>
                                    ))}
                                </Form.Select>
                                <div className="error m-0">
                                  {clientInfoValidationErrors.UpdatedFtaAbsType}
                                </div>
                                {/* {UpdatedFtaAbsType === "Other" && (
                                  <div>
                                    <br />
                                    <AppLabel label={"Specify Other Test"} />
                                    <Form.Control
                                      {...register('UpdatedFtaAbsType1')}
                                      name='UpdatedFtaAbsType1'
                                      type="text"
                                      value={UpdatedFtaAbsType1}
                                      onChange={(e) => { setUpdatedFtaAbsType1(e.target.value); handleFormFieldChange(e); }}
                                    />
                                    <div className="error m-0">
                                      {clientInfoValidationErrors.UpdatedFtaAbsType1}
                                    </div>
                                  </div>
                                )} */}
                              </Col>
                              <Col>
                                <AppLabel label={"Specimen Collection Date"} required={updatedFTAABS_Type != ""} />
                                <Form.Control
                                  {...register('UpdatedFtaAbsSpecimenCollectionDate')}
                                  name="UpdatedFtaAbsSpecimenCollectionDate"
                                  type="date"
                                  value={UpdatedFtaAbsSpecimenCollectionDate}
                                  //readOnly={isAdmin ? !isAdmin : !isAdmin}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setUpdatedFtaAbsSpecimenCollectionDate(date)
                                    handleFormFieldChange(e);
                                  }}
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                  disabled={!updatedFTAABS_Type}
                                />
                                <div className="error m-0">
                                  {clientInfoValidationErrors.UpdatedFtaAbsSpecimenCollectionDate}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"Specimen ID"} />
                                <Form.Control
                                  // {...register('UpdatedFtaAbsSpecimenId')}
                                  name="UpdatedFtaAbsSpecimenId"
                                  type="text"
                                  value={UpdatedFtaAbsSpecimenId}
                                  onChange={(e) => setUpdatedFtaAbsSpecimenId(e.target.value)}
                                  maxLength={25}
                                  disabled={!updatedFTAABS_Type}
                                // readOnly={isAdmin ? !isAdmin : !isAdmin}
                                />
                              </Col>
                              <Col>
                                <AppLabel
                                  label={
                                    "Details"
                                  }
                                  required={updatedFTAABS_Type != ""}
                                />

                                <Form.Select
                                  {...register('UpdatedFtaAbsDetails')}
                                  name="UpdatedFtaAbsDetails"
                                  value={updatedFTAABS_Result}
                                  onChange={(e) => { setupdatedFTAABS_Result(e.target.value); handleFormFieldChange(e); }}
                                  disabled={!updatedFTAABS_Type}
                                >
                                  <option value="">--</option>
                                  {caseReportResultData
                                    .filter((option) => option.value === 'Reactive' || option.value === 'Non-Reactive')
                                    .map((option) => (
                                      <option key={option.id} value={option.id}>
                                        {option.value}
                                      </option>
                                    ))}
                                </Form.Select>
                                <div className="error m-0">
                                  {clientInfoValidationErrors.UpdatedFtaAbsDetails}
                                </div>
                              </Col>
                            </Row>
                            {/* EIA */}
                            <Row className="mb-3">
                              <AppLabel
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: "10px",
                                  marginTop: "10px",
                                }}
                                label={"EIA Information "}
                              />

                              {/* TYPE */}
                              <Col>
                                <AppLabel label={"Type"} />
                                <Form.Select
                                  {...register("UpdatedEiaType")}
                                  name="UpdatedEiaType"
                                  value={UpdatedEiaType}
                                  onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    setUpdatedEiaType(selectedValue);

                                    if (selectedValue === "") {
                                      setUpdatedEiaSpecimenCollectionDate("");
                                      setUpdatedEiaSpecimenId("");
                                      setUpdatedEiaDetails("");
                                    }
                                  }}
                                >
                                  <option value="">Select Test Type</option>
                                  {caseReportTestData
                                    .filter((option) => option.value === "EIA")
                                    .map((option) => (
                                      <option key={option.id} value={option.id}>
                                        {option.value1}
                                      </option>
                                    ))}
                                </Form.Select>

                                <div className="error m-0">
                                  {clientInfoValidationErrors.UpdatedEiaType}
                                </div>
                              </Col>

                              {/* SPECIMEN COLLECTION DATE */}
                              <Col>
                                <AppLabel
                                  label={"Specimen Collection Date"}
                                  required={UpdatedEiaType !== ""}
                                />
                                <Form.Control
                                  {...register("UpdatedEiaSpecimenCollectionDate")}
                                  name="UpdatedEiaSpecimenCollectionDate"
                                  type="date"
                                  value={UpdatedEiaSpecimenCollectionDate}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(e.target.value, maxDate);
                                    setUpdatedEiaSpecimenCollectionDate(date);
                                    handleFormFieldChange(e);
                                  }}
                                  max={maxDate}
                                  min={minDate}
                                  disabled={!UpdatedEiaType}
                                />
                                <div className="error m-0">
                                  {clientInfoValidationErrors.UpdatedEiaSpecimenCollectionDate}
                                </div>
                              </Col>

                              {/* SPECIMEN ID */}
                              <Col>
                                <AppLabel label={"Specimen ID"} />
                                <Form.Control
                                  name="UpdatedEiaSpecimenId"
                                  type="text"
                                  value={UpdatedEiaSpecimenId}
                                  onChange={(e) => setUpdatedEiaSpecimenId(e.target.value)}
                                  maxLength={15}
                                  disabled={!UpdatedEiaType}
                                />
                                <div className="error m-0">
                                  {clientInfoValidationErrors.UpdatedEiaSpecimenId}
                                </div>
                              </Col>

                              {/* DETAILS */}
                              <Col>
                                <AppLabel
                                  label={"Details"}
                                  required={UpdatedEiaType !== ""}
                                />
                                <Form.Select
                                  {...register("UpdatedEiaDetails")}
                                  name="UpdatedEiaDetails"
                                  value={UpdatedEiaDetails}
                                  onChange={(e) => {
                                    setUpdatedEiaDetails(e.target.value);
                                    handleFormFieldChange(e);
                                  }}
                                  disabled={!UpdatedEiaType}
                                >
                                  <option value="">--</option>
                                  {caseReportResultData
                                    .filter(
                                      (option) =>
                                        option.value === "Reactive" || option.value === "Non-Reactive"
                                    )
                                    .map((option) => (
                                      <option key={option.id} value={option.id}>
                                        {option.value}
                                      </option>
                                    ))}
                                </Form.Select>

                                <div className="error m-0">
                                  {clientInfoValidationErrors.UpdatedEiaDetails}
                                </div>
                              </Col>
                            </Row>
                            {/* Chlamydia */}
                            <Row className="mb-3">
                              <AppLabel style={{
                                fontWeight: "bold",
                                marginBottom: "10px",
                                marginTop: "10px"
                              }} label={"Chlamydia [200] Test Information "} />
                              <Col>
                                <AppLabel
                                  label={
                                    "Type"
                                  }
                                />
                                <Form.Select
                                  {...register('UpdatedChlamydiaType')}
                                  name="UpdatedChlamydiaType"
                                  value={updatedChlamydia_Type}
                                  //onChange={(e) => { setupdatedChlamydia_Type(e.target.value); }}
                                  onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    setupdatedChlamydia_Type(selectedValue); // Store ID

                                    if (selectedValue === "") {
                                      setUpdatedChlamydiaDate("");
                                      setUpdatedChlamydiaSpecimenId("");
                                      setupdatedChlamydia_Result("");
                                    }
                                  }}
                                >
                                  <option value="">Select Test Type</option> {/* Placeholder */}
                                  {caseReportTestData
                                    .filter((option) => option.value === 'Chlamydia')
                                    .map((option) => (
                                      <option key={option.id} value={option.id}>
                                        {option.value1}
                                      </option>
                                    ))}
                                </Form.Select>
                                <div className="error m-0">
                                  {clientInfoValidationErrors.UpdatedChlamydiaType}
                                </div>
                                {/* {UpdatedChlamydiaType === "Other" && (
                                  <div>
                                    <br />
                                    <AppLabel label={"Specify Other Test"} />
                                    <Form.Control
                                      {...register('UpdatedChlamydiaType1')}
                                      name='UpdatedChlamydiaType1'
                                      type="text"
                                      value={UpdatedChlamydiaType1}
                                      onChange={(e) => { setUpdatedChlamydiaType1(e.target.value); handleFormFieldChange(e); }}
                                    />
                                    <div className="error m-0">
                                      {clientInfoValidationErrors.UpdatedChlamydiaType1}
                                    </div>
                                  </div>
                                )} */}
                              </Col>
                              <Col>
                                <AppLabel label={"Specimen Collection Date"} required={updatedChlamydia_Type != ""} />
                                <Form.Control
                                  {...register('UpdatedChlamydiaDate')}
                                  name="UpdatedChlamydiaDate"
                                  type="date"
                                  value={UpdatedChlamydiaDate}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setUpdatedChlamydiaDate(date)
                                    handleFormFieldChange(e);
                                  }}
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                  disabled={!updatedChlamydia_Type}
                                />
                                <div className="error m-0">
                                  {clientInfoValidationErrors.UpdatedChlamydiaDate}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"Specimen ID"} />

                                <Form.Control
                                  // {...register('UpdatedChlamydiaSpecimenId')}
                                  name="UpdatedChlamydiaSpecimenId"
                                  type="text"
                                  value={UpdatedChlamydiaSpecimenId}
                                  onChange={(e) => setUpdatedChlamydiaSpecimenId(e.target.value)}
                                  maxLength={25}
                                  disabled={!updatedChlamydia_Type}
                                />
                                <div className="error m-0">
                                  {
                                    clientInfoValidationErrors.chlamydiaSpecimenID
                                  }
                                </div>
                              </Col>
                              <Col>
                                <AppLabel
                                  label={
                                    "Details"
                                  }
                                  required={updatedChlamydia_Type != ""}
                                />
                                <Form.Select
                                  {...register('UpdatedChlamydiaDetails')}
                                  name="UpdatedChlamydiaDetails"
                                  value={updatedChlamydia_Result}
                                  onChange={e => { setupdatedChlamydia_Result(e.target.value); handleFormFieldChange(e); }}
                                  disabled={!updatedChlamydia_Type}
                                >
                                  <option value="">--</option>
                                  {caseReportResultData
                                    .filter((option) => option.value === 'Positive' || option.value === 'Negative')
                                    .map((option) => (
                                      <option key={option.id} value={option.id}>
                                        {option.value}
                                      </option>
                                    ))}
                                </Form.Select>
                                <div className="error m-0">
                                  {clientInfoValidationErrors.UpdatedChlamydiaDetails}
                                </div>
                              </Col>
                            </Row>
                            {/* Gonorrhea */}
                            <Row className="mb-3">
                              <AppLabel style={{
                                fontWeight: "bold",
                                marginBottom: "10px",
                                marginTop: "10px"
                              }} label={"Gonorrhea [300] Test Information "} />
                              <Col>
                                <AppLabel
                                  label={
                                    "Type"
                                  }
                                />
                                <Form.Select
                                  {...register('UpdatedGonorrheaType')}
                                  name="UpdatedGonorrheaType"
                                  value={updatedGonorrhea_Type}
                                  //onChange={(e) => { setupdatedGonorrhea_Type(e.target.value); }}
                                  onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    setupdatedGonorrhea_Type(selectedValue); // Store ID

                                    if (selectedValue === "") {
                                      setUpdatedGonorrheaSpecimenCollectionDate("");
                                      setUpdatedGonorrheaSpecimenId("");
                                      setupdatedGonorrhea_Result("");
                                    }
                                  }}
                                >
                                  <option value="">Select Test Type</option> {/* Placeholder */}
                                  {caseReportTestData
                                    .filter((option) => option.value === 'Gonorrhea')
                                    .map((option) => (
                                      <option key={option.id} value={option.id}>
                                        {option.value1}
                                      </option>
                                    ))}
                                </Form.Select>
                                <div className="error m-0">
                                  {clientInfoValidationErrors.UpdatedGonorrheaType}
                                </div>
                                {/* {UpdatedGonorrheaType === "Other" && (
                                  <div>
                                    <br />
                                    <AppLabel label={"Specify Other Test"} />
                                    <Form.Control
                                      {...register('UpdatedGonorrheaType1')}
                                      name='UpdatedGonorrheaType1'
                                      type="text"
                                      value={UpdatedGonorrheaType1}
                                      onChange={(e) => setUpdatedGonorrheaType1(e.target.value)}
                                    />
                                    <div className="error m-0">
                                      {clientInfoValidationErrors.UpdatedGonorrheaType1}
                                    </div>
                                  </div>
                                )} */}
                              </Col>
                              <Col>
                                <AppLabel label={"Specimen Collection Date"} required={updatedGonorrhea_Type != ""} />
                                <Form.Control
                                  {...register('UpdatedGonorrheaSpecimenCollectionDate')}
                                  name="UpdatedGonorrheaSpecimenCollectionDate"
                                  type="date"
                                  value={UpdatedGonorrheaSpecimenCollectionDate}
                                  onChange={(e) => {
                                    const date = adjustDateToMax(
                                      e.target.value,
                                      maxDate
                                    );
                                    setUpdatedGonorrheaSpecimenCollectionDate(date)
                                    handleFormFieldChange(e);
                                  }}
                                  max={maxDate} // Set the max attribute to today
                                  min={minDate}
                                  disabled={!updatedGonorrhea_Type}
                                />
                                <div className="error m-0">
                                  {clientInfoValidationErrors.UpdatedGonorrheaSpecimenCollectionDate}
                                </div>
                              </Col>
                              <Col>
                                <AppLabel label={"Specimen ID"} />
                                <Form.Control
                                  //{...register('UpdatedGonorrheaSpecimenId')}
                                  name="UpdatedGonorrheaSpecimenId"
                                  type="text"
                                  value={UpdatedGonorrheaSpecimenId}
                                  onChange={(e) => setUpdatedGonorrheaSpecimenId(e.target.value)}
                                  maxLength={25}
                                  disabled={!updatedGonorrhea_Type}
                                />
                                <div className="error m-0">
                                  {
                                    clientInfoValidationErrors.gonorrheaSpecimenID
                                  }
                                </div>
                              </Col>
                              <Col>
                                <AppLabel
                                  label={
                                    "Details"
                                  }
                                  required={updatedGonorrhea_Type != ""}
                                />
                                <Form.Select
                                  {...register('UpdatedGonorrheaDetails')}
                                  name="UpdatedGonorrheaDetails"
                                  value={updatedGonorrhea_Result}
                                  onChange={e => { setupdatedGonorrhea_Result(e.target.value); handleFormFieldChange(e); }}
                                  disabled={!updatedGonorrhea_Type}
                                >
                                  <option value="">--</option>
                                  {caseReportResultData
                                    .filter((option) => option.value === 'Positive' || option.value === 'Negative')
                                    .map((option) => (
                                      <option key={option.id} value={option.id}>
                                        {option.value}
                                      </option>
                                    ))}
                                </Form.Select>
                                <div className="error m-0">
                                  {clientInfoValidationErrors.UpdatedGonorrheaDetails}
                                </div>
                              </Col>
                            </Row>
                          </Card.Body>
                        )}
                      </AppCard>
                    )}

                    {/* Pregnancy Section */}

                    {clientInfoBirthGender?.toLowerCase() == "female" && (
                      <AppCard title={
                        <div className="w-100" id='PregnancyInformation'>
                          <div
                            className="section-header"
                          >
                            <span className="section-title">
                              Pregnancy Information
                            </span>
                          </div>
                        </div>
                      } bottomMargin>
                        <Card.Body>
                          <Row className="mb-3">
                            <Col>
                              <AppLabel label={"Pregnant"} required />
                              <Form.Select
                                {...register("EditCaseIsPregnant")}
                                name="EditCaseIsPregnant"
                                value={caseReportPregnant}
                                onChange={handlePregnantChange}
                              // disabled={caseReportPregnantIsDisabled}
                              >
                                <option value=""> -- </option> {/* Placeholder */}
                                {clientInfoStatusTypeData.map((option) => (
                                  <option key={option.id} value={option.id}>
                                    {option.value}
                                  </option>
                                ))}
                              </Form.Select>
                              <div className="error m-0">
                                {clientInfoValidationErrors.EditCaseIsPregnant}
                              </div>
                            </Col>
                            <Col>
                              <AppLabel label={"EDD"} />
                              <Form.Control


                                type="date"
                                value={caseReportEDD}
                                onChange={(e) => {
                                  const date = adjustDateToMin(
                                    e.target.value,
                                    new Date().toISOString().split("T")[0] // today’s date
                                  );
                                  setCaseReportEDD(date);
                                }}
                                min={new Date().toISOString().split("T")[0]} // restrict to today onwards
                              />


                            </Col>
                            <Col>
                              <AppLabel label={"LMP Date"} required={caseReportPregnant == "1"} />
                              <Form.Control
                                {...register("EditCaseLMPDate")}
                                name="EditCaseLMPDate"
                                type="date"
                                value={caseReportDateLMP}
                                // onChange={(e) => setCaseReportDateLMP(e.target.value)}
                                onChange={(e) => {
                                  const date = adjustDateToMax(
                                    e.target.value,
                                    maxDate
                                  );
                                  setCaseReportDateLMP(date)
                                  handleFormFieldChange(e);
                                }
                                }
                                max={maxDate} // Set the max attribute to today
                                min={minDate}
                              />
                              <div className="error m-0">
                                {newCaseReportValidationErrors.EditCaseLMPDate}
                              </div>
                            </Col>
                          </Row>
                        </Card.Body>
                      </AppCard>
                    )}
                    <AppCard title={
                      <div className="w-100" id="AdditionalNotes">
                        <div className="section-header">
                          <span className="section-title">
                            Additional Notes
                          </span>
                        </div>
                      </div>
                    } bottomMargin>
                      <Row className="mb-3">
                        <Col>
                          <AppLabel style={{ fontWeight: "bold" }} label={"Treatment/Additional Notes"} />
                          <Form.Control
                            as="textarea"
                            value={clientAdditionalNotes}
                            onChange={(e) => setClientAdditionalNotes(e.target.value)}
                            maxLength={1500}
                            rows={3}
                          />
                          <div style={{ fontSize: '0.85rem', color: '#6c757d', textAlign: 'right', marginTop: '4px' }}>
                            Character Count: {clientAdditionalNotes ? clientAdditionalNotes.length : 0} / 1500
                          </div>
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <Col>
                          <AppLabel style={{ fontWeight: "bold" }} label={"DOH Notes/Outcome"} />
                          <Col></Col>
                          <Form.Control
                            as="textarea"
                            value={clientDOHNotes}
                            onChange={(e) => setClientDOHNotes(e.target.value)}
                            maxLength={1500}
                            rows={3}
                            disabled={!isAdmin}
                          />
                          <div style={{ fontSize: '0.85rem', color: '#6c757d', textAlign: 'right', marginTop: '4px' }}>
                            Character Count: {clientDOHNotes ? clientDOHNotes.length : 0} / 1500
                          </div>
                        </Col>
                      </Row>
                    </AppCard>
                  </main>
                </form>
                <Row className="mb-3 justify-content-end">
                  <div className="container d-flex justify-content-end align-items-center flex-wrap flex-column flex-lg-row">
                    <Col className="text-center">
                      {clientInfoErrorMessage && (
                        <p style={{ color: "red" }}>
                          <b>{clientInfoErrorMessage}</b>
                        </p>
                      )}
                    </Col>
                    <Col className="text-end me-2">
                      <AppButton
                        variant="secondary"
                        customClasses={['ms-3', 'me-2']}
                        onClick={(e) => {
                          handleCancelClick(e);
                          window.scrollTo({
                            top: 0,
                            behavior: "smooth",
                          }); // Bring focus back to the top}
                        }}
                      >
                        Cancel
                      </AppButton>
                      <AppButton
                        variant="primary"
                        onClick={handleClientInfoSave}
                        disabled={isClientInfoSubmitting}
                      >
                        Save
                      </AppButton>
                    </Col>
                  </div>
                </Row>
              </div>}
            </>) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
        <div>
          &nbsp;
          <br></br>
        </div>
      </Container>

      {/* Floating sticky navigation */}
      {showPatientInfo && (
        <div>
          <div className="col-sm-2">
            <button
              type="button"
              className="nav-toggle"
              onClick={handleNavToggle}
              style={{
                position: 'fixed',
                right: `${navToggleRightOffset}px`,
                top: '35%',
                transform: 'translateY(-50%)',
                background: '#004e6a',
                border: '2px solid #0070f3',
                borderRadius: '4px',
                fontSize: '16px',
                cursor: 'pointer',
                padding: '6px 8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 101,
                transition: 'all 0.3s ease',
                color: 'white',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#0051a2';
                e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#004e6a';
                e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.2)';
              }}
              title={isNavCollapsed ? 'Expand navigation' : 'Collapse navigation'}
            >
              {isNavCollapsed ? '\u25C0' : '\u25B6'}
            </button>

          </div>

          <div className="col-sm-10">
            <nav className="sticky-nav">
              {!isNavCollapsed && navItems.map((item) => (
                <a
                  key={item.id}
                  href={`#${item.id}`}
                  className="nav-btn"
                  onClick={(e) => handleNavItemClick(e, item.id)}
                >
                  {item.label}
                </a>
              ))}

            </nav>
          </div>
        </div>
      )}

      <br />
      <Row>
        <Col className="text-center">
          {errorMessage && (
            <p style={{ color: "red" }}>
              <b>{errorMessage}</b>
            </p>
          )}
        </Col>
      </Row>
      {/* New Case Report  */}

      {showNewCase && searchResults == 0 ? (
        <Container>
          {!caseReportErrorMessage && (
            <>
              <Row className="mb-3 justify-content-end">
                <div className="container d-flex justify-content-end align-items-center flex-wrap flex-column flex-lg-row">
                  <Col className="text-end">
                    <AppButton variant="primary" onClick={handleAddCaseReport}>
                      Enter New Case Report
                    </AppButton>
                  </Col>
                </div>
              </Row>
              <br />
            </>
          )}
          <Row>
            <Col className="text-center">
              {caseReportErrorMessage && (
                <p style={{ color: "red" }}>
                  <b>{caseReportErrorMessage}</b>
                </p>
              )}
            </Col>
          </Row>
          {newCaseKey && <div style={{ marginBottom: '20px', border: '1px solid #dee2e6', borderRadius: '5px' }}>
            <div
              ref={caseReportRef}
              tabIndex={-1}
              style={{
                backgroundColor: '#005F85',
                color: 'whitesmoke',
                height: '30px',
                outline: 'none' // Removes the default browser focus border
              }}
            ><h4 className="p-1">Case Report Form</h4></div>
            {/* <form> */}
            <>
              <form ref={caseReportCreateFomrRef}>
                <AppCard title={
                  <div className="w-100" id="CaseReportPatientIdentification">
                    <div className="section-header">
                      <span className="section-title">
                        Patient Identification
                      </span>
                    </div>
                  </div>
                } bottomMargin>
                  <Card.Body>
                    <Row className="mb-3">
                      <Col>
                        <AppLabel
                          label={"Routinized Testing Focus Project - Hospital"}
                          required
                        ></AppLabel>
                        <Form.Select
                          {...register("routinizedHospitalId")}
                          name="routinizedHospitalId"
                          // id="RoutinizedHospital"
                          value={caseReportSelectedRoutinizedHospital}
                          onChange={(event) => {
                            handleRoutinizedHospitalChange(event);
                            handleFormFieldChange(event);
                          }}
                        >
                          {/* <option value="0"> -- </option> */}
                          {/* {allRoutinizedHospitalsData.map((option) => (
                            <option key={option.id} value={option.id}>
                              {option.value}
                            </option>
                          ))} */}
                          {allRoutinizedHospitalsData.map((option) => (
                            <option key={option.id} value={option.id}>
                              {option.value}
                            </option>
                          ))}
                        </Form.Select>
                        <div className="error m-0">
                          {newCaseReportValidationErrors.routinizedHospitalId}
                        </div>
                      </Col>
                      <Col>
                        <AppLabel
                          label={"Routinized Testing Focus Project - Facility"}
                          required
                        ></AppLabel>
                        <Form.Select
                          {...register("routinizedFacilityId")}
                          name="routinizedFacilityId"
                          value={caseReportSelectedRoutinizedFacility}
                          onChange={event => {
                            handleRoutinizedFacilityChange(event);
                            handleFormFieldChange(event);
                          }}
                        >
                          {/* <option value="0">--</option> */}
                          {filteredRoutinizedFacilities.map((option) => (
                            <option
                              key={option.id}
                              value={option.id}
                              data-value={option.value}
                            >
                              {option.value}
                            </option>
                          ))}
                        </Form.Select>
                        <div className="error m-0">
                          {newCaseReportValidationErrors.routinizedFacilityId}
                        </div>
                      </Col>
                      {/* <Col>
                        <AppLabel label={"Details"}></AppLabel>
                        <Form.Control
                          type="text"
                          value={caseReportOtherFacilityDetail}
                          onChange={(e) =>
                            setCaseReportSetOtherFacilityDetail(e.target.value)
                          }
                          disabled={caseReportOtherFacilityDetailIsDisabled}
                        />
                      </Col> */}
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <AppLabel label={"Date Received"} required></AppLabel>
                        <Form.Control
                          {...register("dateReceived")}
                          name="dateReceived"
                          type="date"
                          value={caseReportDateReceived}
                          onChange={(e) => {
                            const date = adjustDateToMax(
                              e.target.value,
                              maxDate
                            );
                            setCaseReportDateReceived(date);
                            handleFormFieldChange(e)
                          }}
                          max={maxDate} // Set the max attribute to today
                          min={minDate}
                        />
                        <div className="error m-0">
                          {newCaseReportValidationErrors.dateReceived}
                        </div>
                      </Col>
                      <Col>
                        <AppLabel
                          label={"Medical record #"}
                          required
                        ></AppLabel>
                        <Form.Control
                          {...register("medicalRecordNumber")}
                          name="medicalRecordNumber"
                          type="text"
                          value={caseReportMedicalRecord}
                          maxLength={25}
                          onChange={(e) => {
                            setCaseReportMedicalRecord(e.target.value);
                            handleFormFieldChange(e);
                          }}
                        />
                        <div className="error m-0">
                          {newCaseReportValidationErrors.medicalRecordNumber}
                        </div>
                        {/* {errors.medicalRecordNumber ? (
                          <span className="text-red-900">
                            {errors.medicalRecordNumber.message}
                          </span>
                        ) : (
                          <></>
                        )} */}
                      </Col>
                      <Col></Col>
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <AppLabel label={"Source"}></AppLabel>
                        <Form.Select
                          value={caseReportSource}
                          onChange={(e) =>
                            setCaseReportSource(e.target.value)}
                        >
                          <option value="All">All</option>
                          <option value="HIV">HIV</option>
                          <option value="SYPHILIS">SYPHILIS</option>
                        </Form.Select>
                        <div className="error m-0">
                          {newCaseReportValidationErrors.NewCaseBirthGender}
                        </div>
                      </Col>
                      <Col>
                        <AppLabel label={"First Name"} required></AppLabel>
                        <Form.Control
                          {...register("firstName")}
                          name="firstName"
                          type="text"
                          value={caseReportFirstName}
                          onChange={(e) => {
                            setCaseReportFirstName(e.target.value)
                            handleFormFieldChange(e);
                          }}
                          maxLength={30}
                        />
                        <div className="error m-0">
                          {newCaseReportValidationErrors.firstName}
                        </div>
                      </Col>
                      <Col>
                        <AppLabel label={"Middle Name"}></AppLabel>
                        <Form.Control
                          name="middleName"
                          type="text"
                          value={caseReportMiddleName}
                          onChange={(e) =>
                            setCaseReportMiddleName(e.target.value)
                          }
                          maxLength={30}
                        />
                      </Col>
                      <Col>
                        <AppLabel label={"Last Name"} required></AppLabel>
                        <Form.Control
                          {...register("lastName")}
                          name="lastName"
                          type="text"
                          value={caseReportLastName}
                          onChange={(e) => {
                            setCaseReportLastName(e.target.value)
                            handleFormFieldChange(e);
                          }}
                          maxLength={30}
                        />
                        <div className="error m-0">
                          {newCaseReportValidationErrors.lastName}
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <AppLabel label={"Date of Birth"} required></AppLabel>
                        <Form.Control
                          {...register("dateOfBirth")}
                          name="dateOfBirth"
                          type="date"
                          value={caseReportDOB}
                          onChange={(e) => {
                            const date = adjustDateToMax(
                              e.target.value,
                              maxDate
                            );
                            setCaseReportDOB(date)
                            handleFormFieldChange(e);
                          }
                          }
                          max={maxDate} // Set the max attribute to today
                          min={minDate}
                        />
                        <div className="error m-0">
                          {newCaseReportValidationErrors.dateOfBirth}
                        </div>
                      </Col>
                      <Col>
                        <AppLabel label={"Birth Sex"}></AppLabel>
                        <Form.Select
                          {...register("NewCaseBirthGender")}
                          id="NewCaseBirthGender"
                          name="NewCaseBirthGender"
                          value={caseReportBirthGender}
                          onChange={handleCaseReportBirthGenderChange}
                        >
                          <option value="">--</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                        </Form.Select>
                        <div className="error m-0">
                          {newCaseReportValidationErrors.NewCaseBirthGender}
                        </div>
                      </Col>
                      <Col>
                        <AppLabel label={"Last 4 of SSN"}></AppLabel>
                        <Form.Control
                          {...register("NewCaseLast4SSN")}
                          type="password"
                          placeholder="****"
                          value={caseReportLast4SSN}
                          maxLength={4}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");
                            if (value.length <= 4) {
                              setCaseReportLast4SSN(value);
                            }
                          }}
                          onBlur={() => {
                            setMaskedSSN("****");
                          }}
                          onFocus={() => {
                            setMaskedSSN(caseReportLast4SSN);
                          }}
                        />
                        <div className="error m-0">
                          {newCaseReportValidationErrors.NewCaseLast4SSN}
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </AppCard>
                <AppCard title={
                  <div className="w-100" id="CaseReportPatientContactIdentification">
                    <div className="section-header">
                      <span className="section-title">
                        Patient Contact Information
                      </span>
                    </div>
                  </div>
                } bottomMargin>
                  <Card.Body>
                    <Row className="mb-3">
                      <Col>
                        <AppLabel label={"Address Type"} required />
                        <Form.Select
                          {...register("addressTypeDetailNewCase")}
                          name="addressTypeDetailNewCase"
                          onChange={handleAddressTypeNewCase}
                          value={addressTypeNewCase}
                        >
                          <option value="">--</option>
                          <option value="Yes">Home Address</option>
                          <option value="No">Unhoused</option>
                          <option value="No1">Unknown/ No Response</option>
                        </Form.Select>
                        <div className="error m-0">
                          {
                            newCaseReportValidationErrors.addressTypeDetailNewCase
                          }
                        </div>
                      </Col>
                      <Col>
                        <AppLabel
                          label={"Street Address 1"}
                          required={addressTypeNewCase === "Yes"}
                        />
                        <Form.Control
                          {...register("streetAddress")}
                          name="streetAddress"
                          type="text"
                          value={caseReportStreet1}
                          onChange={(e) => {
                            setCaseReportStreet1(e.target.value)
                            handleFormFieldChange(e);
                          }}
                          disabled={addressDisableNewCase}
                          maxLength={100}
                        />
                        <div className="error m-0">
                          {newCaseReportValidationErrors.streetAddress}
                        </div>
                      </Col>
                      <Col>
                        <AppLabel label={"Street Address 2"} />
                        <Form.Control
                          type="text"
                          value={caseReportStreet2}
                          onChange={(e) => setCaseReportStreet2(e.target.value)}
                          disabled={addressDisableNewCase}
                          maxLength={50}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <AppLabel
                          label={"City"}
                          required={addressTypeNewCase === "Yes"}
                        />
                        <Form.Control
                          {...register("city")}
                          name="city"
                          type="text"
                          value={caseReportCity}
                          onChange={(e) => {
                            setCaseReportCity(e.target.value)
                            handleFormFieldChange(e);
                          }}
                          disabled={addressDisableNewCase}
                          maxLength={100}
                        />
                        <div className="error m-0">
                          {newCaseReportValidationErrors.city}
                        </div>
                      </Col>
                      <Col>
                        <AppLabel
                          label={"State"}
                          required={addressTypeNewCase === "Yes"}
                        />
                        <Form.Select
                          {...register("stateId")}
                          name="stateId"
                          value={caseReportStateId}
                          onChange={handleCaseReportStateChange}
                          disabled={addressDisableNewCase}
                        >
                          <option value="0"> -- </option>
                          {caseReportStateData.map((option) => (
                            <option key={option.id} value={option.value}>
                              {option.value}
                            </option>
                          ))}
                        </Form.Select>
                        <div className="error m-0">
                          {newCaseReportValidationErrors.stateId}
                        </div>
                      </Col>
                      <Col>
                        <AppLabel
                          label={"Zip Code"}
                          required={addressTypeNewCase === "Yes"}
                        />
                        <Form.Control
                          {...register("zipcode")}
                          name="zipcode"
                          type="text"
                          value={caseReportZipCode}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");
                            if (value.length <= 5) {
                              setCaseReportZipCode(value);
                            }
                            handleFormFieldChange(e);
                          }}
                          maxLength={5}
                          disabled={addressDisableNewCase}
                        />
                        <div className="error m-0">
                          {newCaseReportValidationErrors.zipcode}
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <AppLabel
                          label={"County"}
                          required={addressTypeNewCase === "Yes"}
                        />
                        <Form.Select
                          {...register("countyId")}
                          name="countyId"
                          value={caseReportCountyId}
                          onChange={handleCaseReportCountyChange}
                          disabled={addressDisableNewCase || caseReportStateId !== "FLORIDA"}
                        >
                          <option value=""> -- </option>
                          <option key={68} value="OUT OF STATE">
                            OUT OF STATE
                          </option>
                          {caseReportCountyData.map((option) => (
                            <option key={option.id} value={option.value}>
                              {option.value}
                            </option>
                          ))}
                        </Form.Select>
                        <div className="error m-0">
                          {newCaseReportValidationErrors.countyId}
                        </div>
                      </Col>
                      <Col>
                        <AppLabel label={"Primary Phone"} />
                        <Form.Control
                          type="text"
                          placeholder={
                            "10 digit phone number (ex: 555-555-5555)"
                          }
                          value={caseReportPrimaryPhone}
                          onChange={(e) => {
                            const { name, value } = e.target;
                            const formattedPhoneNumber =
                              formatPhoneNumber(value);
                            setCaseReportPrimaryPhone(formattedPhoneNumber);
                          }}
                        />
                      </Col>
                      <Row className="mt-2">
                        <Col>
                          <AppLabel label={"Comments"} />
                          <Form.Control
                            as="textarea"
                            value={caseReportComments}
                            onChange={(e) =>
                              setCaseReportComments(e.target.value)
                            }
                            maxLength={1500}
                            rows={2}
                          />
                          <div style={{ fontSize: '0.85rem', color: '#6c757d', textAlign: 'right', marginTop: '4px' }}>
                            Character Count: {caseReportComments ? caseReportComments.length : 0} / 1500
                          </div>
                        </Col>
                      </Row>
                    </Row>
                  </Card.Body>
                </AppCard>
                <AppCard title={
                  <div className="w-100" id="CaseReportEmergencyContactInformation">
                    <div className="section-header">
                      <span className="section-title">
                        Emergency Contact Information
                      </span>
                    </div>
                  </div>
                } bottomMargin>
                  <Card.Body>
                    <Row className="mb-3">
                      <Col>
                        <AppLabel label={"Emergency Contact Person"} />
                        <Form.Control
                          type="text"
                          value={caseReportErContactPerson}
                          onChange={(e) =>
                            setCaseReportErContactPerson(e.target.value)
                          }
                          maxLength={60}
                        />
                      </Col>
                      <Col>
                        <AppLabel label="Relationship" />
                        <Form.Select
                          value={caseReportErContactRelation || ""} // Ensure value stores ID
                          onChange={(e) => {
                            setCaseReportErContactRelation(e.target.value); // Store ID instead of name
                          }}
                        >
                          <option value=""> -- </option> {/* Placeholder */}
                          {caseReportRelationshipData.map((option) => (
                            <option key={option.id} value={option.id}>
                              {option.value}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                      <Col>
                        <AppLabel label={"Phone"} />
                        <Form.Control
                          type="text"
                          placeholder={
                            "10 digit phone number (ex: 555-555-5555)"
                          }
                          value={caseReportErContactPhone}
                          onChange={(e) => {
                            const { name, value } = e.target;
                            const formattedPhoneNumber =
                              formatPhoneNumber(value);
                            setCaseReportErContactPhone(formattedPhoneNumber);
                          }}
                        />
                      </Col>
                    </Row>
                  </Card.Body>
                </AppCard>
                <AppCard
                  title={
                    <div className="w-100" id="CaseReportMedicalInformation">
                      <div className="section-header">
                        <span className="section-title">
                          Medical Information
                        </span>

                        <span
                          onClick={toggleMedical}
                          className="section-toggle"
                          title={isMedicalCollapsed ? "Expand" : "Collapse"}
                          aria-label={isMedicalCollapsed ? "Expand" : "Collapse"}
                        >
                          {isMedicalCollapsed ? "+" : "−"}
                        </span>
                      </div>
                    </div>
                  }
                  bottomMargin
                >
                  {!isMedicalCollapsed && (
                    <Card.Body>
                      <Row className="mb-3">
                        <Col>
                          <AppLabel label={"Date of Presented To"} required />
                          <Form.Control
                            {...register("datePresented")}
                            name="datePresented"
                            type="date"
                            value={caseReportDatePresented}
                            onChange={(e) => {
                              const date = adjustDateToMax(
                                e.target.value,
                                maxDate
                              );
                              setCaseReportDatePresented(date)
                              handleFormFieldChange(e);
                            }}
                            max={maxDate} // Set the max attribute to today
                            min={minDate}
                          />
                          <div className="error m-0">
                            {newCaseReportValidationErrors.datePresented}
                          </div>
                        </Col>
                        <Col>
                          <AppLabel label={"Date of Discharge"} />
                          <Form.Control
                            {...register('dateOfDisCharge')}
                            type="date"
                            value={caseReportDateDischarged}
                            onChange={(e) => {
                              const date = adjustDateToMax(
                                e.target.value,
                                maxDate
                              );
                              setCaseReportDateDischarged(date)
                            }
                            }
                            max={maxDate} // Set the max attribute to today
                            min={minDate}
                          />
                          <div className="error m-0">
                            {newCaseReportValidationErrors.dateOfDisCharge}
                          </div>
                        </Col>
                        <Col>
                          <AppLabel label={"Chief Complaint"} required />
                          <Form.Control
                            {...register("chiefComplaint")}
                            name="chiefComplaint"
                            type="text"
                            value={caseReportChiefComplaint}
                            onChange={(e) => {
                              setCaseReportChiefComplaint(e.target.value)
                              handleFormFieldChange(e);
                            }}
                            maxLength={200}
                          />
                          <div className="error m-0">
                            {newCaseReportValidationErrors.chiefComplaint}
                          </div>
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <Col>
                          <AppLabel label={"List of Symptoms"} required />
                          <Form.Control
                            {...register("listOfSymptoms")}
                            name="listOfSymptoms"
                            as="textarea"
                            value={caseReportSymptoms}
                            onChange={(e) => {
                              setCaseReportDateSymptoms(e.target.value)
                              handleFormFieldChange(e);
                            }}
                            maxLength={1500}
                            rows={2}
                          />
                          <div style={{ fontSize: '0.85rem', color: '#6c757d', textAlign: 'right', marginTop: '4px' }}>
                            Character Count: {caseReportSymptoms ? caseReportSymptoms.length : 0} / 1500
                          </div>
                          <div className="error m-0">
                            {newCaseReportValidationErrors.listOfSymptoms}
                          </div>
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <Col>
                          <AppLabel label={"Admitted to Hospital"} required />
                          <Form.Select
                            {...register("admittedToHospital")}
                            name="admittedToHospital"
                            value={caseReportHospitalAdmit}
                            onChange={handleHospitalAdmitChange}
                          >
                            <option value="0">--</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </Form.Select>
                          <div className="error m-0">
                            {newCaseReportValidationErrors.admittedToHospital}
                          </div>
                        </Col>
                        <Col>
                          <AppLabel label={"Where"} />
                          <Form.Control
                            {...register("admittedToHospitalWhere")}
                            type="text"
                            value={caseReportHospitalLocation}
                            onChange={(e) =>
                              setCaseReportHospitalLocation(e.target.value)
                            }
                            disabled={caseReportHospitalLocationIsDisabled}
                            maxLength={50}
                          />
                          <div className="error m-0">
                            {
                              newCaseReportValidationErrors.admittedToHospitalWhere
                            }
                          </div>
                        </Col>
                        <Col>
                          <AppLabel label={"Room #"} />
                          <Form.Control
                            type="text"
                            value={caseReportHospitalRoom}
                            onChange={(e) =>
                              setCaseReportHospitalRoom(e.target.value)
                            }
                            disabled={caseReportHospitalRoomIsDisabled}
                            maxLength={25}
                          />
                        </Col>
                      </Row>
                    </Card.Body>)}
                </AppCard>

                <AppCard title={
                  <div className="w-100" id="CaseReportLinkageToCareStatus">
                    <div className="section-header">
                      <span className="section-title">
                        Linkage to Care Status
                      </span>
                    </div>
                  </div>
                } bottomMargin>
                  <Card.Body>
                    <Row className="mb-3">
                      <Col>
                        <AppLabel label={"Linkage to Care Status"} />
                        <Form.Select
                          //{...register("LinkageCareStatus")}
                          name="LinkageCareStatusId"
                          value={linkageCareStatus}
                          onChange={(e) => {
                            setLinkageCareStatus(e.target.value)
                            if (String(e.target.selectedOptions[0].text) !== 'Others') setLinkageCareStatusOtherDetails("");
                            handleSectionValidation(false, false, true);
                          }}

                        >
                          {allLinkageCareStatusesData.map((option) => (
                            <option key={option.id} value={option.id}>
                              {option.value}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                      {String(linkageCareStatus ?? "") === "7" && ( // linkageCareStatus 7 is "Others"
                        <Col>
                          <AppLabel label={"Details"} />
                          <Form.Control
                            type="text"
                            value={linkageCareStatusOtherDetails}
                            onChange={(e) =>
                              setLinkageCareStatusOtherDetails(e.target.value)
                            }
                            maxLength={50}
                          />
                        </Col>
                      )}
                      {String(linkageCareStatus ?? "") !== "7" && ( // linkageCareStatus 7 is "Others"
                        <Col>
                        </Col>
                      )}
                      <Col>
                      </Col>
                    </Row>

                  </Card.Body>
                </AppCard>

                <div id="CaseReportTestingInformation"></div>
                <AppCard titleNode={testingInformationTitle} hasTitleNode={true} bottomMargin>

                  {!isTestingInfoCollapsed && (
                    <Card.Body>
                      <Row className="mb-3">
                        <Col>
                          <AppLabel label={"NAAT"}
  required={isPositiveTestResult === true && caseReportCheckBox === false} />
                          <Form.Select
                            {...register("naat")}
                            name="NAAT"
                            value={caseReportNAAT}
                            onChange={(e) => {
                              setCaseReportNAAT(e.target.value)
                              handleSectionValidation(true, false, false);
                              if (e.target.value && e.target.value !== '0') {
                                positiveTestResultRef.current.naat = false;
                              } else {
                                positiveTestResultRef.current.naat = true;
                              }
                              handleFormFieldChange(e)
                            }}
                            disabled={caseReportCheckBox}
                          >
                            <option value="0">--</option>
                            <option value="Positive">Positive</option>
                            <option value="Negative">Negative</option>
                            <option value="Indetermine">Indetermine</option>
                            <option value="Notperformed">Not Performed</option>
                          </Form.Select>
                          <div className="error m-0">
                            {newCaseReportValidationErrors.NAAT}
                          </div>
                        </Col>
                        <Col>
                          <AppLabel label={"NAAT Date"} required={caseReportNAAT == "Positive"}></AppLabel>
                          <Form.Control
                            {...register("naatDate")}
                            name="naatDate"
                            type="date"
                            value={caseReportNAATDate}
                            onChange={(e) => {
                              const date = adjustDateToMax(
                                e.target.value,
                                maxDate
                              );
                              setCaseReportNAATDate(date)
                              handleSectionValidation(true, false, false);
                              handleFormFieldChange(e)
                            }}
                            max={maxDate} // Set the max attribute to today
                            min={minDate}
                            disabled={caseReportCheckBox}
                          />
                          <div className="error m-0">
                            {newCaseReportValidationErrors.naatDate}
                          </div>
                        </Col>
                        <Col>
                          <AppLabel label={"Disclosed"} />
                          <Form.Select
                            {...register("Disclosed")}
                            name="Disclosed"
                            value={caseReportDisclosed}
                            onChange={(e) => {
                              setCaseReportDisclosed(e.target.value)
                              handleSectionValidation(true, false, false);
                              if (e.target.value && e.target.value !== '0') {
                                positiveTestResultRef.current.disclosed = false;
                              } else {
                                positiveTestResultRef.current.disclosed = true;
                              }
                              handleFormFieldChange(e)
                            }}
                            disabled={caseReportCheckBox}
                          >
                            <option value="0">--</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </Form.Select>
                          <div className="error m-0">
                            {newCaseReportValidationErrors.Disclosed}
                          </div>
                        </Col>
                        <Col>
                          <AppLabel label={"Disclosed Date"} required={caseReportDisclosed == "Yes"}></AppLabel>
                          <Form.Control
                            {...register("disclosedDate")}
                            name="disclosedDate"
                            type="date"
                            value={caseReportDisclosedDate}
                            onChange={(e) => {
                              const date = adjustDateToMax(
                                e.target.value,
                                maxDate
                              );
                              setCaseReportDisclosedDate(date)
                              handleSectionValidation(true, false, false);
                              handleFormFieldChange(e)
                            }}
                            max={maxDate} // Set the max attribute to today
                            min={minDate}
                            disabled={caseReportCheckBox}
                          />
                          <div className="error m-0">
                            {newCaseReportValidationErrors.disclosedDate}
                          </div>
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <Col>
                          <AppLabel label={"HIV-1/2 Ag/Ab"} />
                          <Form.Select
                            {...register("hivAgAb")}
                            name="hivAgAb"
                            value={caseReportHIVAGAB}
                            onChange={(e) => {
                              setCaseReportHIVAGAB(e.target.value)
                              handleSectionValidation(false, true, false);
                              if (e.target.value && e.target.value !== '0') {
                                positiveTestResultRef.current.hivagab = false;
                              } else {
                                positiveTestResultRef.current.hivagab = true;
                              }
                              handleFormFieldChange(e)
                            }}
                            disabled={caseReportCheckBox}
                          >
                            <option value="0">--</option>
                            <option value="Positive">Positive</option>
                            <option value="Negative">Negative</option>
                            <option value="Indetermine">Indetermine</option>
                          </Form.Select>
                          <div className="error m-0">
                            {newCaseReportValidationErrors.hivAgAb}
                          </div>
                        </Col>
                        <Col>
                          <AppLabel label={"HIV-1/2 Ag/Ab Date"} required={caseReportHIVAGAB == "Positive"}></AppLabel>
                          <Form.Control
                            {...register("hivAgAbDate")}
                            name="hivAgAbDate"
                            type="date"
                            value={caseReportHivAgAbDate}
                            onChange={(e) => {
                              const date = adjustDateToMax(
                                e.target.value,
                                maxDate
                              );
                              setCaseReportHivAgAbDate(date)
                              handleSectionValidation(false, true, false);
                              handleFormFieldChange(e)
                            }}
                            max={maxDate} // Set the max attribute to today
                            min={minDate}
                            disabled={caseReportCheckBox}
                          />
                          <div className="error m-0">
                            {newCaseReportValidationErrors.hivAgAbDate}
                          </div>
                        </Col>
                        <Col>
                          <AppLabel label={"In Care"} />
                          <Form.Select
                            {...register("NewCaseInCare")}
                            name="NewCaseInCare"
                            value={caseReportInCare}
                            onChange={(e) => {
                              setCaseReportInCare(e.target.value)
                              handleSectionValidation(false, true, false);
                              if (e.target.value && e.target.value !== '0') {
                                positiveTestResultRef.current.incare = false;
                              } else {
                                positiveTestResultRef.current.incare = true;
                              }
                              handleFormFieldChange(e)
                            }}
                            disabled={caseReportCheckBox}
                          >
                            <option value="0">--</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </Form.Select>
                          <div className="error m-0">
                            {newCaseReportValidationErrors.NewCaseInCare}
                          </div>
                        </Col>
                        <Col>
                          <AppLabel label={"In Care Date"} required={caseReportInCare == "Yes"}></AppLabel>
                          <Form.Control
                            {...register('inCareDate')}
                            name="inCareDate"
                            type="date"
                            value={caseReportInCareDate}
                            onChange={(e) => {
                              const date = adjustDateToMax(
                                e.target.value,
                                maxDate
                              );
                              setCaseReportInCareDate(date)
                              handleSectionValidation(false, true, false);
                              handleFormFieldChange(e)
                            }}
                            max={maxDate} // Set the max attribute to today
                            min={minDate}
                            disabled={caseReportCheckBox}
                          />
                          <div className="error m-0">
                            {newCaseReportValidationErrors.inCareDate}
                          </div>
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <Col>
                          <AppLabel
                            label={"HIV - 1/2 IA (Supplemental)"}
                          />
                          <Form.Select
                            {...register("hivIASupplemental")}
                            name="hivIASupplemental"
                            value={caseReportHIVIA}
                            onChange={(e) => {
                              setCaseReportHIVIA(e.target.value)
                              handleSectionValidation(false, false, true);
                              if (e.target.value && e.target.value !== '0') {
                                positiveTestResultRef.current.hivIa = false;
                              } else {
                                positiveTestResultRef.current.hivIa = true;
                              }
                              handleFormFieldChange(e)
                            }}
                            disabled={caseReportCheckBox}
                          >
                            <option value="0">--</option>
                            <option value="Positive">Positive</option>
                            <option value="Negative">Negative</option>
                            <option value="Indetermine">Indetermine</option>
                          </Form.Select>
                          <div className="error m-0">
                            {newCaseReportValidationErrors.hivIASupplemental}
                          </div>
                        </Col>
                        <Col>
                          <AppLabel
                            label={"HIV - 1/2 IA (Supplemental) Date"}
                            required={caseReportHIVIA == "Positive"}
                          ></AppLabel>
                          <Form.Control
                            {...register('hivIaSupplementalDate')}
                            name="hivIaSupplementalDate"
                            type="date"
                            value={caseReportHivIaDate}
                            onChange={(e) => {
                              const date = adjustDateToMax(
                                e.target.value,
                                maxDate
                              );
                              setCaseReportHivIaDate(date)
                              handleSectionValidation(false, false, true);
                              handleFormFieldChange(e)
                            }}
                            max={maxDate} // Set the max attribute to today
                            min={minDate}
                            disabled={caseReportCheckBox}
                          />
                          <div className="error m-0">
                            {newCaseReportValidationErrors.hivIaSupplementalDate}
                          </div>
                        </Col>
                        <Col>

                        </Col>
                        <Col></Col>
                      </Row>
                      <Row className="mb-3">
                        <Col>
                          <AppLabel label={"Medication"} />
                          <Form.Control
                            type="text"
                            value={caseReportMedication}
                            onChange={(e) =>
                              setCaseReportMedication(e.target.value)
                            }
                            disabled={caseReportCheckBox}
                            maxLength={200}
                          />
                        </Col>
                      </Row>
                    </Card.Body>
                  )}
                </AppCard>
                {source !== "SYPHILIS" && (
                  <AppCard
                    title={
                      <div className="w-100" id="CaseReportHIVDetails">
                        <div className="section-header">
                          <span className="section-title">
                            HIV Diagnosis Details
                          </span>

                          <span
                            onClick={toggleHivDetails}
                            className="section-toggle"
                            title={isHivDetailsCollapsed ? "Expand" : "Collapse"}
                            aria-label={isHivDetailsCollapsed ? "Expand" : "Collapse"}
                          >
                            {isHivDetailsCollapsed ? "+" : "−"}
                          </span>
                        </div>
                      </div>
                    }
                    bottomMargin
                  >

                    {/* COLLAPSIBLE CONTENT */}
                    {!isHivDetailsCollapsed && (
                      <Card.Body>
                        <Row className="mb-3">
                          <Col>
                            <AppLabel label={"HIV Diagnosis Date"} />
                            <Form.Control
                              {...register('hivDiagnosisDate')}
                              name="hivDiagnosisDate"
                              type="date"
                              value={clientInfoHivDateOfDiagnosis}
                              onChange={(e) => {
                                const date = adjustDateToMax(
                                  e.target.value,
                                  maxDate
                                );
                                setClientInfoHivDateOfDiagnosis(date)
                                handleFormFieldChange(e)
                              }}
                              //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                              //readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                              max={maxDate} // Set the max attribute to today
                              min={minDate}
                            />
                            <div className="error m-0">
                              {newCaseReportValidationErrors.hivDiagnosisDate}
                            </div>
                          </Col>
                          <Col>
                            <AppLabel label={"AIDS Date"} />
                            <Form.Control
                              {...register('aidsDate')}
                              name="aidsDate"
                              type="date"
                              value={clientInfoAidsDate}
                              onChange={(e) => {
                                const date = adjustDateToMax(
                                  e.target.value,
                                  maxDate
                                );
                                setClientInfoAidsDate(date)
                                handleFormFieldChange(e)
                              }
                              }
                              //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                              //readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                              max={maxDate} // Set the max attribute to today
                              min={minDate}
                            />
                            <div className="error m-0">
                              {newCaseReportValidationErrors.aidsDate}
                            </div>
                          </Col>
                          <Col>
                            <AppLabel label={"Mode of Transmission"} />
                            <Form.Select
                              name="clientInfoHIVModeOfTransmissionId"
                              value={clientInfoHIVModeOfTransmissionId}
                              onChange={(e) => setClientInfoModeOfTransmissionId(e.target.value)}
                            //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                            //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                            >
                              {allModeoftransmissionData.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.value}
                                </option>
                              ))}
                            </Form.Select>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col>
                            <AppLabel label={"Date Reported HIV Positive to State"} />
                            <Form.Control
                              {...register('dateReportedHivPositive')}
                              name="dateReportedHivPositive"
                              type="date"
                              value={clientInfoHIVReportedDate}
                              onChange={(e) => {
                                const date = adjustDateToMax(
                                  e.target.value,
                                  maxDate
                                );
                                setClientInfoHIVReportedDate(date)
                                handleFormFieldChange(e)
                              }}
                              //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                              //readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                              max={maxDate} // Set the max attribute to today
                              min={minDate}
                            />
                            <div className="error m-0">
                              {newCaseReportValidationErrors.dateReportedHivPositive}
                            </div>
                          </Col>
                          <Col>
                            <AppLabel
                              label={
                                "Date of Last Viral Load"
                              }
                            />
                            <Form.Control
                              {...register("newlastViralLoad")}
                              name="newlastViralLoad"
                              type="date"
                              value={lastUpdatedDate.lastViralLoad}
                              onChange={(e) => {
                                const date = adjustDateToMax(
                                  e.target.value,
                                  maxDate
                                );
                                setLastUpdatedDate((prev) => ({ ...prev, lastViralLoad: date }));
                                handleFormFieldChange(e)
                              }}
                              //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                              //readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                              max={maxDate} // Set the max attribute to today
                              min={minDate}
                            >
                            </Form.Control>
                            <div className="error m-0">
                              {newCaseReportValidationErrors.newlastViralLoad}
                            </div>
                          </Col>
                          <Col>
                            <AppLabel label={"Viral Load"} />
                            <Form.Control
                              type="text"
                              value={clientInfoViralLoad}
                              onChange={(e) =>
                                setClientInfoViralLoad(e.target.value)
                              }
                              //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                              //readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                              maxLength={25}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          {/* <Col>
                          <AppLabel label={"Linkage to Care Status"} />
                          <Form.Select
                            name="LinkageToCareStatusId"
                            value={l2CName}
                            onChange={(e) => {
                              setLinkageToCareStatusForHivDiagnosis(e.target.value);
                              setl2CName(e.target.value)
                            }}
                            //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                          >
                            {allLinkageCareStatusesData.map((option) => (
                              <option key={option.id} value={option.id}>
                                {option.value}
                              </option>
                            ))}
                          </Form.Select>
                        </Col> */}
                          <Col>
                            <AppLabel
                              label="Date of Last CD4 Count"
                            />
                            <Form.Control
                              {...register("newlastCd4")}
                              name="newlastCd4"
                              type="date"
                              value={lastUpdatedDate.lastCd4}
                              onChange={(e) => {
                                const date = adjustDateToMax(
                                  e.target.value,
                                  maxDate
                                );
                                setLastUpdatedDate((prev) => ({ ...prev, lastCd4: date }));
                                handleFormFieldChange(e)
                              }}
                              //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                              //readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                              max={maxDate} // Set the max attribute to today
                              min={minDate}
                            />
                            <div className="error m-0">
                              {newCaseReportValidationErrors.newlastCd4}
                            </div>
                          </Col>
                          <Col>
                            <AppLabel label={"CD4 Count"} />
                            <Form.Control
                              type="text"
                              value={clientInfoCD4Count}
                              //disabled={isAdmin || isHivProvider ? false : !isAdmin}
                              //readOnly={isAdmin || isHivProvider ? false : !isAdmin}
                              onChange={(e) => setClientInfoCD4Count(e.target.value)}
                              maxLength={25}
                            />
                          </Col>
                          <Col>

                          </Col>
                        </Row>
                      </Card.Body>
                    )}
                  </AppCard>
                )}
                {
                  !showStdTestInfo &&
                  <AppCard
                    title={
                      <div className="w-100" id="CaseReportSTDTestInformation">
                        <div className="section-header">
                          <span className="section-title">
                            STD Test Information
                          </span>

                          <span
                            onClick={toggleStdInfo}
                            className="section-toggle"
                            title={isStdInfoCollapsed ? "Expand" : "Collapse"}
                            aria-label={isStdInfoCollapsed ? "Expand" : "Collapse"}
                          >
                            {isStdInfoCollapsed ? "+" : "−"}
                          </span>
                        </div>
                      </div>
                    }
                    bottomMargin
                  >
                    {!isStdInfoCollapsed && (
                      <Card.Body>
                        <Row className="mb-3">
                          <AppLabel style={{
                            fontWeight: "bold",
                            marginBottom: "10px"
                          }} label={"RPR Test Information"} />
                          <Col>
                            <AppLabel label={"Test Type"} />
                            <Form.Select
                              {...register('rPR_Type')}
                              name="rPR_Type"
                              value={rPR_Type || ""} // Ensure value stores ID
                              onChange={(e) => {
                                const selectedValue = e.target.value;
                                setRPR_Type(selectedValue); // Store ID

                                // NEW: Clear rPR_Result if the placeholder is selected (value is "")
                                if (selectedValue === "") {
                                  setRPR_Result("");
                                  setcaseReportRPRSpecimanDate("");
                                  setcaseReportRPRSpecimanID("");
                                  setTiter("");

                                }
                              }}
                            // onChange={(e) => {
                            //   setRPR_Type(e.target.value); // Store ID instead of name
                            // }}
                            >
                              <option value="">Select Test Type</option> {/* Placeholder */}
                              {caseReportTestData
                                .filter((option) => option.value === 'RPR')
                                .map((option) => (
                                  <option key={option.id} value={option.id}>
                                    {option.value1}
                                  </option>
                                ))}
                            </Form.Select>
                          </Col>
                          <Col>
                            <AppLabel label={"Specimen Collection Date"}
                              required={rPR_Type !== ""}
                            />
                            <Form.Control
                              {...register('rprCollectionDate')}
                              name="rprCollectionDate"
                              type="date"
                              value={caseReportRPRSpecimanDate}
                              onChange={(e) => {
                                const date = adjustDateToMax(
                                  e.target.value,
                                  maxDate
                                );
                                setcaseReportRPRSpecimanDate(date)
                                handleFormFieldChange(e);
                              }}
                              max={maxDate} // Set the max attribute to today
                              min={minDate}
                              disabled={!rPR_Type}
                            />
                            <div className="error m-0">
                              {newCaseReportValidationErrors.rprCollectionDate}
                            </div>
                          </Col>
                          <Col>
                            <AppLabel label={"Specimen ID"} />
                            <Form.Control
                              {...register("rprSpecimenID")}
                              name="rprSpecimenID"
                              type="text"
                              value={caseReportRPRSpecimanID}
                              onChange={(e) => setcaseReportRPRSpecimanID(e.target.value)}
                              disabled={!rPR_Type}
                              maxLength={25}
                            />
                            <div className="error m-0">
                              {
                                newCaseReportValidationErrors.rprSpecimenID
                              }
                            </div>
                          </Col>
                          <Col>
                            <AppLabel
                              label={
                                "Details"
                              }
                              required={rPR_Type !== ""}
                            />
                            <Form.Select
                              {...register('rPR_Result')}
                              name="rPR_Result"
                              value={rPR_Result}
                              onChange={(e) => {
                                setRPR_Result(e.target.value)
                                handleFormFieldChange(e)

                                if (e.target.value === "" || e.target.value === "6") {
                                  setTiter("");
                                }
                              }}
                              disabled={!rPR_Type || isChecked}
                            >
                              <option value="">--</option>
                              {caseReportResultData
                                .filter((option) => option.value === 'Reactive' || option.value === 'Non-Reactive')
                                .map((option) => (
                                  <option key={option.id} value={option.id}>
                                    {option.value}
                                  </option>
                                ))}

                            </Form.Select>
                            <div className="error m-0">
                              {newCaseReportValidationErrors.rPR_Result}
                            </div>
                          </Col>
                          <Col>
                            <AppLabel label={"Titer"} />
                            <Form.Control
                              type="text"
                              value={titer}
                              onChange={(e) => setTiter(e.target.value)}
                              disabled={rPR_Result !== '5'}
                              maxLength={10}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <AppLabel style={{
                            fontWeight: "bold",
                            marginBottom: "10px",
                            marginTop: "10px"
                          }} label={"CSF-VDRL Test Information"}
                          />
                          <Col>
                            <AppLabel label={"Test Type"} />
                            <Form.Select
                              {...register('vDRL_Type')}
                              value={vDRL_Type || ""} // Ensure value stores ID
                              onChange={(e) => {
                                const selectedValue = e.target.value;
                                setVDRL_Type(selectedValue); // Store ID

                                // NEW: Clear rPR_Result if the placeholder is selected (value is "")
                                if (selectedValue === "") {
                                  setVDRL_Result("");
                                  setcaseReportVDRLSpecimanDate("");
                                  setcaseReportVDRLSpecimanID("");
                                  setcaseReportVDRLTiter("");
                                }
                              }}
                            >
                              <option value="">Select Test Type</option> {/* Placeholder */}
                              {caseReportTestData
                                .filter((option) => option.value === 'VDRL')
                                .map((option) => (
                                  <option key={option.id} value={option.id}>
                                    {option.value1}
                                  </option>
                                ))}
                            </Form.Select>
                          </Col>
                          <Col>
                            <AppLabel label={"Specimen Collection Date"}
                              required={vDRL_Type !== ""}
                            />
                            <Form.Control
                              {...register('vdrlCollectionDate')}
                              name="vdrlCollectionDate"
                              type="date"
                              value={caseReportVDRLSpecimanDate}
                              onChange={(e) => {
                                const date = adjustDateToMax(
                                  e.target.value,
                                  maxDate
                                );
                                setcaseReportVDRLSpecimanDate(date)
                                handleFormFieldChange(e);
                              }
                              }
                              max={maxDate} // Set the max attribute to today
                              min={minDate}
                              disabled={!vDRL_Type}
                            />
                            <div className="error m-0">
                              {newCaseReportValidationErrors.vdrlCollectionDate}
                            </div>
                          </Col>
                          <Col>
                            <AppLabel label={"Specimen ID"} />
                            <Form.Control
                              name="vdrlSpecimenID"
                              type="text"
                              value={caseReportVDRLSpecimanID}
                              onChange={(e) => setcaseReportVDRLSpecimanID(e.target.value)}
                              disabled={!vDRL_Type}
                              maxLength={25}
                            />
                            <div className="error m-0">
                              {
                                newCaseReportValidationErrors.vdrlSpecimenID
                              }
                            </div>
                          </Col>
                          <Col>
                            <AppLabel
                              label={
                                "Details"
                              }
                              required={vDRL_Type !== ""}
                            />
                            <Form.Select
                              {...register('vDRL_Result')}
                              name="vDRL_Result"
                              value={vDRL_Result}
                              onChange={(e) => {
                                setVDRL_Result(e.target.value)
                                handleFormFieldChange(e)
                                if (e.target.value === "" || e.target.value === "6") { //2=Negative
                                  setcaseReportVDRLTiter("");
                                }
                              }}
                              //disabled={isChecked}
                              disabled={!vDRL_Type}
                            >
                              <option value="">--</option>
                              {caseReportResultData
                                .filter((option) => option.value === 'Reactive' || option.value === 'Non-Reactive')
                                .map((option) => (
                                  <option key={option.id} value={option.id}>
                                    {option.value}
                                  </option>
                                ))}
                            </Form.Select>
                            <div className="error m-0">
                              {newCaseReportValidationErrors.vDRL_Result}
                            </div>
                          </Col>
                          <Col>
                            <AppLabel label={"Titer"} />
                            <Form.Control
                              type="text"
                              value={caseReportVDRLTiter}
                              onChange={(e) => setcaseReportVDRLTiter(e.target.value)}
                              disabled={vDRL_Result !== '5'}
                              maxLength={10}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <AppLabel style={{
                            fontWeight: "bold",
                            marginBottom: "10px",
                            marginTop: "10px"
                          }} label={"TP-PA Information"} />
                          <Col>
                            <AppLabel label={"Test Type"} />
                            <Form.Select
                              // {...register('tPPA_Type')}
                              value={tPPA_Type || ""} // Ensure value stores ID
                              onChange={(e) => {
                                const selectedValue = e.target.value;
                                setTPPA_Type(selectedValue); // Store ID

                                // NEW: Clear rPR_Result if the placeholder is selected (value is "")
                                if (selectedValue === "") {
                                  setTPPA_Result("");
                                  setcaseReportTPPASpecimanDate("");
                                  setcaseReportTPPASpecimanID("");
                                }
                              }}
                            >
                              <option value="">Select Test Type</option> {/* Placeholder */}
                              {caseReportTestData
                                .filter((option) => option.value === 'TP-PA')
                                .map((option) => (
                                  <option key={option.id} value={option.id}>
                                    {option.value1}
                                  </option>
                                ))}
                            </Form.Select>
                          </Col>
                          <Col>
                            <AppLabel label={"Specimen Collection Date"}
                              required={tPPA_Type !== ""}
                            />
                            <Form.Control
                              {...register('tppaCollectionDate')}
                              name="tppaCollectionDate"
                              type="date"
                              value={caseReportTPPASpecimanDate}
                              onChange={(e) => {
                                const date = adjustDateToMax(
                                  e.target.value,
                                  maxDate
                                );
                                setcaseReportTPPASpecimanDate(date)
                                handleFormFieldChange(e);
                              }
                              }
                              max={maxDate} // Set the max attribute to today
                              min={minDate}
                              disabled={!tPPA_Type}
                            />
                            <div className="error m-0">
                              {newCaseReportValidationErrors.tppaCollectionDate}
                            </div>
                          </Col>
                          <Col>
                            <AppLabel label={"Specimen ID"} />
                            <Form.Control
                              name="tppaSpecimenID"
                              type="text"
                              value={caseReportTPPASpecimanID}
                              onChange={(e) => setcaseReportTPPASpecimanID(e.target.value)}
                              disabled={!tPPA_Type}
                              maxLength={25}
                            />
                            <div className="error m-0">
                              {
                                newCaseReportValidationErrors.tppaSpecimenID
                              }
                            </div>
                          </Col>
                          <Col>
                            <AppLabel
                              label={
                                "Details"
                              }
                              required={tPPA_Type !== ""}
                            />
                            <Form.Select
                              {...register('tPPA_Type')}
                              name="tPPA_Result"
                              value={tPPA_Result}
                              onChange={(e) => { setTPPA_Result(e.target.value); handleFormFieldChange(e); }}
                              //disabled={isChecked}
                              disabled={!tPPA_Type}
                            >
                              <option value="">--</option>
                              {caseReportResultData
                                .filter((option) => option.value === 'Reactive' || option.value === 'Non-Reactive')
                                .map((option) => (
                                  <option key={option.id} value={option.id}>
                                    {option.value}
                                  </option>
                                ))}
                            </Form.Select>
                            <div className="error m-0">
                              {newCaseReportValidationErrors.tPPA_Result}
                            </div>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <AppLabel style={{
                            fontWeight: "bold",
                            marginBottom: "10px",
                            marginTop: "10px"
                          }} label={"FTA-ABS Information "} />
                          <Col>
                            <AppLabel label={"Test Type"} />
                            <Form.Select
                              {...register('fTAABS_Type')}
                              value={fTAABS_Type || ""} // Ensure value stores ID
                              onChange={(e) => {
                                const selectedValue = e.target.value;
                                setFTAABS_Type(selectedValue); // Store ID

                                // NEW: Clear rPR_Result if the placeholder is selected (value is "")
                                if (selectedValue === "") {
                                  setcaseReportFTAABSpecimanDate("");
                                  setcaseReportFTAABSpecimanID("");
                                  setFTAABS_Result("");
                                }
                              }
                              }
                            >
                              <option value="">Select Test Type</option> {/* Placeholder */}
                              {caseReportTestData
                                .filter((option) => option.value === 'FTA-ABS')
                                .map((option) => (
                                  <option key={option.id} value={option.id}>
                                    {option.value1}
                                  </option>
                                ))}
                            </Form.Select>
                          </Col>
                          <Col>
                            <AppLabel label={"Specimen Collection Date"}
                              required={fTAABS_Type !== ""}
                            />
                            <Form.Control
                              {...register('ftaabsCollectionDate')}
                              name="ftaabsCollectionDate"
                              type="date"
                              value={caseReportFTAABSSpecimanDate}
                              onChange={(e) => {
                                const date = adjustDateToMax(
                                  e.target.value,
                                  maxDate
                                );
                                setcaseReportFTAABSpecimanDate(date)
                                handleFormFieldChange(e);
                              }}
                              max={maxDate} // Set the max attribute to today
                              min={minDate}
                              disabled={!fTAABS_Type}
                            />
                            <div className="error m-0">
                              {newCaseReportValidationErrors.ftaabsCollectionDate}
                            </div>
                          </Col>
                          <Col>
                            <AppLabel label={"Specimen ID"} />
                            <Form.Control
                              name="ftaabsSpecimenID"
                              type="text"
                              value={caseReportFTAABSSpecimanID}
                              onChange={(e) => setcaseReportFTAABSpecimanID(e.target.value)}
                              disabled={!fTAABS_Type}
                              maxLength={25}
                            />
                            <div className="error m-0">
                              {
                                newCaseReportValidationErrors.ftaabsSpecimenID
                              }
                            </div>
                          </Col>
                          <Col>
                            <AppLabel
                              label={
                                "Details"
                              }
                              required={fTAABS_Type !== ""}
                            />
                            <Form.Select
                              {...register('fTAABS_Result')}
                              name="fTAABS_Result"
                              value={fTAABS_Result}
                              onChange={(e) => { setFTAABS_Result(e.target.value); handleFormFieldChange(e); }}
                              //disabled={isChecked}
                              disabled={!fTAABS_Type}
                            >
                              <option value="">--</option>
                              {caseReportResultData
                                .filter((option) => option.value === 'Reactive' || option.value === 'Non-Reactive')
                                .map((option) => (
                                  <option key={option.id} value={option.id}>
                                    {option.value}
                                  </option>
                                ))}
                            </Form.Select>
                            <div className="error m-0">
                              {newCaseReportValidationErrors.fTAABS_Result}
                            </div>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <AppLabel
                            style={{
                              fontWeight: "bold",
                              marginBottom: "10px",
                              marginTop: "10px"
                            }}
                            label={"EIA Information"}
                          />

                          {/* TEST TYPE */}
                          <Col>
                            <AppLabel label={"Test Type"} />
                            <Form.Select
                              {...register("eIAIgG_Type")}
                              value={eIAIgG_Type || ""}
                              onChange={(e) => {
                                const selectedValue = e.target.value;
                                setEIAIgG_Type(selectedValue);

                                // Clear fields when placeholder is selected
                                if (selectedValue === "") {
                                  setCaseReportEIAIgGSpecimenDate("");
                                  setCaseReportEIAIgGSpecimenID("");
                                  setEIAIgG_Result("");
                                }
                              }}
                            >
                              <option value="">Select Test Type</option>
                              {caseReportTestData
                                .filter((option) => option.value === "EIA")
                                .map((option) => (
                                  <option key={option.id} value={option.id}>
                                    {option.value1}
                                  </option>
                                ))}
                            </Form.Select>
                          </Col>

                          {/* SPECIMEN COLLECTION DATE */}
                          <Col>
                            <AppLabel
                              label={"Specimen Collection Date"}
                              required={eIAIgG_Type !== ""}
                            />
                            <Form.Control
                              {...register("eIAIgGSpecimenCollectionDate")}
                              name="eIAIgGSpecimenCollectionDate"
                              type="date"
                              value={caseReportEIAIgGSpecimenDate}
                              onChange={(e) => {
                                const date = adjustDateToMax(e.target.value, maxDate);
                                setCaseReportEIAIgGSpecimenDate(date);
                                handleFormFieldChange(e);
                              }}
                              max={maxDate}
                              min={minDate}
                              disabled={!eIAIgG_Type}
                            />
                            <div className="error m-0">
                              {newCaseReportValidationErrors.eIAIgGSpecimenCollectionDate}
                            </div>
                          </Col>

                          {/* SPECIMEN ID */}
                          <Col>
                            <AppLabel label={"Specimen ID"} />
                            <Form.Control
                              name="eiaIgGSpecimenId"
                              type="text"
                              value={caseReportEIAIgGSpecimenID}
                              onChange={(e) => setCaseReportEIAIgGSpecimenID(e.target.value)}
                              disabled={!eIAIgG_Type}
                              maxLength={15}
                            />
                            <div className="error m-0">
                              {newCaseReportValidationErrors.eiaIgGSpecimenId}
                            </div>
                          </Col>

                          {/* DETAILS */}
                          <Col>
                            <AppLabel label={"Details"} required={eIAIgG_Type !== ""} />
                            <Form.Select
                              {...register("eIAIgG_Result")}
                              name="eIAIgG_Result"
                              value={eIAIgG_Result}
                              onChange={(e) => {
                                setEIAIgG_Result(e.target.value);
                                handleFormFieldChange(e);
                              }}
                              disabled={!eIAIgG_Type}
                            >
                              <option value="">--</option>
                              {caseReportResultData
                                .filter(
                                  (option) =>
                                    option.value === "Reactive" || option.value === "Non-Reactive"
                                )
                                .map((option) => (
                                  <option key={option.id} value={option.id}>
                                    {option.value}
                                  </option>
                                ))}
                            </Form.Select>
                            <div className="error m-0">
                              {newCaseReportValidationErrors.eIAIgG_Result}
                            </div>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <AppLabel style={{
                            fontWeight: "bold",
                            marginBottom: "10px",
                            marginTop: "10px"
                          }} label={"Chlamydia [200] Test Information "} />
                          <Col>
                            <AppLabel label={"Test Type"} />
                            <Form.Select
                              {...register('chlamydia_Type')}
                              value={chlamydia_Type || ""} // Ensure value stores ID
                              onChange={(e) => {
                                const selectedValue = e.target.value;
                                setChlamydia_Type(selectedValue); // Store ID

                                // NEW: Clear rPR_Result if the placeholder is selected (value is "")
                                if (selectedValue === "") {
                                  setcaseReportChlamydiaSpecimanDate("");
                                  setcaseReportChlamydiaSpecimanID("");
                                  setChlamydia_Result("");
                                }
                              }
                              }
                            >
                              <option value="">Select Test Type</option> {/* Placeholder */}
                              {caseReportTestData
                                .filter((option) => option.value === 'Chlamydia')
                                .map((option) => (
                                  <option key={option.id} value={option.id}>
                                    {option.value1}
                                  </option>
                                ))}
                            </Form.Select>
                          </Col>
                          <Col>
                            <AppLabel label={"Specimen Collection Date"}
                              required={chlamydia_Type !== ""}
                            />
                            <Form.Control
                              {...register('chlamydiaCollectionDate')}
                              name="chlamydiaCollectionDate"
                              type="date"
                              value={caseReportChlamydiaSpecimanDate}
                              onChange={(e) => {
                                const date = adjustDateToMax(
                                  e.target.value,
                                  maxDate
                                );
                                setcaseReportChlamydiaSpecimanDate(date)
                                handleFormFieldChange(e);
                              }}
                              max={maxDate} // Set the max attribute to today
                              min={minDate}
                              disabled={!chlamydia_Type}
                            />
                            <div className="error m-0">
                              {newCaseReportValidationErrors.chlamydiaCollectionDate}
                            </div>
                          </Col>
                          <Col>
                            <AppLabel label={"Specimen ID"} />
                            <Form.Control
                              name="chlamydiaSpecimenID"
                              type="text"
                              value={caseReportChlamydiaSpecimanID}
                              onChange={(e) => setcaseReportChlamydiaSpecimanID(e.target.value)}
                              disabled={!chlamydia_Type}
                              maxLength={25}
                            />
                            <div className="error m-0">
                              {
                                newCaseReportValidationErrors.chlamydiaSpecimenID
                              }
                            </div>
                          </Col>
                          <Col>
                            <AppLabel
                              label={
                                "Details"
                              }
                              required={chlamydia_Type !== ""}
                            />
                            <Form.Select
                              {...register('chlamydia_Result')}
                              id="chlamydia_Result"
                              value={chlamydia_Result}
                              onChange={e => { setChlamydia_Result(e.target.value); handleFormFieldChange(e); }}
                              disabled={!chlamydia_Type}
                            >
                              <option value="">--</option>
                              {caseReportResultData
                                .filter((option) => option.value === 'Positive' || option.value === 'Negative')
                                .map((option) => (
                                  <option key={option.id} value={option.id}>
                                    {option.value}
                                  </option>
                                ))}
                            </Form.Select>
                            <div className="error m-0">
                              {newCaseReportValidationErrors.chlamydia_Result}
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    )}
                    {!isStdInfoCollapsed && (
                      <Row className="mb-3">
                        <AppLabel style={{
                          fontWeight: "bold",
                          marginBottom: "10px",
                          marginTop: "10px"
                        }} label={"Gonorrhea [300] Test Information "} />
                        <Col>
                          <AppLabel label={"Test Type"} />
                          <Form.Select
                            {...register('gonorrhea_Type')}
                            value={gonorrhea_Type || ""} // Ensure value stores ID


                            onChange={(e) => {
                              const selectedValue = e.target.value;
                              setGonorrhea_Type(selectedValue); // Store ID

                              // NEW: Clear rPR_Result if the placeholder is selected (value is "")
                              if (selectedValue === "") {
                                setcaseReportGonorrheaSpecimanDate("");
                                setcaseReportGonorrheaSpecimanID("");
                                setGonorrhea_Result("");
                              }
                            }
                            }
                          >
                            <option value="">Select Test Type</option> {/* Placeholder */}
                            {caseReportTestData
                              .filter((option) => option.value === 'Gonorrhea')
                              .map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.value1}
                                </option>
                              ))}
                          </Form.Select>
                        </Col>
                        <Col>
                          <AppLabel label={"Specimen Collection Date"}
                            required={gonorrhea_Type !== ""}
                          />
                          <Form.Control
                            {...register('gonorrheaCollectionDate')}
                            name="gonorrheaCollectionDate"
                            type="date"
                            value={caseReportGonorrheaSpecimanDate}
                            onChange={(e) => {
                              const date = adjustDateToMax(
                                e.target.value,
                                maxDate
                              );
                              setcaseReportGonorrheaSpecimanDate(date)
                              handleFormFieldChange(e);
                            }}
                            max={maxDate} // Set the max attribute to today
                            min={minDate}
                            disabled={!gonorrhea_Type}
                          />
                          <div className="error m-0">
                            {newCaseReportValidationErrors.gonorrheaCollectionDate}
                          </div>
                        </Col>
                        <Col>
                          <AppLabel label={"Specimen ID"} />
                          <Form.Control
                            name="gonorrheaSpecimenID"
                            type="text"
                            value={caseReportGonorrheaSpecimanID}
                            onChange={(e) => setcaseReportGonorrheaSpecimanID(e.target.value)
                            }
                            disabled={!gonorrhea_Type}
                            maxLength={25}
                          />
                          <div className="error m-0">
                            {
                              newCaseReportValidationErrors.gonorrheaSpecimenID
                            }
                          </div>
                        </Col>
                        <Col>
                          <AppLabel
                            label={
                              "Details"
                            }
                            required={gonorrhea_Type !== ""}
                          />
                          <Form.Select
                            {...register('gonorrhea_Result')}
                            id="gonorrhea_Result"
                            value={gonorrhea_Result}
                            onChange={e => { setGonorrhea_Result(e.target.value); handleFormFieldChange(e); }}
                            disabled={!gonorrhea_Type}
                          >
                            <option value="">--</option>
                            {caseReportResultData
                              .filter((option) => option.value === 'Positive' || option.value === 'Negative')
                              .map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.value}
                                </option>
                              ))}
                          </Form.Select>
                          <div className="error m-0">
                            {newCaseReportValidationErrors.gonorrhea_Result}
                          </div>
                        </Col>
                      </Row>
                    )}
                  </AppCard>
                }
                {caseReportBirthGender?.toLowerCase() == "female" && (
                  <AppCard title={
                    <div className="w-100" id="CaseReportPregnancyInformation">
                      <div
                        className="section-header"
                      >
                        <span className="section-title">
                          Pregnancy Information
                        </span>
                      </div>
                    </div>
                  } bottomMargin>
                    <Card.Body>
                      <Row className="mb-3">
                        <Col>
                          <AppLabel label={"Pregnant"} required />
                          <Form.Select
                            {...register("NewCaseIsPregnant")}
                            value={caseReportPregnant}
                            onChange={handlePregnantChange}
                          // disabled={caseReportPregnantIsDisabled}
                          >
                            <option value=""> -- </option> {/* Placeholder */}
                            {caseReportStatusTypeData.map((option) => (
                              <option key={option.id} value={option.id}>
                                {option.value}
                              </option>
                            ))}
                          </Form.Select>
                          <div className="error m-0">
                            {newCaseReportValidationErrors.NewCaseIsPregnant}
                          </div>
                        </Col>
                        <Col>
                          <AppLabel label={"EDD"} />
                          <Form.Control

                            type="date"
                            value={caseReportEDD}
                            onChange={(e) => {
                              const date = adjustDateToMin(
                                e.target.value,
                                minDate,
                              );
                              setCaseReportEDD(date)
                            }}
                            // disabled={caseReportEDDIsDisabled}
                            max={maxDate} // Set the max attribute to today
                            min={minDate}
                          />
                        </Col>
                        <Col>
                          <AppLabel label={"LMP Date"} required={caseReportPregnant == "1"} />   {/* 1 = Yes */}
                          <Form.Control
                            {...register("NewCaseLMPDate")}
                            name="NewCaseLMPDate"
                            type="date"
                            value={caseReportDateLMP}
                            // onChange={(e) => setCaseReportDateLMP(e.target.value)}
                            onChange={(e) => {
                              const date = adjustDateToMax(
                                e.target.value,
                                maxDate
                              );
                              setCaseReportDateLMP(date)
                              handleFormFieldChange(e)
                            }
                            }
                            max={maxDate} // Set the max attribute to today
                            min={minDate}
                          />
                          <div className="error m-0">
                            {newCaseReportValidationErrors.NewCaseLMPDate}
                          </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </AppCard>
                )}
                <AppCard title={
                  <div className="w-100" id="CaseReportAdditionalNotes">
                    <div className="section-header">
                      <span className="section-title">
                        Additional Notes
                      </span>
                    </div>
                  </div>
                } bottomMargin>
                  <Row className="mb-3">
                    <Col>
                      <AppLabel style={{ fontWeight: "bold" }} label={"Additional Notes"} />
                      <Form.Control
                        as="textarea"
                        value={clientAdditionalNotes}
                        onChange={(e) => setClientAdditionalNotes(e.target.value)}
                        maxLength={1500}
                        rows={3}
                      />
                      <div style={{ fontSize: '0.85rem', color: '#6c757d', textAlign: 'right', marginTop: '4px' }}>
                        Character Count: {clientAdditionalNotes ? clientAdditionalNotes.length : 0} / 1500
                      </div>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col>
                      <AppLabel style={{ fontWeight: "bold" }} label={"DOH Notes/Outcome"} />
                      <Form.Control
                        as="textarea"
                        value={clientDOHNotes}
                        onChange={(e) => setClientDOHNotes(e.target.value)}
                        maxLength={1500}
                        rows={3}
                        disabled={!isAdmin}
                      />
                      <div style={{ fontSize: '0.85rem', color: '#6c757d', textAlign: 'right', marginTop: '4px' }}>
                        Character Count: {clientDOHNotes ? clientDOHNotes.length : 0} / 1500
                      </div>
                    </Col>
                  </Row>
                </AppCard>

                {/* Floating sticky navigation */}
                {showNewCase && searchResults == 0 && (
                  <div>
                    <div className="col-sm-2">
                      <button
                        type="button"
                        className="nav-toggle"
                        onClick={handleNavCaseReportToggle}
                        style={{
                          position: 'fixed',
                          right: `${navCaseReportToggleRightOffset}px`,
                          top: '30%',
                          transform: 'translateY(-50%)',
                          background: '#004e6a',
                          border: '2px solid #0070f3',
                          borderRadius: '4px',
                          fontSize: '16px',
                          cursor: 'pointer',
                          padding: '6px 8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          zIndex: 101,
                          transition: 'all 0.3s ease',
                          color: 'white',
                          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = '#0051a2';
                          e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
                          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.3)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = '#004e6a';
                          e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                          e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.2)';
                        }}
                        title={isNavCaseReportCollapsed ? 'Expand navigation' : 'Collapse navigation'}
                      >
                        {isNavCaseReportCollapsed ? '\u25C0' : '\u25B6'}
                      </button>

                    </div>

                    <div className="col-sm-10">
                      <nav className="sticky-nav">
                        {!isNavCaseReportCollapsed && navCaseReportItems.map((item) => (
                          <a
                            key={item.id}
                            href={`#${item.id}`}
                            className="nav-btn"
                            onClick={(e) => handleNavCaseReportItemClick(e, item.id)}
                          >
                            {item.label}
                          </a>
                        ))}

                      </nav>
                    </div>
                  </div>
                )}
              </form>
              <Row>
                <Col className="text-center">
                  {caseReportErrorMessage && (
                    <p style={{ color: "red" }}>
                      <b>{caseReportErrorMessage}</b>
                    </p>
                  )}
                </Col>
              </Row>
              <Row className="mb-3 me-2 justify-content-end ">
                <div className="container d-flex justify-content-end align-items-center flex-wrap flex-column flex-lg-row">
                  <Col className="text-center">
                    {clientInfoErrorMessage && (
                      <p style={{ color: "red" }}>
                        <b>{clientInfoErrorMessage}</b>
                      </p>
                    )}
                  </Col>
                  <Col className="text-end">
                    <AppButton
                      type="button"
                      variant="secondary"
                      onClick={handleCaseReportClear}
                    >
                      Cancel
                    </AppButton>
                    &nbsp;&nbsp;&nbsp;
                    <AppButton
                      type="button"
                      variant="primary"
                      onClick={handleCaseReportSave}
                      disabled={isCaseReportSubmitting}
                    >
                      Save
                    </AppButton>
                  </Col>
                </div>
              </Row>
            </>
            {/* </form> */}
          </div>
          };
        </Container>
      ) : (
        ""
      )}
    </>
  );
};

export default Dashboard;
